!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("mobx"), require("ramda"), require("uuid"), require("@miriamtech/if2-core"), require("js-quantities"), require("moment"), require("sanitize-filename")) : "function" == typeof define && define.amd ? define(["mobx", "ramda", "uuid", "@miriamtech/if2-core", "js-quantities", "moment", "sanitize-filename"], e) : "object" == typeof exports ? exports.jsModel = e(require("mobx"), require("ramda"), require("uuid"), require("@miriamtech/if2-core"), require("js-quantities"), require("moment"), require("sanitize-filename")) : t.jsModel = e(t.mobx, t.ramda, t.uuid, t["@miriamtech/if2-core"], t["js-quantities"], t.moment, t["sanitize-filename"]);
}("undefined" != typeof self ? self : this, (t, e, r, n, o, i, c) => (() => {
  var a = {
    3286: (t, e, r) => {
      var n = {
        "./account-reference.json": 2375,
        "./account-reference/v0.json": 3482,
        "./account-reference/v1.json": 6306,
        "./crop-label.json": 5897,
        "./crop-label/v0.json": 3768,
        "./crop-label/v1.json": 1355,
        "./field.json": 824,
        "./field/geo-json.json": 5067,
        "./field/v0.json": 8115,
        "./field/v1.json": 7776,
        "./license.json": 9991,
        "./license/v0.json": 2490,
        "./license/v1.json": 2197,
        "./mode-of-action.json": 6228,
        "./mode-of-action/v0.json": 1607,
        "./mode-of-action/v1.json": 2564,
        "./organic-listing.json": 6915,
        "./organic-listing/v0.json": 3803,
        "./organic-listing/v1.json": 6056,
        "./product.json": 8731,
        "./product/active-ingredient.json": 6782,
        "./product/active-ingredient/v0.json": 5597,
        "./product/active-ingredient/v1.json": 8866,
        "./product/attachment.json": 6845,
        "./product/attachment/v0.json": 372,
        "./product/attachment/v1.json": 9095,
        "./product/nutrient-analysis.json": 6828,
        "./product/v0.json": 7366,
        "./product/v1.json": 4721,
        "./recommendation.json": 479,
        "./recommendation/accounts.json": 1412,
        "./recommendation/approved.json": 4687,
        "./recommendation/fields.json": 7489,
        "./recommendation/product-application.json": 3852,
        "./recommendation/product-application/v0.json": 2847,
        "./recommendation/product-application/v1.json": 9308,
        "./recommendation/rejected.json": 9286,
        "./recommendation/replaces.json": 9589,
        "./recommendation/status.json": 5142,
        "./recommendation/v0.json": 5538,
        "./recommendation/v1.json": 5245,
        "./recommendation/written-by.json": 2511
      };

      function o(t) {
        var e = i(t);
        return r(e);
      }

      function i(t) {
        if (!r.o(n, t)) {
          var e = new Error("Cannot find module '" + t + "'");
          throw e.code = "MODULE_NOT_FOUND", e;
        }

        return n[t];
      }

      o.keys = function () {
        return Object.keys(n);
      }, o.resolve = i, t.exports = o, o.id = 3286;
    },
    9683: t => {
      "use strict";

      t.exports = n;
    },
    5211: t => {
      "use strict";

      t.exports = o;
    },
    5314: e => {
      "use strict";

      e.exports = t;
    },
    5416: t => {
      "use strict";

      t.exports = i;
    },
    4871: t => {
      "use strict";

      t.exports = e;
    },
    619: t => {
      "use strict";

      t.exports = c;
    },
    7315: t => {
      "use strict";

      t.exports = r;
    },
    9306: (t, e, r) => {
      "use strict";

      var n = r(4901),
          o = r(6823),
          i = TypeError;

      t.exports = function (t) {
        if (n(t)) return t;
        throw new i(o(t) + " is not a function");
      };
    },
    5548: (t, e, r) => {
      "use strict";

      var n = r(3517),
          o = r(6823),
          i = TypeError;

      t.exports = function (t) {
        if (n(t)) return t;
        throw new i(o(t) + " is not a constructor");
      };
    },
    3506: (t, e, r) => {
      "use strict";

      var n = r(3925),
          o = String,
          i = TypeError;

      t.exports = function (t) {
        if (n(t)) return t;
        throw new i("Can't set " + o(t) + " as a prototype");
      };
    },
    6469: (t, e, r) => {
      "use strict";

      var n = r(8227),
          o = r(2360),
          i = r(4913).f,
          c = n("unscopables"),
          a = Array.prototype;
      void 0 === a[c] && i(a, c, {
        configurable: !0,
        value: o(null)
      }), t.exports = function (t) {
        a[c][t] = !0;
      };
    },
    7829: (t, e, r) => {
      "use strict";

      var n = r(8183).charAt;

      t.exports = function (t, e, r) {
        return e + (r ? n(t, e).length : 1);
      };
    },
    679: (t, e, r) => {
      "use strict";

      var n = r(1625),
          o = TypeError;

      t.exports = function (t, e) {
        if (n(e, t)) return t;
        throw new o("Incorrect invocation");
      };
    },
    8551: (t, e, r) => {
      "use strict";

      var n = r(34),
          o = String,
          i = TypeError;

      t.exports = function (t) {
        if (n(t)) return t;
        throw new i(o(t) + " is not an object");
      };
    },
    5652: (t, e, r) => {
      "use strict";

      var n = r(9039);
      t.exports = n(function () {
        if ("function" == typeof ArrayBuffer) {
          var t = new ArrayBuffer(8);
          Object.isExtensible(t) && Object.defineProperty(t, "a", {
            value: 8
          });
        }
      });
    },
    235: (t, e, r) => {
      "use strict";

      var n = r(9213).forEach,
          o = r(4598)("forEach");
      t.exports = o ? [].forEach : function (t) {
        return n(this, t, arguments.length > 1 ? arguments[1] : void 0);
      };
    },
    7916: (t, e, r) => {
      "use strict";

      var n = r(6080),
          o = r(9565),
          i = r(8981),
          c = r(6319),
          a = r(4209),
          u = r(3517),
          s = r(6198),
          p = r(4659),
          l = r(81),
          f = r(851),
          y = Array;

      t.exports = function (t) {
        var e = i(t),
            r = u(this),
            d = arguments.length,
            h = d > 1 ? arguments[1] : void 0,
            m = void 0 !== h;
        m && (h = n(h, d > 2 ? arguments[2] : void 0));
        var g,
            v,
            b,
            O,
            P,
            j,
            w = f(e),
            k = 0;
        if (!w || this === y && a(w)) for (g = s(e), v = r ? new this(g) : y(g); g > k; k++) j = m ? h(e[k], k) : e[k], p(v, k, j);else for (v = r ? new this() : [], P = (O = l(e, w)).next; !(b = o(P, O)).done; k++) j = m ? c(O, h, [b.value, k], !0) : b.value, p(v, k, j);
        return v.length = k, v;
      };
    },
    9617: (t, e, r) => {
      "use strict";

      var n = r(5397),
          o = r(5610),
          i = r(6198),
          c = function (t) {
        return function (e, r, c) {
          var a = n(e),
              u = i(a);
          if (0 === u) return !t && -1;
          var s,
              p = o(c, u);

          if (t && r != r) {
            for (; u > p;) if ((s = a[p++]) != s) return !0;
          } else for (; u > p; p++) if ((t || p in a) && a[p] === r) return t || p || 0;

          return !t && -1;
        };
      };

      t.exports = {
        includes: c(!0),
        indexOf: c(!1)
      };
    },
    9213: (t, e, r) => {
      "use strict";

      var n = r(6080),
          o = r(9504),
          i = r(7055),
          c = r(8981),
          a = r(6198),
          u = r(1469),
          s = o([].push),
          p = function (t) {
        var e = 1 === t,
            r = 2 === t,
            o = 3 === t,
            p = 4 === t,
            l = 6 === t,
            f = 7 === t,
            y = 5 === t || l;
        return function (d, h, m, g) {
          for (var v, b, O = c(d), P = i(O), j = a(P), w = n(h, m), k = 0, R = g || u, A = e ? R(d, j) : r || f ? R(d, 0) : void 0; j > k; k++) if ((y || k in P) && (b = w(v = P[k], k, O), t)) if (e) A[k] = b;else if (b) switch (t) {
            case 3:
              return !0;

            case 5:
              return v;

            case 6:
              return k;

            case 2:
              s(A, v);
          } else switch (t) {
            case 4:
              return !1;

            case 7:
              s(A, v);
          }

          return l ? -1 : o || p ? p : A;
        };
      };

      t.exports = {
        forEach: p(0),
        map: p(1),
        filter: p(2),
        some: p(3),
        every: p(4),
        find: p(5),
        findIndex: p(6),
        filterReject: p(7)
      };
    },
    597: (t, e, r) => {
      "use strict";

      var n = r(9039),
          o = r(8227),
          i = r(9519),
          c = o("species");

      t.exports = function (t) {
        return i >= 51 || !n(function () {
          var e = [];
          return (e.constructor = {})[c] = function () {
            return {
              foo: 1
            };
          }, 1 !== e[t](Boolean).foo;
        });
      };
    },
    4598: (t, e, r) => {
      "use strict";

      var n = r(9039);

      t.exports = function (t, e) {
        var r = [][t];
        return !!r && n(function () {
          r.call(null, e || function () {
            return 1;
          }, 1);
        });
      };
    },
    926: (t, e, r) => {
      "use strict";

      var n = r(9306),
          o = r(8981),
          i = r(7055),
          c = r(6198),
          a = TypeError,
          u = "Reduce of empty array with no initial value",
          s = function (t) {
        return function (e, r, s, p) {
          var l = o(e),
              f = i(l),
              y = c(l);
          if (n(r), 0 === y && s < 2) throw new a(u);
          var d = t ? y - 1 : 0,
              h = t ? -1 : 1;
          if (s < 2) for (;;) {
            if (d in f) {
              p = f[d], d += h;
              break;
            }

            if (d += h, t ? d < 0 : y <= d) throw new a(u);
          }

          for (; t ? d >= 0 : y > d; d += h) d in f && (p = r(p, f[d], d, l));

          return p;
        };
      };

      t.exports = {
        left: s(!1),
        right: s(!0)
      };
    },
    4527: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(4376),
          i = TypeError,
          c = Object.getOwnPropertyDescriptor,
          a = n && !function () {
        if (void 0 !== this) return !0;

        try {
          Object.defineProperty([], "length", {
            writable: !1
          }).length = 1;
        } catch (t) {
          return t instanceof TypeError;
        }
      }();
      t.exports = a ? function (t, e) {
        if (o(t) && !c(t, "length").writable) throw new i("Cannot set read only .length");
        return t.length = e;
      } : function (t, e) {
        return t.length = e;
      };
    },
    7680: (t, e, r) => {
      "use strict";

      var n = r(9504);
      t.exports = n([].slice);
    },
    4488: (t, e, r) => {
      "use strict";

      var n = r(7680),
          o = Math.floor,
          i = function (t, e) {
        var r = t.length;
        if (r < 8) for (var c, a, u = 1; u < r;) {
          for (a = u, c = t[u]; a && e(t[a - 1], c) > 0;) t[a] = t[--a];

          a !== u++ && (t[a] = c);
        } else for (var s = o(r / 2), p = i(n(t, 0, s), e), l = i(n(t, s), e), f = p.length, y = l.length, d = 0, h = 0; d < f || h < y;) t[d + h] = d < f && h < y ? e(p[d], l[h]) <= 0 ? p[d++] : l[h++] : d < f ? p[d++] : l[h++];
        return t;
      };

      t.exports = i;
    },
    7433: (t, e, r) => {
      "use strict";

      var n = r(4376),
          o = r(3517),
          i = r(34),
          c = r(8227)("species"),
          a = Array;

      t.exports = function (t) {
        var e;
        return n(t) && (e = t.constructor, (o(e) && (e === a || n(e.prototype)) || i(e) && null === (e = e[c])) && (e = void 0)), void 0 === e ? a : e;
      };
    },
    1469: (t, e, r) => {
      "use strict";

      var n = r(7433);

      t.exports = function (t, e) {
        return new (n(t))(0 === e ? 0 : e);
      };
    },
    6319: (t, e, r) => {
      "use strict";

      var n = r(8551),
          o = r(9539);

      t.exports = function (t, e, r, i) {
        try {
          return i ? e(n(r)[0], r[1]) : e(r);
        } catch (e) {
          o(t, "throw", e);
        }
      };
    },
    4428: (t, e, r) => {
      "use strict";

      var n = r(8227)("iterator"),
          o = !1;

      try {
        var i = 0,
            c = {
          next: function () {
            return {
              done: !!i++
            };
          },
          return: function () {
            o = !0;
          }
        };
        c[n] = function () {
          return this;
        }, Array.from(c, function () {
          throw 2;
        });
      } catch (t) {}

      t.exports = function (t, e) {
        try {
          if (!e && !o) return !1;
        } catch (t) {
          return !1;
        }

        var r = !1;

        try {
          var i = {};
          i[n] = function () {
            return {
              next: function () {
                return {
                  done: r = !0
                };
              }
            };
          }, t(i);
        } catch (t) {}

        return r;
      };
    },
    2195: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = n({}.toString),
          i = n("".slice);

      t.exports = function (t) {
        return i(o(t), 8, -1);
      };
    },
    6955: (t, e, r) => {
      "use strict";

      var n = r(2140),
          o = r(4901),
          i = r(2195),
          c = r(8227)("toStringTag"),
          a = Object,
          u = "Arguments" === i(function () {
        return arguments;
      }());
      t.exports = n ? i : function (t) {
        var e, r, n;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function (t, e) {
          try {
            return t[e];
          } catch (t) {}
        }(e = a(t), c)) ? r : u ? i(e) : "Object" === (n = i(e)) && o(e.callee) ? "Arguments" : n;
      };
    },
    6938: (t, e, r) => {
      "use strict";

      var n = r(2360),
          o = r(2106),
          i = r(6279),
          c = r(6080),
          a = r(679),
          u = r(4117),
          s = r(2652),
          p = r(1088),
          l = r(2529),
          f = r(7633),
          y = r(3724),
          d = r(3451).fastKey,
          h = r(1181),
          m = h.set,
          g = h.getterFor;
      t.exports = {
        getConstructor: function (t, e, r, p) {
          var l = t(function (t, o) {
            a(t, f), m(t, {
              type: e,
              index: n(null),
              first: null,
              last: null,
              size: 0
            }), y || (t.size = 0), u(o) || s(o, t[p], {
              that: t,
              AS_ENTRIES: r
            });
          }),
              f = l.prototype,
              h = g(e),
              v = function (t, e, r) {
            var n,
                o,
                i = h(t),
                c = b(t, e);
            return c ? c.value = r : (i.last = c = {
              index: o = d(e, !0),
              key: e,
              value: r,
              previous: n = i.last,
              next: null,
              removed: !1
            }, i.first || (i.first = c), n && (n.next = c), y ? i.size++ : t.size++, "F" !== o && (i.index[o] = c)), t;
          },
              b = function (t, e) {
            var r,
                n = h(t),
                o = d(e);
            if ("F" !== o) return n.index[o];

            for (r = n.first; r; r = r.next) if (r.key === e) return r;
          };

          return i(f, {
            clear: function () {
              for (var t = h(this), e = t.first; e;) e.removed = !0, e.previous && (e.previous = e.previous.next = null), e = e.next;

              t.first = t.last = null, t.index = n(null), y ? t.size = 0 : this.size = 0;
            },
            delete: function (t) {
              var e = this,
                  r = h(e),
                  n = b(e, t);

              if (n) {
                var o = n.next,
                    i = n.previous;
                delete r.index[n.index], n.removed = !0, i && (i.next = o), o && (o.previous = i), r.first === n && (r.first = o), r.last === n && (r.last = i), y ? r.size-- : e.size--;
              }

              return !!n;
            },
            forEach: function (t) {
              for (var e, r = h(this), n = c(t, arguments.length > 1 ? arguments[1] : void 0); e = e ? e.next : r.first;) for (n(e.value, e.key, this); e && e.removed;) e = e.previous;
            },
            has: function (t) {
              return !!b(this, t);
            }
          }), i(f, r ? {
            get: function (t) {
              var e = b(this, t);
              return e && e.value;
            },
            set: function (t, e) {
              return v(this, 0 === t ? 0 : t, e);
            }
          } : {
            add: function (t) {
              return v(this, t = 0 === t ? 0 : t, t);
            }
          }), y && o(f, "size", {
            configurable: !0,
            get: function () {
              return h(this).size;
            }
          }), l;
        },
        setStrong: function (t, e, r) {
          var n = e + " Iterator",
              o = g(e),
              i = g(n);
          p(t, e, function (t, e) {
            m(this, {
              type: n,
              target: t,
              state: o(t),
              kind: e,
              last: null
            });
          }, function () {
            for (var t = i(this), e = t.kind, r = t.last; r && r.removed;) r = r.previous;

            return t.target && (t.last = r = r ? r.next : t.state.first) ? l("keys" === e ? r.key : "values" === e ? r.value : [r.key, r.value], !1) : (t.target = null, l(void 0, !0));
          }, r ? "entries" : "values", !r, !0), f(e);
        }
      };
    },
    6468: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(4576),
          i = r(9504),
          c = r(2796),
          a = r(6840),
          u = r(3451),
          s = r(2652),
          p = r(679),
          l = r(4901),
          f = r(4117),
          y = r(34),
          d = r(9039),
          h = r(4428),
          m = r(687),
          g = r(3167);

      t.exports = function (t, e, r) {
        var v = -1 !== t.indexOf("Map"),
            b = -1 !== t.indexOf("Weak"),
            O = v ? "set" : "add",
            P = o[t],
            j = P && P.prototype,
            w = P,
            k = {},
            R = function (t) {
          var e = i(j[t]);
          a(j, t, "add" === t ? function (t) {
            return e(this, 0 === t ? 0 : t), this;
          } : "delete" === t ? function (t) {
            return !(b && !y(t)) && e(this, 0 === t ? 0 : t);
          } : "get" === t ? function (t) {
            return b && !y(t) ? void 0 : e(this, 0 === t ? 0 : t);
          } : "has" === t ? function (t) {
            return !(b && !y(t)) && e(this, 0 === t ? 0 : t);
          } : function (t, r) {
            return e(this, 0 === t ? 0 : t, r), this;
          });
        };

        if (c(t, !l(P) || !(b || j.forEach && !d(function () {
          new P().entries().next();
        })))) w = r.getConstructor(e, t, v, O), u.enable();else if (c(t, !0)) {
          var A = new w(),
              D = A[O](b ? {} : -0, 1) !== A,
              _ = d(function () {
            A.has(1);
          }),
              x = h(function (t) {
            new P(t);
          }),
              S = !b && d(function () {
            for (var t = new P(), e = 5; e--;) t[O](e, e);

            return !t.has(-0);
          });

          x || ((w = e(function (t, e) {
            p(t, j);
            var r = g(new P(), t, w);
            return f(e) || s(e, r[O], {
              that: r,
              AS_ENTRIES: v
            }), r;
          })).prototype = j, j.constructor = w), (_ || S) && (R("delete"), R("has"), v && R("get")), (S || D) && R(O), b && j.clear && delete j.clear;
        }
        return k[t] = w, n({
          global: !0,
          constructor: !0,
          forced: w !== P
        }, k), m(w, t), b || r.setStrong(w, t, v), w;
      };
    },
    7740: (t, e, r) => {
      "use strict";

      var n = r(9297),
          o = r(5031),
          i = r(7347),
          c = r(4913);

      t.exports = function (t, e, r) {
        for (var a = o(e), u = c.f, s = i.f, p = 0; p < a.length; p++) {
          var l = a[p];
          n(t, l) || r && n(r, l) || u(t, l, s(e, l));
        }
      };
    },
    1436: (t, e, r) => {
      "use strict";

      var n = r(8227)("match");

      t.exports = function (t) {
        var e = /./;

        try {
          "/./"[t](e);
        } catch (r) {
          try {
            return e[n] = !1, "/./"[t](e);
          } catch (t) {}
        }

        return !1;
      };
    },
    2211: (t, e, r) => {
      "use strict";

      var n = r(9039);
      t.exports = !n(function () {
        function t() {}

        return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
      });
    },
    7240: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(7750),
          i = r(655),
          c = /"/g,
          a = n("".replace);

      t.exports = function (t, e, r, n) {
        var u = i(o(t)),
            s = "<" + e;
        return "" !== r && (s += " " + r + '="' + a(i(n), c, "&quot;") + '"'), s + ">" + u + "</" + e + ">";
      };
    },
    2529: t => {
      "use strict";

      t.exports = function (t, e) {
        return {
          value: t,
          done: e
        };
      };
    },
    6699: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(4913),
          i = r(6980);
      t.exports = n ? function (t, e, r) {
        return o.f(t, e, i(1, r));
      } : function (t, e, r) {
        return t[e] = r, t;
      };
    },
    6980: t => {
      "use strict";

      t.exports = function (t, e) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: e
        };
      };
    },
    4659: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(4913),
          i = r(6980);

      t.exports = function (t, e, r) {
        n ? o.f(t, e, i(0, r)) : t[e] = r;
      };
    },
    380: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(9039),
          i = r(533).start,
          c = RangeError,
          a = isFinite,
          u = Math.abs,
          s = Date.prototype,
          p = s.toISOString,
          l = n(s.getTime),
          f = n(s.getUTCDate),
          y = n(s.getUTCFullYear),
          d = n(s.getUTCHours),
          h = n(s.getUTCMilliseconds),
          m = n(s.getUTCMinutes),
          g = n(s.getUTCMonth),
          v = n(s.getUTCSeconds);
      t.exports = o(function () {
        return "0385-07-25T07:06:39.999Z" !== p.call(new Date(-50000000000001));
      }) || !o(function () {
        p.call(new Date(NaN));
      }) ? function () {
        if (!a(l(this))) throw new c("Invalid time value");
        var t = this,
            e = y(t),
            r = h(t),
            n = e < 0 ? "-" : e > 9999 ? "+" : "";
        return n + i(u(e), n ? 6 : 4, 0) + "-" + i(g(t) + 1, 2, 0) + "-" + i(f(t), 2, 0) + "T" + i(d(t), 2, 0) + ":" + i(m(t), 2, 0) + ":" + i(v(t), 2, 0) + "." + i(r, 3, 0) + "Z";
      } : p;
    },
    2106: (t, e, r) => {
      "use strict";

      var n = r(283),
          o = r(4913);

      t.exports = function (t, e, r) {
        return r.get && n(r.get, e, {
          getter: !0
        }), r.set && n(r.set, e, {
          setter: !0
        }), o.f(t, e, r);
      };
    },
    6840: (t, e, r) => {
      "use strict";

      var n = r(4901),
          o = r(4913),
          i = r(283),
          c = r(9433);

      t.exports = function (t, e, r, a) {
        a || (a = {});
        var u = a.enumerable,
            s = void 0 !== a.name ? a.name : e;
        if (n(r) && i(r, s, a), a.global) u ? t[e] = r : c(e, r);else {
          try {
            a.unsafe ? t[e] && (u = !0) : delete t[e];
          } catch (t) {}

          u ? t[e] = r : o.f(t, e, {
            value: r,
            enumerable: !1,
            configurable: !a.nonConfigurable,
            writable: !a.nonWritable
          });
        }
        return t;
      };
    },
    6279: (t, e, r) => {
      "use strict";

      var n = r(6840);

      t.exports = function (t, e, r) {
        for (var o in e) n(t, o, e[o], r);

        return t;
      };
    },
    9433: (t, e, r) => {
      "use strict";

      var n = r(4576),
          o = Object.defineProperty;

      t.exports = function (t, e) {
        try {
          o(n, t, {
            value: e,
            configurable: !0,
            writable: !0
          });
        } catch (r) {
          n[t] = e;
        }

        return e;
      };
    },
    4606: (t, e, r) => {
      "use strict";

      var n = r(6823),
          o = TypeError;

      t.exports = function (t, e) {
        if (!delete t[e]) throw new o("Cannot delete property " + n(e) + " of " + n(t));
      };
    },
    3724: (t, e, r) => {
      "use strict";

      var n = r(9039);
      t.exports = !n(function () {
        return 7 !== Object.defineProperty({}, 1, {
          get: function () {
            return 7;
          }
        })[1];
      });
    },
    4055: (t, e, r) => {
      "use strict";

      var n = r(4576),
          o = r(34),
          i = n.document,
          c = o(i) && o(i.createElement);

      t.exports = function (t) {
        return c ? i.createElement(t) : {};
      };
    },
    6837: t => {
      "use strict";

      var e = TypeError;

      t.exports = function (t) {
        if (t > 9007199254740991) throw e("Maximum allowed index exceeded");
        return t;
      };
    },
    7400: t => {
      "use strict";

      t.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
      };
    },
    9296: (t, e, r) => {
      "use strict";

      var n = r(4055)("span").classList,
          o = n && n.constructor && n.constructor.prototype;
      t.exports = o === Object.prototype ? void 0 : o;
    },
    8727: t => {
      "use strict";

      t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    },
    3709: (t, e, r) => {
      "use strict";

      var n = r(2839).match(/firefox\/(\d+)/i);
      t.exports = !!n && +n[1];
    },
    3763: (t, e, r) => {
      "use strict";

      var n = r(2839);
      t.exports = /MSIE|Trident/.test(n);
    },
    6193: (t, e, r) => {
      "use strict";

      var n = r(4215);
      t.exports = "NODE" === n;
    },
    2839: (t, e, r) => {
      "use strict";

      var n = r(4576).navigator,
          o = n && n.userAgent;
      t.exports = o ? String(o) : "";
    },
    9519: (t, e, r) => {
      "use strict";

      var n,
          o,
          i = r(4576),
          c = r(2839),
          a = i.process,
          u = i.Deno,
          s = a && a.versions || u && u.version,
          p = s && s.v8;
      p && (o = (n = p.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !o && c && (!(n = c.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = c.match(/Chrome\/(\d+)/)) && (o = +n[1]), t.exports = o;
    },
    3607: (t, e, r) => {
      "use strict";

      var n = r(2839).match(/AppleWebKit\/(\d+)\./);
      t.exports = !!n && +n[1];
    },
    4215: (t, e, r) => {
      "use strict";

      var n = r(4576),
          o = r(2839),
          i = r(2195),
          c = function (t) {
        return o.slice(0, t.length) === t;
      };

      t.exports = c("Bun/") ? "BUN" : c("Cloudflare-Workers") ? "CLOUDFLARE" : c("Deno/") ? "DENO" : c("Node.js/") ? "NODE" : n.Bun && "string" == typeof Bun.version ? "BUN" : n.Deno && "object" == typeof Deno.version ? "DENO" : "process" === i(n.process) ? "NODE" : n.window && n.document ? "BROWSER" : "REST";
    },
    6518: (t, e, r) => {
      "use strict";

      var n = r(4576),
          o = r(7347).f,
          i = r(6699),
          c = r(6840),
          a = r(9433),
          u = r(7740),
          s = r(2796);

      t.exports = function (t, e) {
        var r,
            p,
            l,
            f,
            y,
            d = t.target,
            h = t.global,
            m = t.stat;
        if (r = h ? n : m ? n[d] || a(d, {}) : n[d] && n[d].prototype) for (p in e) {
          if (f = e[p], l = t.dontCallGetSet ? (y = o(r, p)) && y.value : r[p], !s(h ? p : d + (m ? "." : "#") + p, t.forced) && void 0 !== l) {
            if (typeof f == typeof l) continue;
            u(f, l);
          }

          (t.sham || l && l.sham) && i(f, "sham", !0), c(r, p, f, t);
        }
      };
    },
    9039: t => {
      "use strict";

      t.exports = function (t) {
        try {
          return !!t();
        } catch (t) {
          return !0;
        }
      };
    },
    9228: (t, e, r) => {
      "use strict";

      r(7495);
      var n = r(9565),
          o = r(6840),
          i = r(7323),
          c = r(9039),
          a = r(8227),
          u = r(6699),
          s = a("species"),
          p = RegExp.prototype;

      t.exports = function (t, e, r, l) {
        var f = a(t),
            y = !c(function () {
          var e = {};
          return e[f] = function () {
            return 7;
          }, 7 !== ""[t](e);
        }),
            d = y && !c(function () {
          var e = !1,
              r = /a/;
          return "split" === t && ((r = {}).constructor = {}, r.constructor[s] = function () {
            return r;
          }, r.flags = "", r[f] = /./[f]), r.exec = function () {
            return e = !0, null;
          }, r[f](""), !e;
        });

        if (!y || !d || r) {
          var h = /./[f],
              m = e(f, ""[t], function (t, e, r, o, c) {
            var a = e.exec;
            return a === i || a === p.exec ? y && !c ? {
              done: !0,
              value: n(h, e, r, o)
            } : {
              done: !0,
              value: n(t, r, e, o)
            } : {
              done: !1
            };
          });
          o(String.prototype, t, m[0]), o(p, f, m[1]);
        }

        l && u(p[f], "sham", !0);
      };
    },
    259: (t, e, r) => {
      "use strict";

      var n = r(4376),
          o = r(6198),
          i = r(6837),
          c = r(6080),
          a = function (t, e, r, u, s, p, l, f) {
        for (var y, d, h = s, m = 0, g = !!l && c(l, f); m < u;) m in r && (y = g ? g(r[m], m, e) : r[m], p > 0 && n(y) ? (d = o(y), h = a(t, e, y, d, h, p - 1) - 1) : (i(h + 1), t[h] = y), h++), m++;

        return h;
      };

      t.exports = a;
    },
    2744: (t, e, r) => {
      "use strict";

      var n = r(9039);
      t.exports = !n(function () {
        return Object.isExtensible(Object.preventExtensions({}));
      });
    },
    8745: (t, e, r) => {
      "use strict";

      var n = r(616),
          o = Function.prototype,
          i = o.apply,
          c = o.call;
      t.exports = "object" == typeof Reflect && Reflect.apply || (n ? c.bind(i) : function () {
        return c.apply(i, arguments);
      });
    },
    6080: (t, e, r) => {
      "use strict";

      var n = r(7476),
          o = r(9306),
          i = r(616),
          c = n(n.bind);

      t.exports = function (t, e) {
        return o(t), void 0 === e ? t : i ? c(t, e) : function () {
          return t.apply(e, arguments);
        };
      };
    },
    616: (t, e, r) => {
      "use strict";

      var n = r(9039);
      t.exports = !n(function () {
        var t = function () {}.bind();

        return "function" != typeof t || t.hasOwnProperty("prototype");
      });
    },
    566: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(9306),
          i = r(34),
          c = r(9297),
          a = r(7680),
          u = r(616),
          s = Function,
          p = n([].concat),
          l = n([].join),
          f = {};
      t.exports = u ? s.bind : function (t) {
        var e = o(this),
            r = e.prototype,
            n = a(arguments, 1),
            u = function () {
          var r = p(n, a(arguments));
          return this instanceof u ? function (t, e, r) {
            if (!c(f, e)) {
              for (var n = [], o = 0; o < e; o++) n[o] = "a[" + o + "]";

              f[e] = s("C,a", "return new C(" + l(n, ",") + ")");
            }

            return f[e](t, r);
          }(e, r.length, r) : e.apply(t, r);
        };

        return i(r) && (u.prototype = r), u;
      };
    },
    9565: (t, e, r) => {
      "use strict";

      var n = r(616),
          o = Function.prototype.call;
      t.exports = n ? o.bind(o) : function () {
        return o.apply(o, arguments);
      };
    },
    350: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(9297),
          i = Function.prototype,
          c = n && Object.getOwnPropertyDescriptor,
          a = o(i, "name"),
          u = a && "something" === function () {}.name,
          s = a && (!n || n && c(i, "name").configurable);

      t.exports = {
        EXISTS: a,
        PROPER: u,
        CONFIGURABLE: s
      };
    },
    6706: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(9306);

      t.exports = function (t, e, r) {
        try {
          return n(o(Object.getOwnPropertyDescriptor(t, e)[r]));
        } catch (t) {}
      };
    },
    7476: (t, e, r) => {
      "use strict";

      var n = r(2195),
          o = r(9504);

      t.exports = function (t) {
        if ("Function" === n(t)) return o(t);
      };
    },
    9504: (t, e, r) => {
      "use strict";

      var n = r(616),
          o = Function.prototype,
          i = o.call,
          c = n && o.bind.bind(i, i);
      t.exports = n ? c : function (t) {
        return function () {
          return i.apply(t, arguments);
        };
      };
    },
    7751: (t, e, r) => {
      "use strict";

      var n = r(4576),
          o = r(4901);

      t.exports = function (t, e) {
        return arguments.length < 2 ? (r = n[t], o(r) ? r : void 0) : n[t] && n[t][e];
        var r;
      };
    },
    851: (t, e, r) => {
      "use strict";

      var n = r(6955),
          o = r(5966),
          i = r(4117),
          c = r(6269),
          a = r(8227)("iterator");

      t.exports = function (t) {
        if (!i(t)) return o(t, a) || o(t, "@@iterator") || c[n(t)];
      };
    },
    81: (t, e, r) => {
      "use strict";

      var n = r(9565),
          o = r(9306),
          i = r(8551),
          c = r(6823),
          a = r(851),
          u = TypeError;

      t.exports = function (t, e) {
        var r = arguments.length < 2 ? a(t) : e;
        if (o(r)) return i(n(r, t));
        throw new u(c(t) + " is not iterable");
      };
    },
    6933: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(4376),
          i = r(4901),
          c = r(2195),
          a = r(655),
          u = n([].push);

      t.exports = function (t) {
        if (i(t)) return t;

        if (o(t)) {
          for (var e = t.length, r = [], n = 0; n < e; n++) {
            var s = t[n];
            "string" == typeof s ? u(r, s) : "number" != typeof s && "Number" !== c(s) && "String" !== c(s) || u(r, a(s));
          }

          var p = r.length,
              l = !0;
          return function (t, e) {
            if (l) return l = !1, e;
            if (o(this)) return e;

            for (var n = 0; n < p; n++) if (r[n] === t) return e;
          };
        }
      };
    },
    5966: (t, e, r) => {
      "use strict";

      var n = r(9306),
          o = r(4117);

      t.exports = function (t, e) {
        var r = t[e];
        return o(r) ? void 0 : n(r);
      };
    },
    2478: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(8981),
          i = Math.floor,
          c = n("".charAt),
          a = n("".replace),
          u = n("".slice),
          s = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
          p = /\$([$&'`]|\d{1,2})/g;

      t.exports = function (t, e, r, n, l, f) {
        var y = r + t.length,
            d = n.length,
            h = p;
        return void 0 !== l && (l = o(l), h = s), a(f, h, function (o, a) {
          var s;

          switch (c(a, 0)) {
            case "$":
              return "$";

            case "&":
              return t;

            case "`":
              return u(e, 0, r);

            case "'":
              return u(e, y);

            case "<":
              s = l[u(a, 1, -1)];
              break;

            default:
              var p = +a;
              if (0 === p) return o;

              if (p > d) {
                var f = i(p / 10);
                return 0 === f ? o : f <= d ? void 0 === n[f - 1] ? c(a, 1) : n[f - 1] + c(a, 1) : o;
              }

              s = n[p - 1];
          }

          return void 0 === s ? "" : s;
        });
      };
    },
    4576: function (t, e, r) {
      "use strict";

      var n = function (t) {
        return t && t.Math === Math && t;
      };

      t.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof r.g && r.g) || n("object" == typeof this && this) || function () {
        return this;
      }() || Function("return this")();
    },
    9297: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(8981),
          i = n({}.hasOwnProperty);

      t.exports = Object.hasOwn || function (t, e) {
        return i(o(t), e);
      };
    },
    421: t => {
      "use strict";

      t.exports = {};
    },
    397: (t, e, r) => {
      "use strict";

      var n = r(7751);
      t.exports = n("document", "documentElement");
    },
    5917: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(9039),
          i = r(4055);
      t.exports = !n && !o(function () {
        return 7 !== Object.defineProperty(i("div"), "a", {
          get: function () {
            return 7;
          }
        }).a;
      });
    },
    7055: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(9039),
          i = r(2195),
          c = Object,
          a = n("".split);
      t.exports = o(function () {
        return !c("z").propertyIsEnumerable(0);
      }) ? function (t) {
        return "String" === i(t) ? a(t, "") : c(t);
      } : c;
    },
    3167: (t, e, r) => {
      "use strict";

      var n = r(4901),
          o = r(34),
          i = r(2967);

      t.exports = function (t, e, r) {
        var c, a;
        return i && n(c = e.constructor) && c !== r && o(a = c.prototype) && a !== r.prototype && i(t, a), t;
      };
    },
    3706: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(4901),
          i = r(7629),
          c = n(Function.toString);
      o(i.inspectSource) || (i.inspectSource = function (t) {
        return c(t);
      }), t.exports = i.inspectSource;
    },
    3451: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9504),
          i = r(421),
          c = r(34),
          a = r(9297),
          u = r(4913).f,
          s = r(8480),
          p = r(298),
          l = r(4124),
          f = r(3392),
          y = r(2744),
          d = !1,
          h = f("meta"),
          m = 0,
          g = function (t) {
        u(t, h, {
          value: {
            objectID: "O" + m++,
            weakData: {}
          }
        });
      },
          v = t.exports = {
        enable: function () {
          v.enable = function () {}, d = !0;
          var t = s.f,
              e = o([].splice),
              r = {};
          r[h] = 1, t(r).length && (s.f = function (r) {
            for (var n = t(r), o = 0, i = n.length; o < i; o++) if (n[o] === h) {
              e(n, o, 1);
              break;
            }

            return n;
          }, n({
            target: "Object",
            stat: !0,
            forced: !0
          }, {
            getOwnPropertyNames: p.f
          }));
        },
        fastKey: function (t, e) {
          if (!c(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;

          if (!a(t, h)) {
            if (!l(t)) return "F";
            if (!e) return "E";
            g(t);
          }

          return t[h].objectID;
        },
        getWeakData: function (t, e) {
          if (!a(t, h)) {
            if (!l(t)) return !0;
            if (!e) return !1;
            g(t);
          }

          return t[h].weakData;
        },
        onFreeze: function (t) {
          return y && d && l(t) && !a(t, h) && g(t), t;
        }
      };

      i[h] = !0;
    },
    1181: (t, e, r) => {
      "use strict";

      var n,
          o,
          i,
          c = r(8622),
          a = r(4576),
          u = r(34),
          s = r(6699),
          p = r(9297),
          l = r(7629),
          f = r(6119),
          y = r(421),
          d = "Object already initialized",
          h = a.TypeError,
          m = a.WeakMap;

      if (c || l.state) {
        var g = l.state || (l.state = new m());
        g.get = g.get, g.has = g.has, g.set = g.set, n = function (t, e) {
          if (g.has(t)) throw new h(d);
          return e.facade = t, g.set(t, e), e;
        }, o = function (t) {
          return g.get(t) || {};
        }, i = function (t) {
          return g.has(t);
        };
      } else {
        var v = f("state");
        y[v] = !0, n = function (t, e) {
          if (p(t, v)) throw new h(d);
          return e.facade = t, s(t, v, e), e;
        }, o = function (t) {
          return p(t, v) ? t[v] : {};
        }, i = function (t) {
          return p(t, v);
        };
      }

      t.exports = {
        set: n,
        get: o,
        has: i,
        enforce: function (t) {
          return i(t) ? o(t) : n(t, {});
        },
        getterFor: function (t) {
          return function (e) {
            var r;
            if (!u(e) || (r = o(e)).type !== t) throw new h("Incompatible receiver, " + t + " required");
            return r;
          };
        }
      };
    },
    4209: (t, e, r) => {
      "use strict";

      var n = r(8227),
          o = r(6269),
          i = n("iterator"),
          c = Array.prototype;

      t.exports = function (t) {
        return void 0 !== t && (o.Array === t || c[i] === t);
      };
    },
    4376: (t, e, r) => {
      "use strict";

      var n = r(2195);

      t.exports = Array.isArray || function (t) {
        return "Array" === n(t);
      };
    },
    4901: t => {
      "use strict";

      var e = "object" == typeof document && document.all;
      t.exports = void 0 === e && void 0 !== e ? function (t) {
        return "function" == typeof t || t === e;
      } : function (t) {
        return "function" == typeof t;
      };
    },
    3517: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(9039),
          i = r(4901),
          c = r(6955),
          a = r(7751),
          u = r(3706),
          s = function () {},
          p = a("Reflect", "construct"),
          l = /^\s*(?:class|function)\b/,
          f = n(l.exec),
          y = !l.test(s),
          d = function (t) {
        if (!i(t)) return !1;

        try {
          return p(s, [], t), !0;
        } catch (t) {
          return !1;
        }
      },
          h = function (t) {
        if (!i(t)) return !1;

        switch (c(t)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return !1;
        }

        try {
          return y || !!f(l, u(t));
        } catch (t) {
          return !0;
        }
      };

      h.sham = !0, t.exports = !p || o(function () {
        var t;
        return d(d.call) || !d(Object) || !d(function () {
          t = !0;
        }) || t;
      }) ? h : d;
    },
    2796: (t, e, r) => {
      "use strict";

      var n = r(9039),
          o = r(4901),
          i = /#|\.prototype\./,
          c = function (t, e) {
        var r = u[a(t)];
        return r === p || r !== s && (o(e) ? n(e) : !!e);
      },
          a = c.normalize = function (t) {
        return String(t).replace(i, ".").toLowerCase();
      },
          u = c.data = {},
          s = c.NATIVE = "N",
          p = c.POLYFILL = "P";

      t.exports = c;
    },
    4117: t => {
      "use strict";

      t.exports = function (t) {
        return null == t;
      };
    },
    34: (t, e, r) => {
      "use strict";

      var n = r(4901);

      t.exports = function (t) {
        return "object" == typeof t ? null !== t : n(t);
      };
    },
    3925: (t, e, r) => {
      "use strict";

      var n = r(34);

      t.exports = function (t) {
        return n(t) || null === t;
      };
    },
    6395: t => {
      "use strict";

      t.exports = !1;
    },
    788: (t, e, r) => {
      "use strict";

      var n = r(34),
          o = r(2195),
          i = r(8227)("match");

      t.exports = function (t) {
        var e;
        return n(t) && (void 0 !== (e = t[i]) ? !!e : "RegExp" === o(t));
      };
    },
    757: (t, e, r) => {
      "use strict";

      var n = r(7751),
          o = r(4901),
          i = r(1625),
          c = r(7040),
          a = Object;
      t.exports = c ? function (t) {
        return "symbol" == typeof t;
      } : function (t) {
        var e = n("Symbol");
        return o(e) && i(e.prototype, a(t));
      };
    },
    2652: (t, e, r) => {
      "use strict";

      var n = r(6080),
          o = r(9565),
          i = r(8551),
          c = r(6823),
          a = r(4209),
          u = r(6198),
          s = r(1625),
          p = r(81),
          l = r(851),
          f = r(9539),
          y = TypeError,
          d = function (t, e) {
        this.stopped = t, this.result = e;
      },
          h = d.prototype;

      t.exports = function (t, e, r) {
        var m,
            g,
            v,
            b,
            O,
            P,
            j,
            w = r && r.that,
            k = !(!r || !r.AS_ENTRIES),
            R = !(!r || !r.IS_RECORD),
            A = !(!r || !r.IS_ITERATOR),
            D = !(!r || !r.INTERRUPTED),
            _ = n(e, w),
            x = function (t) {
          return m && f(m, "normal", t), new d(!0, t);
        },
            S = function (t) {
          return k ? (i(t), D ? _(t[0], t[1], x) : _(t[0], t[1])) : D ? _(t, x) : _(t);
        };

        if (R) m = t.iterator;else if (A) m = t;else {
          if (!(g = l(t))) throw new y(c(t) + " is not iterable");

          if (a(g)) {
            for (v = 0, b = u(t); b > v; v++) if ((O = S(t[v])) && s(h, O)) return O;

            return new d(!1);
          }

          m = p(t, g);
        }

        for (P = R ? t.next : m.next; !(j = o(P, m)).done;) {
          try {
            O = S(j.value);
          } catch (t) {
            f(m, "throw", t);
          }

          if ("object" == typeof O && O && s(h, O)) return O;
        }

        return new d(!1);
      };
    },
    9539: (t, e, r) => {
      "use strict";

      var n = r(9565),
          o = r(8551),
          i = r(5966);

      t.exports = function (t, e, r) {
        var c, a;
        o(t);

        try {
          if (!(c = i(t, "return"))) {
            if ("throw" === e) throw r;
            return r;
          }

          c = n(c, t);
        } catch (t) {
          a = !0, c = t;
        }

        if ("throw" === e) throw r;
        if (a) throw c;
        return o(c), r;
      };
    },
    3994: (t, e, r) => {
      "use strict";

      var n = r(7657).IteratorPrototype,
          o = r(2360),
          i = r(6980),
          c = r(687),
          a = r(6269),
          u = function () {
        return this;
      };

      t.exports = function (t, e, r, s) {
        var p = e + " Iterator";
        return t.prototype = o(n, {
          next: i(+!s, r)
        }), c(t, p, !1, !0), a[p] = u, t;
      };
    },
    1088: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9565),
          i = r(6395),
          c = r(350),
          a = r(4901),
          u = r(3994),
          s = r(2787),
          p = r(2967),
          l = r(687),
          f = r(6699),
          y = r(6840),
          d = r(8227),
          h = r(6269),
          m = r(7657),
          g = c.PROPER,
          v = c.CONFIGURABLE,
          b = m.IteratorPrototype,
          O = m.BUGGY_SAFARI_ITERATORS,
          P = d("iterator"),
          j = "keys",
          w = "values",
          k = "entries",
          R = function () {
        return this;
      };

      t.exports = function (t, e, r, c, d, m, A) {
        u(r, e, c);

        var D,
            _,
            x,
            S = function (t) {
          if (t === d && M) return M;
          if (!O && t && t in N) return N[t];

          switch (t) {
            case j:
            case w:
            case k:
              return function () {
                return new r(this, t);
              };
          }

          return function () {
            return new r(this);
          };
        },
            C = e + " Iterator",
            E = !1,
            N = t.prototype,
            B = N[P] || N["@@iterator"] || d && N[d],
            M = !O && B || S(d),
            F = "Array" === e && N.entries || B;

        if (F && (D = s(F.call(new t()))) !== Object.prototype && D.next && (i || s(D) === b || (p ? p(D, b) : a(D[P]) || y(D, P, R)), l(D, C, !0, !0), i && (h[C] = R)), g && d === w && B && B.name !== w && (!i && v ? f(N, "name", w) : (E = !0, M = function () {
          return o(B, this);
        })), d) if (_ = {
          values: S(w),
          keys: m ? M : S(j),
          entries: S(k)
        }, A) for (x in _) (O || E || !(x in N)) && y(N, x, _[x]);else n({
          target: e,
          proto: !0,
          forced: O || E
        }, _);
        return i && !A || N[P] === M || y(N, P, M, {
          name: d
        }), h[e] = M, _;
      };
    },
    7657: (t, e, r) => {
      "use strict";

      var n,
          o,
          i,
          c = r(9039),
          a = r(4901),
          u = r(34),
          s = r(2360),
          p = r(2787),
          l = r(6840),
          f = r(8227),
          y = r(6395),
          d = f("iterator"),
          h = !1;
      [].keys && ("next" in (i = [].keys()) ? (o = p(p(i))) !== Object.prototype && (n = o) : h = !0), !u(n) || c(function () {
        var t = {};
        return n[d].call(t) !== t;
      }) ? n = {} : y && (n = s(n)), a(n[d]) || l(n, d, function () {
        return this;
      }), t.exports = {
        IteratorPrototype: n,
        BUGGY_SAFARI_ITERATORS: h
      };
    },
    6269: t => {
      "use strict";

      t.exports = {};
    },
    6198: (t, e, r) => {
      "use strict";

      var n = r(8014);

      t.exports = function (t) {
        return n(t.length);
      };
    },
    283: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(9039),
          i = r(4901),
          c = r(9297),
          a = r(3724),
          u = r(350).CONFIGURABLE,
          s = r(3706),
          p = r(1181),
          l = p.enforce,
          f = p.get,
          y = String,
          d = Object.defineProperty,
          h = n("".slice),
          m = n("".replace),
          g = n([].join),
          v = a && !o(function () {
        return 8 !== d(function () {}, "length", {
          value: 8
        }).length;
      }),
          b = String(String).split("String"),
          O = t.exports = function (t, e, r) {
        "Symbol(" === h(y(e), 0, 7) && (e = "[" + m(y(e), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), r && r.getter && (e = "get " + e), r && r.setter && (e = "set " + e), (!c(t, "name") || u && t.name !== e) && (a ? d(t, "name", {
          value: e,
          configurable: !0
        }) : t.name = e), v && r && c(r, "arity") && t.length !== r.arity && d(t, "length", {
          value: r.arity
        });

        try {
          r && c(r, "constructor") && r.constructor ? a && d(t, "prototype", {
            writable: !1
          }) : t.prototype && (t.prototype = void 0);
        } catch (t) {}

        var n = l(t);
        return c(n, "source") || (n.source = g(b, "string" == typeof e ? e : "")), t;
      };

      Function.prototype.toString = O(function () {
        return i(this) && f(this).source || s(this);
      }, "toString");
    },
    741: t => {
      "use strict";

      var e = Math.ceil,
          r = Math.floor;

      t.exports = Math.trunc || function (t) {
        var n = +t;
        return (n > 0 ? r : e)(n);
      };
    },
    2892: (t, e, r) => {
      "use strict";

      var n = r(788),
          o = TypeError;

      t.exports = function (t) {
        if (n(t)) throw new o("The method doesn't accept regular expressions");
        return t;
      };
    },
    360: (t, e, r) => {
      "use strict";

      var n = r(4576).isFinite;

      t.exports = Number.isFinite || function (t) {
        return "number" == typeof t && n(t);
      };
    },
    3904: (t, e, r) => {
      "use strict";

      var n = r(4576),
          o = r(9039),
          i = r(9504),
          c = r(655),
          a = r(3802).trim,
          u = r(7452),
          s = i("".charAt),
          p = n.parseFloat,
          l = n.Symbol,
          f = l && l.iterator,
          y = 1 / p(u + "-0") != -1 / 0 || f && !o(function () {
        p(Object(f));
      });
      t.exports = y ? function (t) {
        var e = a(c(t)),
            r = p(e);
        return 0 === r && "-" === s(e, 0) ? -0 : r;
      } : p;
    },
    2360: (t, e, r) => {
      "use strict";

      var n,
          o = r(8551),
          i = r(6801),
          c = r(8727),
          a = r(421),
          u = r(397),
          s = r(4055),
          p = r(6119),
          l = "prototype",
          f = "script",
          y = p("IE_PROTO"),
          d = function () {},
          h = function (t) {
        return "<" + f + ">" + t + "</" + f + ">";
      },
          m = function (t) {
        t.write(h("")), t.close();
        var e = t.parentWindow.Object;
        return t = null, e;
      },
          g = function () {
        try {
          n = new ActiveXObject("htmlfile");
        } catch (t) {}

        var t, e, r;
        g = "undefined" != typeof document ? document.domain && n ? m(n) : (e = s("iframe"), r = "java" + f + ":", e.style.display = "none", u.appendChild(e), e.src = String(r), (t = e.contentWindow.document).open(), t.write(h("document.F=Object")), t.close(), t.F) : m(n);

        for (var o = c.length; o--;) delete g[l][c[o]];

        return g();
      };

      a[y] = !0, t.exports = Object.create || function (t, e) {
        var r;
        return null !== t ? (d[l] = o(t), r = new d(), d[l] = null, r[y] = t) : r = g(), void 0 === e ? r : i.f(r, e);
      };
    },
    6801: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(8686),
          i = r(4913),
          c = r(8551),
          a = r(5397),
          u = r(1072);
      e.f = n && !o ? Object.defineProperties : function (t, e) {
        c(t);

        for (var r, n = a(e), o = u(e), s = o.length, p = 0; s > p;) i.f(t, r = o[p++], n[r]);

        return t;
      };
    },
    4913: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(5917),
          i = r(8686),
          c = r(8551),
          a = r(6969),
          u = TypeError,
          s = Object.defineProperty,
          p = Object.getOwnPropertyDescriptor,
          l = "enumerable",
          f = "configurable",
          y = "writable";
      e.f = n ? i ? function (t, e, r) {
        if (c(t), e = a(e), c(r), "function" == typeof t && "prototype" === e && "value" in r && y in r && !r[y]) {
          var n = p(t, e);
          n && n[y] && (t[e] = r.value, r = {
            configurable: f in r ? r[f] : n[f],
            enumerable: l in r ? r[l] : n[l],
            writable: !1
          });
        }

        return s(t, e, r);
      } : s : function (t, e, r) {
        if (c(t), e = a(e), c(r), o) try {
          return s(t, e, r);
        } catch (t) {}
        if ("get" in r || "set" in r) throw new u("Accessors not supported");
        return "value" in r && (t[e] = r.value), t;
      };
    },
    7347: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(9565),
          i = r(8773),
          c = r(6980),
          a = r(5397),
          u = r(6969),
          s = r(9297),
          p = r(5917),
          l = Object.getOwnPropertyDescriptor;
      e.f = n ? l : function (t, e) {
        if (t = a(t), e = u(e), p) try {
          return l(t, e);
        } catch (t) {}
        if (s(t, e)) return c(!o(i.f, t, e), t[e]);
      };
    },
    298: (t, e, r) => {
      "use strict";

      var n = r(2195),
          o = r(5397),
          i = r(8480).f,
          c = r(7680),
          a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

      t.exports.f = function (t) {
        return a && "Window" === n(t) ? function (t) {
          try {
            return i(t);
          } catch (t) {
            return c(a);
          }
        }(t) : i(o(t));
      };
    },
    8480: (t, e, r) => {
      "use strict";

      var n = r(1828),
          o = r(8727).concat("length", "prototype");

      e.f = Object.getOwnPropertyNames || function (t) {
        return n(t, o);
      };
    },
    3717: (t, e) => {
      "use strict";

      e.f = Object.getOwnPropertySymbols;
    },
    2787: (t, e, r) => {
      "use strict";

      var n = r(9297),
          o = r(4901),
          i = r(8981),
          c = r(6119),
          a = r(2211),
          u = c("IE_PROTO"),
          s = Object,
          p = s.prototype;
      t.exports = a ? s.getPrototypeOf : function (t) {
        var e = i(t);
        if (n(e, u)) return e[u];
        var r = e.constructor;
        return o(r) && e instanceof r ? r.prototype : e instanceof s ? p : null;
      };
    },
    4124: (t, e, r) => {
      "use strict";

      var n = r(9039),
          o = r(34),
          i = r(2195),
          c = r(5652),
          a = Object.isExtensible,
          u = n(function () {
        a(1);
      });
      t.exports = u || c ? function (t) {
        return !!o(t) && (!c || "ArrayBuffer" !== i(t)) && (!a || a(t));
      } : a;
    },
    1625: (t, e, r) => {
      "use strict";

      var n = r(9504);
      t.exports = n({}.isPrototypeOf);
    },
    1828: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(9297),
          i = r(5397),
          c = r(9617).indexOf,
          a = r(421),
          u = n([].push);

      t.exports = function (t, e) {
        var r,
            n = i(t),
            s = 0,
            p = [];

        for (r in n) !o(a, r) && o(n, r) && u(p, r);

        for (; e.length > s;) o(n, r = e[s++]) && (~c(p, r) || u(p, r));

        return p;
      };
    },
    1072: (t, e, r) => {
      "use strict";

      var n = r(1828),
          o = r(8727);

      t.exports = Object.keys || function (t) {
        return n(t, o);
      };
    },
    8773: (t, e) => {
      "use strict";

      var r = {}.propertyIsEnumerable,
          n = Object.getOwnPropertyDescriptor,
          o = n && !r.call({
        1: 2
      }, 1);
      e.f = o ? function (t) {
        var e = n(this, t);
        return !!e && e.enumerable;
      } : r;
    },
    2967: (t, e, r) => {
      "use strict";

      var n = r(6706),
          o = r(34),
          i = r(7750),
          c = r(3506);
      t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
        var t,
            e = !1,
            r = {};

        try {
          (t = n(Object.prototype, "__proto__", "set"))(r, []), e = r instanceof Array;
        } catch (t) {}

        return function (r, n) {
          return i(r), c(n), o(r) ? (e ? t(r, n) : r.__proto__ = n, r) : r;
        };
      }() : void 0);
    },
    2357: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(9039),
          i = r(9504),
          c = r(2787),
          a = r(1072),
          u = r(5397),
          s = i(r(8773).f),
          p = i([].push),
          l = n && o(function () {
        var t = Object.create(null);
        return t[2] = 2, !s(t, 2);
      }),
          f = function (t) {
        return function (e) {
          for (var r, o = u(e), i = a(o), f = l && null === c(o), y = i.length, d = 0, h = []; y > d;) r = i[d++], n && !(f ? r in o : s(o, r)) || p(h, t ? [r, o[r]] : o[r]);

          return h;
        };
      };

      t.exports = {
        entries: f(!0),
        values: f(!1)
      };
    },
    3179: (t, e, r) => {
      "use strict";

      var n = r(2140),
          o = r(6955);
      t.exports = n ? {}.toString : function () {
        return "[object " + o(this) + "]";
      };
    },
    4270: (t, e, r) => {
      "use strict";

      var n = r(9565),
          o = r(4901),
          i = r(34),
          c = TypeError;

      t.exports = function (t, e) {
        var r, a;
        if ("string" === e && o(r = t.toString) && !i(a = n(r, t))) return a;
        if (o(r = t.valueOf) && !i(a = n(r, t))) return a;
        if ("string" !== e && o(r = t.toString) && !i(a = n(r, t))) return a;
        throw new c("Can't convert object to primitive value");
      };
    },
    5031: (t, e, r) => {
      "use strict";

      var n = r(7751),
          o = r(9504),
          i = r(8480),
          c = r(3717),
          a = r(8551),
          u = o([].concat);

      t.exports = n("Reflect", "ownKeys") || function (t) {
        var e = i.f(a(t)),
            r = c.f;
        return r ? u(e, r(t)) : e;
      };
    },
    9167: (t, e, r) => {
      "use strict";

      var n = r(4576);
      t.exports = n;
    },
    6682: (t, e, r) => {
      "use strict";

      var n = r(9565),
          o = r(8551),
          i = r(4901),
          c = r(2195),
          a = r(7323),
          u = TypeError;

      t.exports = function (t, e) {
        var r = t.exec;

        if (i(r)) {
          var s = n(r, t, e);
          return null !== s && o(s), s;
        }

        if ("RegExp" === c(t)) return n(a, t, e);
        throw new u("RegExp#exec called on incompatible receiver");
      };
    },
    7323: (t, e, r) => {
      "use strict";

      var n,
          o,
          i = r(9565),
          c = r(9504),
          a = r(655),
          u = r(7979),
          s = r(8429),
          p = r(5745),
          l = r(2360),
          f = r(1181).get,
          y = r(3635),
          d = r(8814),
          h = p("native-string-replace", String.prototype.replace),
          m = RegExp.prototype.exec,
          g = m,
          v = c("".charAt),
          b = c("".indexOf),
          O = c("".replace),
          P = c("".slice),
          j = (o = /b*/g, i(m, n = /a/, "a"), i(m, o, "a"), 0 !== n.lastIndex || 0 !== o.lastIndex),
          w = s.BROKEN_CARET,
          k = void 0 !== /()??/.exec("")[1];
      (j || k || w || y || d) && (g = function (t) {
        var e,
            r,
            n,
            o,
            c,
            s,
            p,
            y = this,
            d = f(y),
            R = a(t),
            A = d.raw;
        if (A) return A.lastIndex = y.lastIndex, e = i(g, A, R), y.lastIndex = A.lastIndex, e;

        var D = d.groups,
            _ = w && y.sticky,
            x = i(u, y),
            S = y.source,
            C = 0,
            E = R;

        if (_ && (x = O(x, "y", ""), -1 === b(x, "g") && (x += "g"), E = P(R, y.lastIndex), y.lastIndex > 0 && (!y.multiline || y.multiline && "\n" !== v(R, y.lastIndex - 1)) && (S = "(?: " + S + ")", E = " " + E, C++), r = new RegExp("^(?:" + S + ")", x)), k && (r = new RegExp("^" + S + "$(?!\\s)", x)), j && (n = y.lastIndex), o = i(m, _ ? r : y, E), _ ? o ? (o.input = P(o.input, C), o[0] = P(o[0], C), o.index = y.lastIndex, y.lastIndex += o[0].length) : y.lastIndex = 0 : j && o && (y.lastIndex = y.global ? o.index + o[0].length : n), k && o && o.length > 1 && i(h, o[0], r, function () {
          for (c = 1; c < arguments.length - 2; c++) void 0 === arguments[c] && (o[c] = void 0);
        }), o && D) for (o.groups = s = l(null), c = 0; c < D.length; c++) s[(p = D[c])[0]] = o[p[1]];
        return o;
      }), t.exports = g;
    },
    7979: (t, e, r) => {
      "use strict";

      var n = r(8551);

      t.exports = function () {
        var t = n(this),
            e = "";
        return t.hasIndices && (e += "d"), t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.unicodeSets && (e += "v"), t.sticky && (e += "y"), e;
      };
    },
    1034: (t, e, r) => {
      "use strict";

      var n = r(9565),
          o = r(9297),
          i = r(1625),
          c = r(7979),
          a = RegExp.prototype;

      t.exports = function (t) {
        var e = t.flags;
        return void 0 !== e || "flags" in a || o(t, "flags") || !i(a, t) ? e : n(c, t);
      };
    },
    8429: (t, e, r) => {
      "use strict";

      var n = r(9039),
          o = r(4576).RegExp,
          i = n(function () {
        var t = o("a", "y");
        return t.lastIndex = 2, null !== t.exec("abcd");
      }),
          c = i || n(function () {
        return !o("a", "y").sticky;
      }),
          a = i || n(function () {
        var t = o("^r", "gy");
        return t.lastIndex = 2, null !== t.exec("str");
      });
      t.exports = {
        BROKEN_CARET: a,
        MISSED_STICKY: c,
        UNSUPPORTED_Y: i
      };
    },
    3635: (t, e, r) => {
      "use strict";

      var n = r(9039),
          o = r(4576).RegExp;
      t.exports = n(function () {
        var t = o(".", "s");
        return !(t.dotAll && t.test("\n") && "s" === t.flags);
      });
    },
    8814: (t, e, r) => {
      "use strict";

      var n = r(9039),
          o = r(4576).RegExp;
      t.exports = n(function () {
        var t = o("(?<a>b)", "g");
        return "b" !== t.exec("b").groups.a || "bc" !== "b".replace(t, "$<a>c");
      });
    },
    7750: (t, e, r) => {
      "use strict";

      var n = r(4117),
          o = TypeError;

      t.exports = function (t) {
        if (n(t)) throw new o("Can't call method on " + t);
        return t;
      };
    },
    7633: (t, e, r) => {
      "use strict";

      var n = r(7751),
          o = r(2106),
          i = r(8227),
          c = r(3724),
          a = i("species");

      t.exports = function (t) {
        var e = n(t);
        c && e && !e[a] && o(e, a, {
          configurable: !0,
          get: function () {
            return this;
          }
        });
      };
    },
    687: (t, e, r) => {
      "use strict";

      var n = r(4913).f,
          o = r(9297),
          i = r(8227)("toStringTag");

      t.exports = function (t, e, r) {
        t && !r && (t = t.prototype), t && !o(t, i) && n(t, i, {
          configurable: !0,
          value: e
        });
      };
    },
    6119: (t, e, r) => {
      "use strict";

      var n = r(5745),
          o = r(3392),
          i = n("keys");

      t.exports = function (t) {
        return i[t] || (i[t] = o(t));
      };
    },
    7629: (t, e, r) => {
      "use strict";

      var n = r(6395),
          o = r(4576),
          i = r(9433),
          c = "__core-js_shared__",
          a = t.exports = o[c] || i(c, {});
      (a.versions || (a.versions = [])).push({
        version: "3.38.1",
        mode: n ? "pure" : "global",
        copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
        license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
        source: "https://github.com/zloirock/core-js"
      });
    },
    5745: (t, e, r) => {
      "use strict";

      var n = r(7629);

      t.exports = function (t, e) {
        return n[t] || (n[t] = e || {});
      };
    },
    2293: (t, e, r) => {
      "use strict";

      var n = r(8551),
          o = r(5548),
          i = r(4117),
          c = r(8227)("species");

      t.exports = function (t, e) {
        var r,
            a = n(t).constructor;
        return void 0 === a || i(r = n(a)[c]) ? e : o(r);
      };
    },
    3061: (t, e, r) => {
      "use strict";

      var n = r(9039);

      t.exports = function (t) {
        return n(function () {
          var e = ""[t]('"');
          return e !== e.toLowerCase() || e.split('"').length > 3;
        });
      };
    },
    8183: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(1291),
          i = r(655),
          c = r(7750),
          a = n("".charAt),
          u = n("".charCodeAt),
          s = n("".slice),
          p = function (t) {
        return function (e, r) {
          var n,
              p,
              l = i(c(e)),
              f = o(r),
              y = l.length;
          return f < 0 || f >= y ? t ? "" : void 0 : (n = u(l, f)) < 55296 || n > 56319 || f + 1 === y || (p = u(l, f + 1)) < 56320 || p > 57343 ? t ? a(l, f) : n : t ? s(l, f, f + 2) : p - 56320 + (n - 55296 << 10) + 65536;
        };
      };

      t.exports = {
        codeAt: p(!1),
        charAt: p(!0)
      };
    },
    533: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(8014),
          i = r(655),
          c = r(2333),
          a = r(7750),
          u = n(c),
          s = n("".slice),
          p = Math.ceil,
          l = function (t) {
        return function (e, r, n) {
          var c,
              l,
              f = i(a(e)),
              y = o(r),
              d = f.length,
              h = void 0 === n ? " " : i(n);
          return y <= d || "" === h ? f : ((l = u(h, p((c = y - d) / h.length))).length > c && (l = s(l, 0, c)), t ? f + l : l + f);
        };
      };

      t.exports = {
        start: l(!1),
        end: l(!0)
      };
    },
    2333: (t, e, r) => {
      "use strict";

      var n = r(1291),
          o = r(655),
          i = r(7750),
          c = RangeError;

      t.exports = function (t) {
        var e = o(i(this)),
            r = "",
            a = n(t);
        if (a < 0 || a === 1 / 0) throw new c("Wrong number of repetitions");

        for (; a > 0; (a >>>= 1) && (e += e)) 1 & a && (r += e);

        return r;
      };
    },
    706: (t, e, r) => {
      "use strict";

      var n = r(350).PROPER,
          o = r(9039),
          i = r(7452);

      t.exports = function (t) {
        return o(function () {
          return !!i[t]() || "​᠎" !== "​᠎"[t]() || n && i[t].name !== t;
        });
      };
    },
    3802: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(7750),
          i = r(655),
          c = r(7452),
          a = n("".replace),
          u = RegExp("^[" + c + "]+"),
          s = RegExp("(^|[^" + c + "])[" + c + "]+$"),
          p = function (t) {
        return function (e) {
          var r = i(o(e));
          return 1 & t && (r = a(r, u, "")), 2 & t && (r = a(r, s, "$1")), r;
        };
      };

      t.exports = {
        start: p(1),
        end: p(2),
        trim: p(3)
      };
    },
    4495: (t, e, r) => {
      "use strict";

      var n = r(9519),
          o = r(9039),
          i = r(4576).String;
      t.exports = !!Object.getOwnPropertySymbols && !o(function () {
        var t = Symbol("symbol detection");
        return !i(t) || !(Object(t) instanceof Symbol) || !Symbol.sham && n && n < 41;
      });
    },
    8242: (t, e, r) => {
      "use strict";

      var n = r(9565),
          o = r(7751),
          i = r(8227),
          c = r(6840);

      t.exports = function () {
        var t = o("Symbol"),
            e = t && t.prototype,
            r = e && e.valueOf,
            a = i("toPrimitive");
        e && !e[a] && c(e, a, function (t) {
          return n(r, this);
        }, {
          arity: 1
        });
      };
    },
    1296: (t, e, r) => {
      "use strict";

      var n = r(4495);
      t.exports = n && !!Symbol.for && !!Symbol.keyFor;
    },
    1240: (t, e, r) => {
      "use strict";

      var n = r(9504);
      t.exports = n(1..valueOf);
    },
    5610: (t, e, r) => {
      "use strict";

      var n = r(1291),
          o = Math.max,
          i = Math.min;

      t.exports = function (t, e) {
        var r = n(t);
        return r < 0 ? o(r + e, 0) : i(r, e);
      };
    },
    5397: (t, e, r) => {
      "use strict";

      var n = r(7055),
          o = r(7750);

      t.exports = function (t) {
        return n(o(t));
      };
    },
    1291: (t, e, r) => {
      "use strict";

      var n = r(741);

      t.exports = function (t) {
        var e = +t;
        return e != e || 0 === e ? 0 : n(e);
      };
    },
    8014: (t, e, r) => {
      "use strict";

      var n = r(1291),
          o = Math.min;

      t.exports = function (t) {
        var e = n(t);
        return e > 0 ? o(e, 9007199254740991) : 0;
      };
    },
    8981: (t, e, r) => {
      "use strict";

      var n = r(7750),
          o = Object;

      t.exports = function (t) {
        return o(n(t));
      };
    },
    2777: (t, e, r) => {
      "use strict";

      var n = r(9565),
          o = r(34),
          i = r(757),
          c = r(5966),
          a = r(4270),
          u = r(8227),
          s = TypeError,
          p = u("toPrimitive");

      t.exports = function (t, e) {
        if (!o(t) || i(t)) return t;
        var r,
            u = c(t, p);

        if (u) {
          if (void 0 === e && (e = "default"), r = n(u, t, e), !o(r) || i(r)) return r;
          throw new s("Can't convert object to primitive value");
        }

        return void 0 === e && (e = "number"), a(t, e);
      };
    },
    6969: (t, e, r) => {
      "use strict";

      var n = r(2777),
          o = r(757);

      t.exports = function (t) {
        var e = n(t, "string");
        return o(e) ? e : e + "";
      };
    },
    2140: (t, e, r) => {
      "use strict";

      var n = {};
      n[r(8227)("toStringTag")] = "z", t.exports = "[object z]" === String(n);
    },
    655: (t, e, r) => {
      "use strict";

      var n = r(6955),
          o = String;

      t.exports = function (t) {
        if ("Symbol" === n(t)) throw new TypeError("Cannot convert a Symbol value to a string");
        return o(t);
      };
    },
    6823: t => {
      "use strict";

      var e = String;

      t.exports = function (t) {
        try {
          return e(t);
        } catch (t) {
          return "Object";
        }
      };
    },
    3392: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = 0,
          i = Math.random(),
          c = n(1..toString);

      t.exports = function (t) {
        return "Symbol(" + (void 0 === t ? "" : t) + ")_" + c(++o + i, 36);
      };
    },
    7040: (t, e, r) => {
      "use strict";

      var n = r(4495);
      t.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
    },
    8686: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(9039);
      t.exports = n && o(function () {
        return 42 !== Object.defineProperty(function () {}, "prototype", {
          value: 42,
          writable: !1
        }).prototype;
      });
    },
    8622: (t, e, r) => {
      "use strict";

      var n = r(4576),
          o = r(4901),
          i = n.WeakMap;
      t.exports = o(i) && /native code/.test(String(i));
    },
    511: (t, e, r) => {
      "use strict";

      var n = r(9167),
          o = r(9297),
          i = r(1951),
          c = r(4913).f;

      t.exports = function (t) {
        var e = n.Symbol || (n.Symbol = {});
        o(e, t) || c(e, t, {
          value: i.f(t)
        });
      };
    },
    1951: (t, e, r) => {
      "use strict";

      var n = r(8227);
      e.f = n;
    },
    8227: (t, e, r) => {
      "use strict";

      var n = r(4576),
          o = r(5745),
          i = r(9297),
          c = r(3392),
          a = r(4495),
          u = r(7040),
          s = n.Symbol,
          p = o("wks"),
          l = u ? s.for || s : s && s.withoutSetter || c;

      t.exports = function (t) {
        return i(p, t) || (p[t] = a && i(s, t) ? s[t] : l("Symbol." + t)), p[t];
      };
    },
    7452: t => {
      "use strict";

      t.exports = "\t\n\v\f\r                　\u2028\u2029\ufeff";
    },
    8706: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9039),
          i = r(4376),
          c = r(34),
          a = r(8981),
          u = r(6198),
          s = r(6837),
          p = r(4659),
          l = r(1469),
          f = r(597),
          y = r(8227),
          d = r(9519),
          h = y("isConcatSpreadable"),
          m = d >= 51 || !o(function () {
        var t = [];
        return t[h] = !1, t.concat()[0] !== t;
      }),
          g = function (t) {
        if (!c(t)) return !1;
        var e = t[h];
        return void 0 !== e ? !!e : i(t);
      };

      n({
        target: "Array",
        proto: !0,
        arity: 1,
        forced: !m || !f("concat")
      }, {
        concat: function (t) {
          var e,
              r,
              n,
              o,
              i,
              c = a(this),
              f = l(c, 0),
              y = 0;

          for (e = -1, n = arguments.length; e < n; e++) if (g(i = -1 === e ? c : arguments[e])) for (o = u(i), s(y + o), r = 0; r < o; r++, y++) r in i && p(f, y, i[r]);else s(y + 1), p(f, y++, i);

          return f.length = y, f;
        }
      });
    },
    8431: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9213).every;
      n({
        target: "Array",
        proto: !0,
        forced: !r(4598)("every")
      }, {
        every: function (t) {
          return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    },
    2008: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9213).filter;
      n({
        target: "Array",
        proto: !0,
        forced: !r(597)("filter")
      }, {
        filter: function (t) {
          return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    },
    8980: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9213).findIndex,
          i = r(6469),
          c = "findIndex",
          a = !0;
      c in [] && Array(1)[c](function () {
        a = !1;
      }), n({
        target: "Array",
        proto: !0,
        forced: a
      }, {
        findIndex: function (t) {
          return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
      }), i(c);
    },
    113: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9213).find,
          i = r(6469),
          c = "find",
          a = !0;
      c in [] && Array(1)[c](function () {
        a = !1;
      }), n({
        target: "Array",
        proto: !0,
        forced: a
      }, {
        find: function (t) {
          return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
      }), i(c);
    },
    6449: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(259),
          i = r(8981),
          c = r(6198),
          a = r(1291),
          u = r(1469);
      n({
        target: "Array",
        proto: !0
      }, {
        flat: function () {
          var t = arguments.length ? arguments[0] : void 0,
              e = i(this),
              r = c(e),
              n = u(e, 0);
          return n.length = o(n, e, e, r, 0, void 0 === t ? 1 : a(t)), n;
        }
      });
    },
    1629: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(235);
      n({
        target: "Array",
        proto: !0,
        forced: [].forEach !== o
      }, {
        forEach: o
      });
    },
    3418: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(7916);
      n({
        target: "Array",
        stat: !0,
        forced: !r(4428)(function (t) {
          Array.from(t);
        })
      }, {
        from: o
      });
    },
    4423: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9617).includes,
          i = r(9039),
          c = r(6469);
      n({
        target: "Array",
        proto: !0,
        forced: i(function () {
          return !Array(1).includes();
        })
      }, {
        includes: function (t) {
          return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
      }), c("includes");
    },
    4346: (t, e, r) => {
      "use strict";

      r(6518)({
        target: "Array",
        stat: !0
      }, {
        isArray: r(4376)
      });
    },
    3792: (t, e, r) => {
      "use strict";

      var n = r(5397),
          o = r(6469),
          i = r(6269),
          c = r(1181),
          a = r(4913).f,
          u = r(1088),
          s = r(2529),
          p = r(6395),
          l = r(3724),
          f = "Array Iterator",
          y = c.set,
          d = c.getterFor(f);
      t.exports = u(Array, "Array", function (t, e) {
        y(this, {
          type: f,
          target: n(t),
          index: 0,
          kind: e
        });
      }, function () {
        var t = d(this),
            e = t.target,
            r = t.index++;
        if (!e || r >= e.length) return t.target = null, s(void 0, !0);

        switch (t.kind) {
          case "keys":
            return s(r, !1);

          case "values":
            return s(e[r], !1);
        }

        return s([r, e[r]], !1);
      }, "values");
      var h = i.Arguments = i.Array;
      if (o("keys"), o("values"), o("entries"), !p && l && "values" !== h.name) try {
        a(h, "name", {
          value: "values"
        });
      } catch (t) {}
    },
    8598: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9504),
          i = r(7055),
          c = r(5397),
          a = r(4598),
          u = o([].join);
      n({
        target: "Array",
        proto: !0,
        forced: i !== Object || !a("join", ",")
      }, {
        join: function (t) {
          return u(c(this), void 0 === t ? "," : t);
        }
      });
    },
    2062: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9213).map;
      n({
        target: "Array",
        proto: !0,
        forced: !r(597)("map")
      }, {
        map: function (t) {
          return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    },
    2712: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(926).left,
          i = r(4598),
          c = r(9519);
      n({
        target: "Array",
        proto: !0,
        forced: !r(6193) && c > 79 && c < 83 || !i("reduce")
      }, {
        reduce: function (t) {
          var e = arguments.length;
          return o(this, t, e, e > 1 ? arguments[1] : void 0);
        }
      });
    },
    4782: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(4376),
          i = r(3517),
          c = r(34),
          a = r(5610),
          u = r(6198),
          s = r(5397),
          p = r(4659),
          l = r(8227),
          f = r(597),
          y = r(7680),
          d = f("slice"),
          h = l("species"),
          m = Array,
          g = Math.max;
      n({
        target: "Array",
        proto: !0,
        forced: !d
      }, {
        slice: function (t, e) {
          var r,
              n,
              l,
              f = s(this),
              d = u(f),
              v = a(t, d),
              b = a(void 0 === e ? d : e, d);
          if (o(f) && (r = f.constructor, (i(r) && (r === m || o(r.prototype)) || c(r) && null === (r = r[h])) && (r = void 0), r === m || void 0 === r)) return y(f, v, b);

          for (n = new (void 0 === r ? m : r)(g(b - v, 0)), l = 0; v < b; v++, l++) v in f && p(n, l, f[v]);

          return n.length = l, n;
        }
      });
    },
    5086: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9213).some;
      n({
        target: "Array",
        proto: !0,
        forced: !r(4598)("some")
      }, {
        some: function (t) {
          return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    },
    6910: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9504),
          i = r(9306),
          c = r(8981),
          a = r(6198),
          u = r(4606),
          s = r(655),
          p = r(9039),
          l = r(4488),
          f = r(4598),
          y = r(3709),
          d = r(3763),
          h = r(9519),
          m = r(3607),
          g = [],
          v = o(g.sort),
          b = o(g.push),
          O = p(function () {
        g.sort(void 0);
      }),
          P = p(function () {
        g.sort(null);
      }),
          j = f("sort"),
          w = !p(function () {
        if (h) return h < 70;

        if (!(y && y > 3)) {
          if (d) return !0;
          if (m) return m < 603;
          var t,
              e,
              r,
              n,
              o = "";

          for (t = 65; t < 76; t++) {
            switch (e = String.fromCharCode(t), t) {
              case 66:
              case 69:
              case 70:
              case 72:
                r = 3;
                break;

              case 68:
              case 71:
                r = 4;
                break;

              default:
                r = 2;
            }

            for (n = 0; n < 47; n++) g.push({
              k: e + n,
              v: r
            });
          }

          for (g.sort(function (t, e) {
            return e.v - t.v;
          }), n = 0; n < g.length; n++) e = g[n].k.charAt(0), o.charAt(o.length - 1) !== e && (o += e);

          return "DGBEFHACIJK" !== o;
        }
      });
      n({
        target: "Array",
        proto: !0,
        forced: O || !P || !j || !w
      }, {
        sort: function (t) {
          void 0 !== t && i(t);
          var e = c(this);
          if (w) return void 0 === t ? v(e) : v(e, t);
          var r,
              n,
              o = [],
              p = a(e);

          for (n = 0; n < p; n++) n in e && b(o, e[n]);

          for (l(o, function (t) {
            return function (e, r) {
              return void 0 === r ? -1 : void 0 === e ? 1 : void 0 !== t ? +t(e, r) || 0 : s(e) > s(r) ? 1 : -1;
            };
          }(t)), r = a(o), n = 0; n < r;) e[n] = o[n++];

          for (; n < p;) u(e, n++);

          return e;
        }
      });
    },
    4554: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(8981),
          i = r(5610),
          c = r(1291),
          a = r(6198),
          u = r(4527),
          s = r(6837),
          p = r(1469),
          l = r(4659),
          f = r(4606),
          y = r(597)("splice"),
          d = Math.max,
          h = Math.min;
      n({
        target: "Array",
        proto: !0,
        forced: !y
      }, {
        splice: function (t, e) {
          var r,
              n,
              y,
              m,
              g,
              v,
              b = o(this),
              O = a(b),
              P = i(t, O),
              j = arguments.length;

          for (0 === j ? r = n = 0 : 1 === j ? (r = 0, n = O - P) : (r = j - 2, n = h(d(c(e), 0), O - P)), s(O + r - n), y = p(b, n), m = 0; m < n; m++) (g = P + m) in b && l(y, m, b[g]);

          if (y.length = n, r < n) {
            for (m = P; m < O - n; m++) v = m + r, (g = m + n) in b ? b[v] = b[g] : f(b, v);

            for (m = O; m > O - n + r; m--) f(b, m - 1);
          } else if (r > n) for (m = O - n; m > P; m--) v = m + r - 1, (g = m + n - 1) in b ? b[v] = b[g] : f(b, v);

          for (m = 0; m < r; m++) b[m + P] = arguments[m + 2];

          return u(b, O - n + r), y;
        }
      });
    },
    1688: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(380);
      n({
        target: "Date",
        proto: !0,
        forced: Date.prototype.toISOString !== o
      }, {
        toISOString: o
      });
    },
    3288: (t, e, r) => {
      "use strict";

      var n = r(9504),
          o = r(6840),
          i = Date.prototype,
          c = "Invalid Date",
          a = "toString",
          u = n(i[a]),
          s = n(i.getTime);
      String(new Date(NaN)) !== c && o(i, a, function () {
        var t = s(this);
        return t == t ? u(this) : c;
      });
    },
    4170: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(566);
      n({
        target: "Function",
        proto: !0,
        forced: Function.bind !== o
      }, {
        bind: o
      });
    },
    2010: (t, e, r) => {
      "use strict";

      var n = r(3724),
          o = r(350).EXISTS,
          i = r(9504),
          c = r(2106),
          a = Function.prototype,
          u = i(a.toString),
          s = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/,
          p = i(s.exec);
      n && !o && c(a, "name", {
        configurable: !0,
        get: function () {
          try {
            return p(s, u(this))[1];
          } catch (t) {
            return "";
          }
        }
      });
    },
    3110: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(7751),
          i = r(8745),
          c = r(9565),
          a = r(9504),
          u = r(9039),
          s = r(4901),
          p = r(757),
          l = r(7680),
          f = r(6933),
          y = r(4495),
          d = String,
          h = o("JSON", "stringify"),
          m = a(/./.exec),
          g = a("".charAt),
          v = a("".charCodeAt),
          b = a("".replace),
          O = a(1..toString),
          P = /[\uD800-\uDFFF]/g,
          j = /^[\uD800-\uDBFF]$/,
          w = /^[\uDC00-\uDFFF]$/,
          k = !y || u(function () {
        var t = o("Symbol")("stringify detection");
        return "[null]" !== h([t]) || "{}" !== h({
          a: t
        }) || "{}" !== h(Object(t));
      }),
          R = u(function () {
        return '"\\udf06\\ud834"' !== h("\udf06\ud834") || '"\\udead"' !== h("\udead");
      }),
          A = function (t, e) {
        var r = l(arguments),
            n = f(e);
        if (s(n) || void 0 !== t && !p(t)) return r[1] = function (t, e) {
          if (s(n) && (e = c(n, this, d(t), e)), !p(e)) return e;
        }, i(h, null, r);
      },
          D = function (t, e, r) {
        var n = g(r, e - 1),
            o = g(r, e + 1);
        return m(j, t) && !m(w, o) || m(w, t) && !m(j, n) ? "\\u" + O(v(t, 0), 16) : t;
      };

      h && n({
        target: "JSON",
        stat: !0,
        arity: 3,
        forced: k || R
      }, {
        stringify: function (t, e, r) {
          var n = l(arguments),
              o = i(k ? A : h, null, n);
          return R && "string" == typeof o ? b(o, P, D) : o;
        }
      });
    },
    8523: (t, e, r) => {
      "use strict";

      r(6468)("Map", function (t) {
        return function () {
          return t(this, arguments.length ? arguments[0] : void 0);
        };
      }, r(6938));
    },
    6033: (t, e, r) => {
      "use strict";

      r(8523);
    },
    8130: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(6395),
          i = r(3724),
          c = r(4576),
          a = r(9167),
          u = r(9504),
          s = r(2796),
          p = r(9297),
          l = r(3167),
          f = r(1625),
          y = r(757),
          d = r(2777),
          h = r(9039),
          m = r(8480).f,
          g = r(7347).f,
          v = r(4913).f,
          b = r(1240),
          O = r(3802).trim,
          P = "Number",
          j = c[P],
          w = a[P],
          k = j.prototype,
          R = c.TypeError,
          A = u("".slice),
          D = u("".charCodeAt),
          _ = s(P, !j(" 0o1") || !j("0b1") || j("+0x1")),
          x = function (t) {
        var e,
            r = arguments.length < 1 ? 0 : j(function (t) {
          var e = d(t, "number");
          return "bigint" == typeof e ? e : function (t) {
            var e,
                r,
                n,
                o,
                i,
                c,
                a,
                u,
                s = d(t, "number");
            if (y(s)) throw new R("Cannot convert a Symbol value to a number");
            if ("string" == typeof s && s.length > 2) if (s = O(s), 43 === (e = D(s, 0)) || 45 === e) {
              if (88 === (r = D(s, 2)) || 120 === r) return NaN;
            } else if (48 === e) {
              switch (D(s, 1)) {
                case 66:
                case 98:
                  n = 2, o = 49;
                  break;

                case 79:
                case 111:
                  n = 8, o = 55;
                  break;

                default:
                  return +s;
              }

              for (c = (i = A(s, 2)).length, a = 0; a < c; a++) if ((u = D(i, a)) < 48 || u > o) return NaN;

              return parseInt(i, n);
            }
            return +s;
          }(e);
        }(t));
        return f(k, e = this) && h(function () {
          b(e);
        }) ? l(Object(r), this, x) : r;
      };

      x.prototype = k, _ && !o && (k.constructor = x), n({
        global: !0,
        constructor: !0,
        wrap: !0,
        forced: _
      }, {
        Number: x
      });

      var S = function (t, e) {
        for (var r, n = i ? m(e) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), o = 0; n.length > o; o++) p(e, r = n[o]) && !p(t, r) && v(t, r, g(e, r));
      };

      o && w && S(a[P], w), (_ || o) && S(a[P], j);
    },
    5428: (t, e, r) => {
      "use strict";

      r(6518)({
        target: "Number",
        stat: !0
      }, {
        isFinite: r(360)
      });
    },
    150: (t, e, r) => {
      "use strict";

      r(6518)({
        target: "Number",
        stat: !0
      }, {
        isNaN: function (t) {
          return t != t;
        }
      });
    },
    9868: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9504),
          i = r(1291),
          c = r(1240),
          a = r(2333),
          u = r(9039),
          s = RangeError,
          p = String,
          l = Math.floor,
          f = o(a),
          y = o("".slice),
          d = o(1..toFixed),
          h = function (t, e, r) {
        return 0 === e ? r : e % 2 == 1 ? h(t, e - 1, r * t) : h(t * t, e / 2, r);
      },
          m = function (t, e, r) {
        for (var n = -1, o = r; ++n < 6;) o += e * t[n], t[n] = o % 1e7, o = l(o / 1e7);
      },
          g = function (t, e) {
        for (var r = 6, n = 0; --r >= 0;) n += t[r], t[r] = l(n / e), n = n % e * 1e7;
      },
          v = function (t) {
        for (var e = 6, r = ""; --e >= 0;) if ("" !== r || 0 === e || 0 !== t[e]) {
          var n = p(t[e]);
          r = "" === r ? n : r + f("0", 7 - n.length) + n;
        }

        return r;
      };

      n({
        target: "Number",
        proto: !0,
        forced: u(function () {
          return "0.000" !== d(8e-5, 3) || "1" !== d(.9, 0) || "1.25" !== d(1.255, 2) || "1000000000000000128" !== d(0xde0b6b3a7640080, 0);
        }) || !u(function () {
          d({});
        })
      }, {
        toFixed: function (t) {
          var e,
              r,
              n,
              o,
              a = c(this),
              u = i(t),
              l = [0, 0, 0, 0, 0, 0],
              d = "",
              b = "0";
          if (u < 0 || u > 20) throw new s("Incorrect fraction digits");
          if (a != a) return "NaN";
          if (a <= -1e21 || a >= 1e21) return p(a);
          if (a < 0 && (d = "-", a = -a), a > 1e-21) if (r = (e = function (t) {
            for (var e = 0, r = t; r >= 4096;) e += 12, r /= 4096;

            for (; r >= 2;) e += 1, r /= 2;

            return e;
          }(a * h(2, 69, 1)) - 69) < 0 ? a * h(2, -e, 1) : a / h(2, e, 1), r *= 4503599627370496, (e = 52 - e) > 0) {
            for (m(l, 0, r), n = u; n >= 7;) m(l, 1e7, 0), n -= 7;

            for (m(l, h(10, n, 1), 0), n = e - 1; n >= 23;) g(l, 1 << 23), n -= 23;

            g(l, 1 << n), m(l, 1, 1), g(l, 2), b = v(l);
          } else m(l, 0, r), m(l, 1 << -e, 0), b = v(l) + f("0", u);
          return u > 0 ? d + ((o = b.length) <= u ? "0." + f("0", u - o) + b : y(b, 0, o - u) + "." + y(b, o - u)) : d + b;
        }
      });
    },
    7945: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(3724),
          i = r(6801).f;
      n({
        target: "Object",
        stat: !0,
        forced: Object.defineProperties !== i,
        sham: !o
      }, {
        defineProperties: i
      });
    },
    4185: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(3724),
          i = r(4913).f;
      n({
        target: "Object",
        stat: !0,
        forced: Object.defineProperty !== i,
        sham: !o
      }, {
        defineProperty: i
      });
    },
    5506: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(2357).entries;
      n({
        target: "Object",
        stat: !0
      }, {
        entries: function (t) {
          return o(t);
        }
      });
    },
    3851: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9039),
          i = r(5397),
          c = r(7347).f,
          a = r(3724);
      n({
        target: "Object",
        stat: !0,
        forced: !a || o(function () {
          c(1);
        }),
        sham: !a
      }, {
        getOwnPropertyDescriptor: function (t, e) {
          return c(i(t), e);
        }
      });
    },
    1278: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(3724),
          i = r(5031),
          c = r(5397),
          a = r(7347),
          u = r(4659);
      n({
        target: "Object",
        stat: !0,
        sham: !o
      }, {
        getOwnPropertyDescriptors: function (t) {
          for (var e, r, n = c(t), o = a.f, s = i(n), p = {}, l = 0; s.length > l;) void 0 !== (r = o(n, e = s[l++])) && u(p, e, r);

          return p;
        }
      });
    },
    9773: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(4495),
          i = r(9039),
          c = r(3717),
          a = r(8981);
      n({
        target: "Object",
        stat: !0,
        forced: !o || i(function () {
          c.f(1);
        })
      }, {
        getOwnPropertySymbols: function (t) {
          var e = c.f;
          return e ? e(a(t)) : [];
        }
      });
    },
    875: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9039),
          i = r(8981),
          c = r(2787),
          a = r(2211);
      n({
        target: "Object",
        stat: !0,
        forced: o(function () {
          c(1);
        }),
        sham: !a
      }, {
        getPrototypeOf: function (t) {
          return c(i(t));
        }
      });
    },
    9432: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(8981),
          i = r(1072);
      n({
        target: "Object",
        stat: !0,
        forced: r(9039)(function () {
          i(1);
        })
      }, {
        keys: function (t) {
          return i(o(t));
        }
      });
    },
    6099: (t, e, r) => {
      "use strict";

      var n = r(2140),
          o = r(6840),
          i = r(3179);
      n || o(Object.prototype, "toString", i, {
        unsafe: !0
      });
    },
    6034: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(2357).values;
      n({
        target: "Object",
        stat: !0
      }, {
        values: function (t) {
          return o(t);
        }
      });
    },
    8459: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(3904);
      n({
        global: !0,
        forced: parseFloat !== o
      }, {
        parseFloat: o
      });
    },
    825: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(7751),
          i = r(8745),
          c = r(566),
          a = r(5548),
          u = r(8551),
          s = r(34),
          p = r(2360),
          l = r(9039),
          f = o("Reflect", "construct"),
          y = Object.prototype,
          d = [].push,
          h = l(function () {
        function t() {}

        return !(f(function () {}, [], t) instanceof t);
      }),
          m = !l(function () {
        f(function () {});
      }),
          g = h || m;
      n({
        target: "Reflect",
        stat: !0,
        forced: g,
        sham: g
      }, {
        construct: function (t, e) {
          a(t), u(e);
          var r = arguments.length < 3 ? t : a(arguments[2]);
          if (m && !h) return f(t, e, r);

          if (t === r) {
            switch (e.length) {
              case 0:
                return new t();

              case 1:
                return new t(e[0]);

              case 2:
                return new t(e[0], e[1]);

              case 3:
                return new t(e[0], e[1], e[2]);

              case 4:
                return new t(e[0], e[1], e[2], e[3]);
            }

            var n = [null];
            return i(d, n, e), new (i(c, t, n))();
          }

          var o = r.prototype,
              l = p(s(o) ? o : y),
              g = i(t, l, e);
          return s(g) ? g : l;
        }
      });
    },
    7495: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(7323);
      n({
        target: "RegExp",
        proto: !0,
        forced: /./.exec !== o
      }, {
        exec: o
      });
    },
    8781: (t, e, r) => {
      "use strict";

      var n = r(350).PROPER,
          o = r(6840),
          i = r(8551),
          c = r(655),
          a = r(9039),
          u = r(1034),
          s = "toString",
          p = RegExp.prototype,
          l = p[s],
          f = a(function () {
        return "/a/b" !== l.call({
          source: "a",
          flags: "b"
        });
      }),
          y = n && l.name !== s;
      (f || y) && o(p, s, function () {
        var t = i(this);
        return "/" + c(t.source) + "/" + c(u(t));
      }, {
        unsafe: !0
      });
    },
    2405: (t, e, r) => {
      "use strict";

      r(6468)("Set", function (t) {
        return function () {
          return t(this, arguments.length ? arguments[0] : void 0);
        };
      }, r(6938));
    },
    1415: (t, e, r) => {
      "use strict";

      r(2405);
    },
    4298: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(7240);
      n({
        target: "String",
        proto: !0,
        forced: r(3061)("fixed")
      }, {
        fixed: function () {
          return o(this, "tt", "", "");
        }
      });
    },
    1699: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9504),
          i = r(2892),
          c = r(7750),
          a = r(655),
          u = r(1436),
          s = o("".indexOf);
      n({
        target: "String",
        proto: !0,
        forced: !u("includes")
      }, {
        includes: function (t) {
          return !!~s(a(c(this)), a(i(t)), arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    },
    7764: (t, e, r) => {
      "use strict";

      var n = r(8183).charAt,
          o = r(655),
          i = r(1181),
          c = r(1088),
          a = r(2529),
          u = "String Iterator",
          s = i.set,
          p = i.getterFor(u);
      c(String, "String", function (t) {
        s(this, {
          type: u,
          string: o(t),
          index: 0
        });
      }, function () {
        var t,
            e = p(this),
            r = e.string,
            o = e.index;
        return o >= r.length ? a(void 0, !0) : (t = n(r, o), e.index += t.length, a(t, !1));
      });
    },
    1761: (t, e, r) => {
      "use strict";

      var n = r(9565),
          o = r(9228),
          i = r(8551),
          c = r(4117),
          a = r(8014),
          u = r(655),
          s = r(7750),
          p = r(5966),
          l = r(7829),
          f = r(6682);
      o("match", function (t, e, r) {
        return [function (e) {
          var r = s(this),
              o = c(e) ? void 0 : p(e, t);
          return o ? n(o, e, r) : new RegExp(e)[t](u(r));
        }, function (t) {
          var n = i(this),
              o = u(t),
              c = r(e, n, o);
          if (c.done) return c.value;
          if (!n.global) return f(n, o);
          var s = n.unicode;
          n.lastIndex = 0;

          for (var p, y = [], d = 0; null !== (p = f(n, o));) {
            var h = u(p[0]);
            y[d] = h, "" === h && (n.lastIndex = l(o, a(n.lastIndex), s)), d++;
          }

          return 0 === d ? null : y;
        }];
      });
    },
    5440: (t, e, r) => {
      "use strict";

      var n = r(8745),
          o = r(9565),
          i = r(9504),
          c = r(9228),
          a = r(9039),
          u = r(8551),
          s = r(4901),
          p = r(4117),
          l = r(1291),
          f = r(8014),
          y = r(655),
          d = r(7750),
          h = r(7829),
          m = r(5966),
          g = r(2478),
          v = r(6682),
          b = r(8227)("replace"),
          O = Math.max,
          P = Math.min,
          j = i([].concat),
          w = i([].push),
          k = i("".indexOf),
          R = i("".slice),
          A = "$0" === "a".replace(/./, "$0"),
          D = !!/./[b] && "" === /./[b]("a", "$0");
      c("replace", function (t, e, r) {
        var i = D ? "$" : "$0";
        return [function (t, r) {
          var n = d(this),
              i = p(t) ? void 0 : m(t, b);
          return i ? o(i, t, n, r) : o(e, y(n), t, r);
        }, function (t, o) {
          var c = u(this),
              a = y(t);

          if ("string" == typeof o && -1 === k(o, i) && -1 === k(o, "$<")) {
            var p = r(e, c, a, o);
            if (p.done) return p.value;
          }

          var d = s(o);
          d || (o = y(o));
          var m,
              b = c.global;
          b && (m = c.unicode, c.lastIndex = 0);

          for (var A, D = []; null !== (A = v(c, a)) && (w(D, A), b);) "" === y(A[0]) && (c.lastIndex = h(a, f(c.lastIndex), m));

          for (var _, x = "", S = 0, C = 0; C < D.length; C++) {
            for (var E, N = y((A = D[C])[0]), B = O(P(l(A.index), a.length), 0), M = [], F = 1; F < A.length; F++) w(M, void 0 === (_ = A[F]) ? _ : String(_));

            var T = A.groups;

            if (d) {
              var I = j([N], M, B, a);
              void 0 !== T && w(I, T), E = y(n(o, void 0, I));
            } else E = g(N, a, B, M, T, o);

            B >= S && (x += R(a, S, B) + E, S = B + N.length);
          }

          return x + R(a, S);
        }];
      }, !!a(function () {
        var t = /./;
        return t.exec = function () {
          var t = [];
          return t.groups = {
            a: "7"
          }, t;
        }, "7" !== "".replace(t, "$<a>");
      }) || !A || D);
    },
    744: (t, e, r) => {
      "use strict";

      var n = r(9565),
          o = r(9504),
          i = r(9228),
          c = r(8551),
          a = r(4117),
          u = r(7750),
          s = r(2293),
          p = r(7829),
          l = r(8014),
          f = r(655),
          y = r(5966),
          d = r(6682),
          h = r(8429),
          m = r(9039),
          g = h.UNSUPPORTED_Y,
          v = Math.min,
          b = o([].push),
          O = o("".slice),
          P = !m(function () {
        var t = /(?:)/,
            e = t.exec;

        t.exec = function () {
          return e.apply(this, arguments);
        };

        var r = "ab".split(t);
        return 2 !== r.length || "a" !== r[0] || "b" !== r[1];
      }),
          j = "c" === "abbc".split(/(b)*/)[1] || 4 !== "test".split(/(?:)/, -1).length || 2 !== "ab".split(/(?:ab)*/).length || 4 !== ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length;
      i("split", function (t, e, r) {
        var o = "0".split(void 0, 0).length ? function (t, r) {
          return void 0 === t && 0 === r ? [] : n(e, this, t, r);
        } : e;
        return [function (e, r) {
          var i = u(this),
              c = a(e) ? void 0 : y(e, t);
          return c ? n(c, e, i, r) : n(o, f(i), e, r);
        }, function (t, n) {
          var i = c(this),
              a = f(t);

          if (!j) {
            var u = r(o, i, a, n, o !== e);
            if (u.done) return u.value;
          }

          var y = s(i, RegExp),
              h = i.unicode,
              m = (i.ignoreCase ? "i" : "") + (i.multiline ? "m" : "") + (i.unicode ? "u" : "") + (g ? "g" : "y"),
              P = new y(g ? "^(?:" + i.source + ")" : i, m),
              w = void 0 === n ? 4294967295 : n >>> 0;
          if (0 === w) return [];
          if (0 === a.length) return null === d(P, a) ? [a] : [];

          for (var k = 0, R = 0, A = []; R < a.length;) {
            P.lastIndex = g ? 0 : R;

            var D,
                _ = d(P, g ? O(a, R) : a);

            if (null === _ || (D = v(l(P.lastIndex + (g ? R : 0)), a.length)) === k) R = p(a, R, h);else {
              if (b(A, O(a, k, R)), A.length === w) return A;

              for (var x = 1; x <= _.length - 1; x++) if (b(A, _[x]), A.length === w) return A;

              R = k = D;
            }
          }

          return b(A, O(a, k)), A;
        }];
      }, j || !P, g);
    },
    8718: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(7240);
      n({
        target: "String",
        proto: !0,
        forced: r(3061)("sub")
      }, {
        sub: function () {
          return o(this, "sub", "", "");
        }
      });
    },
    2762: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(3802).trim;
      n({
        target: "String",
        proto: !0,
        forced: r(706)("trim")
      }, {
        trim: function () {
          return o(this);
        }
      });
    },
    6761: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(4576),
          i = r(9565),
          c = r(9504),
          a = r(6395),
          u = r(3724),
          s = r(4495),
          p = r(9039),
          l = r(9297),
          f = r(1625),
          y = r(8551),
          d = r(5397),
          h = r(6969),
          m = r(655),
          g = r(6980),
          v = r(2360),
          b = r(1072),
          O = r(8480),
          P = r(298),
          j = r(3717),
          w = r(7347),
          k = r(4913),
          R = r(6801),
          A = r(8773),
          D = r(6840),
          _ = r(2106),
          x = r(5745),
          S = r(6119),
          C = r(421),
          E = r(3392),
          N = r(8227),
          B = r(1951),
          M = r(511),
          F = r(8242),
          T = r(687),
          I = r(1181),
          L = r(9213).forEach,
          $ = S("hidden"),
          V = "Symbol",
          Y = "prototype",
          q = I.set,
          U = I.getterFor(V),
          z = Object[Y],
          J = o.Symbol,
          G = J && J[Y],
          H = o.RangeError,
          K = o.TypeError,
          Q = o.QObject,
          W = w.f,
          Z = k.f,
          X = P.f,
          tt = A.f,
          et = c([].push),
          rt = x("symbols"),
          nt = x("op-symbols"),
          ot = x("wks"),
          it = !Q || !Q[Y] || !Q[Y].findChild,
          ct = function (t, e, r) {
        var n = W(z, e);
        n && delete z[e], Z(t, e, r), n && t !== z && Z(z, e, n);
      },
          at = u && p(function () {
        return 7 !== v(Z({}, "a", {
          get: function () {
            return Z(this, "a", {
              value: 7
            }).a;
          }
        })).a;
      }) ? ct : Z,
          ut = function (t, e) {
        var r = rt[t] = v(G);
        return q(r, {
          type: V,
          tag: t,
          description: e
        }), u || (r.description = e), r;
      },
          st = function (t, e, r) {
        t === z && st(nt, e, r), y(t);
        var n = h(e);
        return y(r), l(rt, n) ? (r.enumerable ? (l(t, $) && t[$][n] && (t[$][n] = !1), r = v(r, {
          enumerable: g(0, !1)
        })) : (l(t, $) || Z(t, $, g(1, v(null))), t[$][n] = !0), at(t, n, r)) : Z(t, n, r);
      },
          pt = function (t, e) {
        y(t);
        var r = d(e),
            n = b(r).concat(dt(r));
        return L(n, function (e) {
          u && !i(lt, r, e) || st(t, e, r[e]);
        }), t;
      },
          lt = function (t) {
        var e = h(t),
            r = i(tt, this, e);
        return !(this === z && l(rt, e) && !l(nt, e)) && (!(r || !l(this, e) || !l(rt, e) || l(this, $) && this[$][e]) || r);
      },
          ft = function (t, e) {
        var r = d(t),
            n = h(e);

        if (r !== z || !l(rt, n) || l(nt, n)) {
          var o = W(r, n);
          return !o || !l(rt, n) || l(r, $) && r[$][n] || (o.enumerable = !0), o;
        }
      },
          yt = function (t) {
        var e = X(d(t)),
            r = [];
        return L(e, function (t) {
          l(rt, t) || l(C, t) || et(r, t);
        }), r;
      },
          dt = function (t) {
        var e = t === z,
            r = X(e ? nt : d(t)),
            n = [];
        return L(r, function (t) {
          !l(rt, t) || e && !l(z, t) || et(n, rt[t]);
        }), n;
      };

      s || (D(G = (J = function () {
        if (f(G, this)) throw new K("Symbol is not a constructor");

        var t = arguments.length && void 0 !== arguments[0] ? m(arguments[0]) : void 0,
            e = E(t),
            r = function (t) {
          var n = void 0 === this ? o : this;
          n === z && i(r, nt, t), l(n, $) && l(n[$], e) && (n[$][e] = !1);
          var c = g(1, t);

          try {
            at(n, e, c);
          } catch (t) {
            if (!(t instanceof H)) throw t;
            ct(n, e, c);
          }
        };

        return u && it && at(z, e, {
          configurable: !0,
          set: r
        }), ut(e, t);
      })[Y], "toString", function () {
        return U(this).tag;
      }), D(J, "withoutSetter", function (t) {
        return ut(E(t), t);
      }), A.f = lt, k.f = st, R.f = pt, w.f = ft, O.f = P.f = yt, j.f = dt, B.f = function (t) {
        return ut(N(t), t);
      }, u && (_(G, "description", {
        configurable: !0,
        get: function () {
          return U(this).description;
        }
      }), a || D(z, "propertyIsEnumerable", lt, {
        unsafe: !0
      }))), n({
        global: !0,
        constructor: !0,
        wrap: !0,
        forced: !s,
        sham: !s
      }, {
        Symbol: J
      }), L(b(ot), function (t) {
        M(t);
      }), n({
        target: V,
        stat: !0,
        forced: !s
      }, {
        useSetter: function () {
          it = !0;
        },
        useSimple: function () {
          it = !1;
        }
      }), n({
        target: "Object",
        stat: !0,
        forced: !s,
        sham: !u
      }, {
        create: function (t, e) {
          return void 0 === e ? v(t) : pt(v(t), e);
        },
        defineProperty: st,
        defineProperties: pt,
        getOwnPropertyDescriptor: ft
      }), n({
        target: "Object",
        stat: !0,
        forced: !s
      }, {
        getOwnPropertyNames: yt
      }), F(), T(J, V), C[$] = !0;
    },
    9463: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(3724),
          i = r(4576),
          c = r(9504),
          a = r(9297),
          u = r(4901),
          s = r(1625),
          p = r(655),
          l = r(2106),
          f = r(7740),
          y = i.Symbol,
          d = y && y.prototype;

      if (o && u(y) && (!("description" in d) || void 0 !== y().description)) {
        var h = {},
            m = function () {
          var t = arguments.length < 1 || void 0 === arguments[0] ? void 0 : p(arguments[0]),
              e = s(d, this) ? new y(t) : void 0 === t ? y() : y(t);
          return "" === t && (h[e] = !0), e;
        };

        f(m, y), m.prototype = d, d.constructor = m;
        var g = "Symbol(description detection)" === String(y("description detection")),
            v = c(d.valueOf),
            b = c(d.toString),
            O = /^Symbol\((.*)\)[^)]+$/,
            P = c("".replace),
            j = c("".slice);
        l(d, "description", {
          configurable: !0,
          get: function () {
            var t = v(this);
            if (a(h, t)) return "";
            var e = b(t),
                r = g ? j(e, 7, -1) : P(e, O, "$1");
            return "" === r ? void 0 : r;
          }
        }), n({
          global: !0,
          constructor: !0,
          forced: !0
        }, {
          Symbol: m
        });
      }
    },
    1510: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(7751),
          i = r(9297),
          c = r(655),
          a = r(5745),
          u = r(1296),
          s = a("string-to-symbol-registry"),
          p = a("symbol-to-string-registry");
      n({
        target: "Symbol",
        stat: !0,
        forced: !u
      }, {
        for: function (t) {
          var e = c(t);
          if (i(s, e)) return s[e];
          var r = o("Symbol")(e);
          return s[e] = r, p[r] = e, r;
        }
      });
    },
    2675: (t, e, r) => {
      "use strict";

      r(6761), r(1510), r(7812), r(3110), r(9773);
    },
    7812: (t, e, r) => {
      "use strict";

      var n = r(6518),
          o = r(9297),
          i = r(757),
          c = r(6823),
          a = r(5745),
          u = r(1296),
          s = a("symbol-to-string-registry");
      n({
        target: "Symbol",
        stat: !0,
        forced: !u
      }, {
        keyFor: function (t) {
          if (!i(t)) throw new TypeError(c(t) + " is not a symbol");
          if (o(s, t)) return s[t];
        }
      });
    },
    3500: (t, e, r) => {
      "use strict";

      var n = r(4576),
          o = r(7400),
          i = r(9296),
          c = r(235),
          a = r(6699),
          u = function (t) {
        if (t && t.forEach !== c) try {
          a(t, "forEach", c);
        } catch (e) {
          t.forEach = c;
        }
      };

      for (var s in o) o[s] && u(n[s] && n[s].prototype);

      u(i);
    },
    2953: (t, e, r) => {
      "use strict";

      var n = r(4576),
          o = r(7400),
          i = r(9296),
          c = r(3792),
          a = r(6699),
          u = r(687),
          s = r(8227)("iterator"),
          p = c.values,
          l = function (t, e) {
        if (t) {
          if (t[s] !== p) try {
            a(t, s, p);
          } catch (e) {
            t[s] = p;
          }
          if (u(t, e, !0), o[e]) for (var r in c) if (t[r] !== c[r]) try {
            a(t, r, c[r]);
          } catch (e) {
            t[r] = c[r];
          }
        }
      };

      for (var f in o) l(n[f] && n[f].prototype, f);

      l(i, "DOMTokenList");
    },
    2375: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/account_reference","anyOf":[{"$ref":"./account_reference/v0"},{"$ref":"./account_reference/v1"}]}');
    },
    3482: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/account_reference/v0","type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":["null","string"]},"fullName":{"type":"string"},"client_path":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":["null","string"]}},"required":["id","serial","name"],"additionalProperties":false}},"clientPath":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"fullName":{"type":["null","string"]}},"required":["id","serial","name"],"additionalProperties":false}}},"required":["id","serial","name"],"additionalProperties":false}');
    },
    6306: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/account_reference/v1","type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":"string"},"client_path":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":"string"}},"required":["type","id","serial","name","full_name"],"additionalProperties":false}}},"required":["type","id","serial","name","full_name","client_path"],"additionalProperties":false}');
    },
    5897: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/crop_label","oneOf":[{"$ref":"./crop_label/v0"},{"$ref":"./crop_label/v1"}]}');
    },
    3768: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/crop_label/v0","type":"object","properties":{"type":{"enum":["IF2::Product::CropLabel","IF2::ProductCropLabel"]},"id":{"type":"string"},"serial":{"type":"integer"},"application_methods":{"type":"array","items":{"type":"string"}},"crop":{"type":["null","string"]},"crop_id":{"type":["null","string"]},"max_applications_per_year":{"type":["null","integer"]},"max_per_application":{"type":["null","string"]},"max_per_year":{"type":["null","string"]},"max_spray_rate":{"type":["null","string"]},"min_spray_rate":{"type":["null","string"]},"min_treatment_interval":{"type":["null","string"]},"product_id":{"type":["null","integer"]},"phi":{"type":["null","string"]},"rei":{"type":"string"},"old_crop_snapshot":{"type":["null","object"]},"special_conditions":{"oneOf":[{"type":"object","additionalProperties":{"type":"string"}},{"type":"null"}]},"updated_at":{"type":"string"},"created_at":{"type":"string"},"updatedAt":{"type":"string"},"createdAt":{"type":"string"}},"required":["type","id","serial","application_methods","crop","phi","rei","updated_at","created_at"],"additionalProperties":false}');
    },
    1355: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/crop_label/v1","type":"object","properties":{"schema":{"const":"if2/product/crop_label/v1"},"type":{"const":"IF2::Product::CropLabel"},"id":{"type":"string"},"serial":{"type":"integer"},"application_methods":{"type":"array","items":{"type":"string"}},"crop":{"type":"string"},"max_applications_per_year":{"type":["null","integer"]},"max_per_application":{"type":["null","string"]},"max_per_year":{"type":["null","string"]},"max_spray_rate":{"type":["null","string"]},"min_spray_rate":{"type":["null","string"]},"min_treatment_interval":{"type":["null","string"]},"product_id":{"type":"integer"},"phi":{"type":["null","string"]},"rei":{"type":"string"},"special_conditions":{"oneOf":[{"type":"object","additionalProperties":{"type":"string"}},{"type":"null"}]},"updated_at":{"type":"string"},"created_at":{"type":"string"}},"required":["schema","type","id","serial","product_id","phi","rei","min_spray_rate","max_per_application","max_per_year","special_conditions","application_methods","max_applications_per_year","min_treatment_interval","max_spray_rate","crop","updated_at","created_at"],"additionalProperties":false}');
    },
    824: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/field","oneOf":[{"$ref":"./field/v0"},{"$ref":"./field/v1"}]}');
    },
    5067: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/field/geo_json","anyOf":[{"type":"null"},{"type":"object","properties":{"type":{"type":"string"}},"required":["type"]}]}');
    },
    8115: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/field/v0","type":"object","properties":{"type":{"const":"IF2::Field"},"id":{"type":"string"},"serial":{"type":"integer"},"created_at":{"type":"string"},"createdAt":{"type":"string"},"updated_at":{"type":"string"},"updatedAt":{"type":"string"},"name":{"type":"string"},"area":{"type":"string"},"acres":{"type":"null"},"row_spacing":{"type":["string","null"]},"rowSpacing":{"type":["string","null"]},"plant_spacing":{"type":["string","null"]},"plantSpacing":{"type":["string","null"]},"tree_density":{"type":["string","null"]},"treeDensity":{"type":["string","null"]},"irrigation_rate":{"type":["string","null"]},"irrigationRate":{"type":["string","null"]},"elevation":{"type":["string","null"]},"county":{"type":["string","null"]},"notes":{"type":["string","null"]},"accounting_reference":{"type":["string","null"]},"accountingReference":{"type":["string","null"]},"nearest_region":{"type":["string","null"]},"nearestRegion":{"type":["string","null"]},"harvest_lot":{"type":["string","null"]},"harvestLot":{"type":["string","null"]},"previous_crop":{"type":["string","null"]},"previousCrop":{"type":["string","null"]},"year_planted":{"type":["integer","string","null"]},"yearPlanted":{"type":["integer","string","null"]},"latitude":{"type":["string","null"]},"longitude":{"type":["string","null"]},"geo_json":{"oneOf":[{"$ref":"./geo_json"},{"type":"string"}]},"geoJson":{"oneOf":[{"$ref":"./geo_json"},{"type":"string"}]},"inactive":{"type":"boolean"},"non_bearing":{"type":"boolean"},"nonBearing":{"type":"boolean"},"acid_water_treatment":{"type":"boolean"},"acidWaterTreatment":{"type":"boolean"},"organic":{"type":"boolean"},"transitional":{"type":"boolean"},"organic_date":{"type":["string","null"]},"organicDate":{"type":["string","null"]},"transitional_date":{"type":["string","null"]},"transitionalDate":{"type":["string","null"]},"account":{"$ref":"https://schemas.miriamtech.com/if2/account_reference"},"crop":{"$ref":"#/$defs/crop_reference"},"varieties":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"root_stocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"rootStocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"cultivars":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"use_types":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"useTypes":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}}},"required":["type","id","serial","created_at","updated_at","name","area","row_spacing","county","notes","year_planted","latitude","longitude","geo_json","organic","organic_date","account","crop"],"additionalProperties":false,"$defs":{"crop_reference":{"type":"object","properties":{"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"varieties":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"root_stocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"rootStocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"cultivars":{"type":"array","items":{"$ref":"#/$defs/cultivar_reference"}},"use_types":{"type":"array","items":{"oneOf":[{"$ref":"#/$defs/presentation_reference"},{"type":"string"}]}},"useTypes":{"type":"array","items":{"oneOf":[{"$ref":"#/$defs/presentation_reference"},{"type":"string"}]}}},"required":["id","name"],"additionalProperties":false},"presentation_percentage_reference":{"type":"object","properties":{"name":{"type":"string"},"percentage":{"oneOf":[{"type":"number","minimum":0,"maximum":1},{"type":"string"},{"type":"null"}]},"percent":{"type":["string","null"]}},"required":["name"],"additionalProperties":false},"presentation_reference":{"type":"object","properties":{"name":{"type":"string"}},"required":["name"],"additionalProperties":false},"cultivar_reference":{"type":"object","properties":{"name":{"type":"string"},"variety":{"type":["null","string"]}},"required":["name"],"additionalProperties":false}}}');
    },
    7776: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/field/v1","type":"object","properties":{"schema":{"const":"if2/field/v1"},"type":{"const":"IF2::Field"},"id":{"type":"string"},"serial":{"type":"integer"},"created_at":{"type":"string"},"createdAt":{"type":"string"},"updated_at":{"type":"string"},"updatedAt":{"type":"string"},"name":{"type":"string"},"area":{"type":"string"},"row_spacing":{"type":["string","null"]},"rowSpacing":{"type":["string","null"]},"plant_spacing":{"type":["string","null"]},"plantSpacing":{"type":["string","null"]},"tree_density":{"type":["string","null"]},"treeDensity":{"type":["string","null"]},"irrigation_rate":{"type":["string","null"]},"irrigationRate":{"type":["string","null"]},"elevation":{"type":["string","null"]},"county":{"type":["string","null"]},"notes":{"type":["string","null"]},"accounting_reference":{"type":["string","null"]},"accountingReference":{"type":["string","null"]},"nearest_region":{"type":["string","null"]},"nearestRegion":{"type":["string","null"]},"harvest_lot":{"type":["string","null"]},"harvestLot":{"type":["string","null"]},"previous_crop":{"type":["string","null"]},"previousCrop":{"type":["string","null"]},"year_planted":{"type":["integer","null"]},"yearPlanted":{"type":["integer","null"]},"latitude":{"type":["string","null"]},"longitude":{"type":["string","null"]},"geo_json":{"$ref":"./geo_json"},"geoJson":{"$ref":"./geo_json"},"inactive":{"type":"boolean"},"non_bearing":{"type":"boolean"},"nonBearing":{"type":"boolean"},"acid_water_treatment":{"type":"boolean"},"acidWaterTreatment":{"type":"boolean"},"organic":{"type":"boolean"},"transitional":{"type":"boolean"},"organic_date":{"type":["string","null"]},"organicDate":{"type":["string","null"]},"transitional_date":{"type":["string","null"]},"transitionalDate":{"type":["string","null"]},"account":{"$ref":"https://schemas.miriamtech.com/if2/account_reference"},"crop":{"$ref":"#/$defs/crop_reference"},"varieties":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"root_stocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"rootStocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"cultivars":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"use_types":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"useTypes":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}}},"required":["schema","type","id","serial","created_at","updated_at","name","area","row_spacing","plant_spacing","tree_density","irrigation_rate","elevation","county","notes","accounting_reference","nearest_region","harvest_lot","previous_crop","year_planted","latitude","longitude","geo_json","inactive","non_bearing","acid_water_treatment","organic","transitional","organic_date","transitional_date","account","crop"],"additionalProperties":false,"$defs":{"crop_reference":{"type":"object","properties":{"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"varieties":{"type":"array","items":{"$ref":"#/$defs/crop_presentation_percentage_reference"}},"root_stocks":{"type":"array","items":{"$ref":"#/$defs/crop_presentation_percentage_reference"}},"rootStocks":{"type":"array","items":{"$ref":"#/$defs/crop_presentation_percentage_reference"}},"cultivars":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"use_types":{"type":"array","items":{"type":"string"}},"useTypes":{"type":"array","items":{"type":"string"}}},"required":["id","name"],"additionalProperties":false},"presentation_percentage_reference":{"type":"object","properties":{"name":{"type":"string"},"percentage":{"oneOf":[{"type":"number","minimum":0,"maximum":1},{"type":"null"}]}},"required":["name","percentage"],"additionalProperties":false},"crop_presentation_percentage_reference":{"type":"object","properties":{"name":{"type":"string"},"percentage":{"type":["string","null"]},"percent":{"type":["string","null"]}},"required":["name","percent"],"additionalProperties":false},"presentation_reference":{"type":"object","properties":{"name":{"type":"string"}},"required":["name"],"additionalProperties":false}}}');
    },
    9991: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/license","oneOf":[{"$ref":"./license/v0"},{"$ref":"./license/v1"}]}');
    },
    2490: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/license/v0","type":"object","properties":{"type":{"type":"string"},"serial":{"type":"integer"},"agency":{"type":"string"},"number":{"type":"string"},"createdAt":{"type":"string"},"updatedAt":{"type":"string"}},"required":["type","serial","agency","number","createdAt","updatedAt"],"additionalProperties":false}');
    },
    2197: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/license/v1","type":"object","properties":{"schema":{"const":"if2/license/v1"},"type":{"type":"string"},"serial":{"type":"integer"},"agency":{"type":"string"},"number":{"type":"string"},"created_at":{"type":"string"},"updated_at":{"type":"string"}},"required":["schema","type","serial","agency","number","created_at","updated_at"],"additionalProperties":false}');
    },
    6228: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/mode_of_action","oneOf":[{"$ref":"./mode_of_action/v0"},{"$ref":"./mode_of_action/v1"}]}');
    },
    1607: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/mode_of_action/v0","type":"object","properties":{"type":{"const":"IF2::ModeOfAction"},"id":{"type":"string"},"action":{"type":"string"},"group_number":{"type":"string"},"description":{"type":"string"},"parent":{"oneOf":[{"type":"null"},{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"group_number":{"type":"string"},"description":{"type":"string"}},"required":["type","id","group_number","description"],"additionalProperties":false}]}},"required":["type","id","action","group_number","description"],"additionalProperties":false}');
    },
    2564: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/mode_of_action/v1","type":"object","properties":{"schema":{"const":"if2/mode_of_action/v1"},"type":{"const":"IF2::ModeOfAction"},"id":{"type":"string"},"action":{"type":"string"},"group_number":{"type":"string"},"description":{"type":"string"},"parent":{"oneOf":[{"type":"null"},{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"group_number":{"type":"string"},"description":{"type":"string"}},"required":["type","id","group_number","description"],"additionalProperties":false}]}},"required":["schema","type","id","action","group_number","description","parent"],"additionalProperties":false}');
    },
    6915: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/organic_listing","oneOf":[{"$ref":"https://schemas.miriamtech.com/if2/product/organic_listing/v0"},{"$ref":"https://schemas.miriamtech.com/if2/product/organic_listing/v1"}]}');
    },
    3803: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/organic_listing/v0","type":"object","properties":{"type":{"enum":["IF2::Product::OrganicListing","IF2::ProductOrganicListing"]},"id":{"type":["null","string"]},"serial":{"type":"integer"},"reference":{"type":"string"},"agency":{"type":"string"},"number":{"type":"string"},"expires":{"type":["null","string"]},"certificate_url":{"type":["null","string"]},"product_id":{"type":["null","integer","string"]},"updated_at":{"type":["null","string"]},"created_at":{"type":["null","string"]},"updatedAt":{"type":["null","string"]},"createdAt":{"type":["null","string"]}},"required":["type","serial","reference","agency","number","expires"],"additionalProperties":false}');
    },
    6056: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/organic_listing/v1","type":"object","properties":{"schema":{"const":"if2/product/organic_listing/v1"},"type":{"const":"IF2::Product::OrganicListing"},"serial":{"type":"integer"},"reference":{"type":"string"},"agency":{"type":"string"},"number":{"type":"string"},"expires":{"type":["null","string"]},"updated_at":{"type":"string"},"created_at":{"type":"string"}},"required":["schema","type","serial","reference","agency","number","expires","updated_at","created_at"],"additionalProperties":false}');
    },
    8731: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product","oneOf":[{"$ref":"./product/v0"},{"$ref":"./product/v1"}]}');
    },
    6782: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/active_ingredient","anyOf":[{"$ref":"./active_ingredient/v0"},{"$ref":"./active_ingredient/v1"}]}');
    },
    5597: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/active_ingredient/v0","type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"name":{"type":"string"},"short_name":{"type":["null","string"]},"alternate_names":{"type":"array","items":{"type":"string"}},"percent":{"type":["null","string","number"]},"cas":{"type":["null","string"]},"pc_code":{"type":["null","string"]},"toxicity_category":{"type":["null","string"]},"toxicity_class":{"type":["null","string"]},"limited_by_espp":{"type":["null","boolean"]},"liquid_concentration":{"type":["null","string"]},"modes_of_action":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/mode_of_action"}},"mode_of_action":{"const":""}},"required":["id","name","cas"],"additionalProperties":false}');
    },
    8866: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/active_ingredient/v1","type":"object","properties":{"type":{"const":"IF2::ActiveIngredient"},"id":{"type":"string"},"name":{"type":"string"},"short_name":{"type":["null","string"]},"alternate_names":{"type":"array","items":{"type":"string"}},"percent":{"type":["null","number"]},"cas":{"type":["null","string"]},"pc_code":{"type":["null","string"]},"toxicity_category":{"type":["null","string"]},"toxicity_class":{"type":["null","string"]},"limited_by_espp":{"type":"boolean"},"liquid_concentration":{"type":["null","string"]},"modes_of_action":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/mode_of_action"}}},"required":["type","id","name","short_name","alternate_names","cas","pc_code","limited_by_espp","modes_of_action","toxicity_category","toxicity_class"],"additionalProperties":false}');
    },
    6845: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/attachment","oneOf":[{"$ref":"./attachment/v0"},{"$ref":"./attachment/v1"}]}');
    },
    372: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/attachment/v0","allOf":[{"type":"object","properties":{"type":{"const":"IF2::Product::Attachment"},"id":{"type":"null"},"serial":{"type":"integer"},"product_id":{"type":"integer"},"title":{"type":"string"},"filename":{"type":["null","string"]},"url":{"type":"string"},"updated_at":{"type":"string"},"created_at":{"type":"string"},"updatedAt":{"type":"string"},"createdAt":{"type":"string"}},"required":["serial","product_id","title","filename","url"],"additionalProperties":false},{"oneOf":[{"required":["updated_at","created_at"]},{"required":["updatedAt","createdAt"]}]}]}');
    },
    9095: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/attachment/v1","type":"object","properties":{"schema":{"const":"if2/product/attachment/v1"},"type":{"const":"IF2::Product::Attachment"},"serial":{"type":"integer"},"product_id":{"type":"integer"},"title":{"type":"string"},"filename":{"type":["null","string"]},"url":{"type":"string"},"updated_at":{"type":"string"},"created_at":{"type":"string"}},"required":["schema","type","serial","product_id","title","filename","url","updated_at","created_at"],"additionalProperties":false}');
    },
    6828: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/nutrient_analysis","type":"object","properties":{"al":{"type":["null","string"]},"b":{"type":["null","string"]},"ca":{"type":["null","string"]},"cu":{"type":["null","string"]},"fe":{"type":["null","string"]},"humicAcid":{"type":["null","string"]},"k":{"type":["null","string"]},"mg":{"type":["null","string"]},"mn":{"type":["null","string"]},"mo":{"type":["null","string"]},"n":{"type":["null","string"]},"p":{"type":["null","string"]},"s":{"type":["null","string"]},"si":{"type":["null","string"]},"zn":{"type":["null","string"]}},"required":["al","b","ca","cu","fe","humicAcid","k","mg","mn","mo","n","p","s","si","zn"],"additionalProperties":false}');
    },
    7366: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/v0","allOf":[{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"account":{"oneOf":[{"$ref":"https://schemas.miriamtech.com/if2/account_reference"},{"type":"null"}]},"account_id":{"type":"null"},"ache_inhibitor":{"type":"boolean"},"alternate_names":{"type":"array","items":{"type":"string"}},"alternateNames":{"type":"array","items":{"type":"string"}},"bee_hazard":{"type":["null","string"]},"epa_number":{"type":["null","string"]},"epaNumber":{"type":["null","string"]},"registration_number":{"type":["null","string"]},"state_registration":{"oneOf":[{"type":"object","additionalProperties":{"type":"string"}},{"type":"null"}]},"attachments":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/attachment"}},"organic_listings":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/organic_listing"}},"crop_labels":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/crop_label"}},"formulation":{"oneOf":[{"type":"object","properties":{"type":{"type":["null","string"]},"base_unit":{"type":["null","string"]},"description":{"type":["null","string"]}},"required":["type","base_unit","description"],"additionalProperties":false},{"type":"null"}]},"nutrient_analysis":{"oneOf":[{"$ref":"https://schemas.miriamtech.com/if2/product/nutrient_analysis"},{"type":"null"}]},"nutrientAnalysis":{"oneOf":[{"$ref":"https://schemas.miriamtech.com/if2/product/nutrient_analysis"},{"type":"null"}]},"inactive":{"type":"boolean"},"organic":{"type":"boolean"},"target_rates_required":{"type":"boolean"},"label_source":{"type":"string"},"attached_label_filename":{"type":"string"},"label_url":{"type":["null","string"]},"sds_source":{"type":"string"},"attached_sds_filename":{"type":"string"},"sds_url":{"type":["null","string"]},"manufacturer":{"type":["null","string"]},"mass_per_volume":{"type":["null","string"]},"notes":{"type":["null","string"]},"product_type":{"type":["null","string"]},"productType":{"type":["null","string"]},"signal_word":{"type":["null","string"]},"signalWord":{"type":["null","string"]},"use":{"type":["null","string"]},"deprecated_active_ingredients":{"type":"array","items":{"type":"object"}},"active_ingredients":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/active_ingredient"}},"activeIngredients":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/active_ingredient"}},"legacy":{"type":"object"},"reviewed_by":{"type":["null","object"]},"reviewed_at":{"type":["null","string"]},"reviewedAt":{"type":["null","string"]},"created_at":{"type":"string"},"createdAt":{"type":"string"},"updated_at":{"type":"string"},"updatedAt":{"type":"string"}},"required":["type","id","serial","name","bee_hazard","state_registration","inactive","label_url","sds_url","manufacturer","notes","use"],"additionalProperties":false},{"oneOf":[{"required":["alternate_names","epa_number","product_type","reviewed_at","signal_word","created_at","updated_at"]},{"required":["alternateNames","epaNumber","productType","reviewedAt","signalWord","createdAt","updatedAt"]}]}]}');
    },
    4721: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/v1","type":"object","properties":{"schema":{"const":"if2/product/v1"},"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"account":{"oneOf":[{"$ref":"https://schemas.miriamtech.com/if2/account_reference"},{"type":"null"}]},"ache_inhibitor":{"type":"boolean"},"alternate_names":{"type":"array","items":{"type":"string"}},"bee_hazard":{"type":["null","string"]},"epa_number":{"type":["null","string"]},"registration_number":{"type":["null","string"]},"state_registration":{"oneOf":[{"type":"object","additionalProperties":{"type":"string"}},{"type":"null"}]},"attachments":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/attachment"}},"organic_listings":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/organic_listing"}},"crop_labels":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/crop_label"}},"formulation":{"oneOf":[{"type":"object","properties":{"type":{"type":["null","string"]},"base_unit":{"type":["null","string"]},"description":{"type":["null","string"]}},"required":["type","base_unit","description"],"additionalProperties":false},{"type":"null"}]},"nutrient_analysis":{"oneOf":[{"$ref":"https://schemas.miriamtech.com/if2/product/nutrient_analysis"},{"type":"null"}]},"inactive":{"type":"boolean"},"organic":{"type":"boolean"},"target_rates_required":{"type":"boolean"},"label_url":{"type":["null","string"]},"sds_url":{"type":["null","string"]},"manufacturer":{"type":["null","string"]},"mass_per_volume":{"type":["null","string"]},"notes":{"type":["null","string"]},"product_type":{"type":["null","string"]},"signal_word":{"type":["null","string"]},"use":{"type":["null","string"]},"active_ingredients":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/active_ingredient"}},"reviewed_at":{"type":["null","string"]},"created_at":{"type":"string"},"updated_at":{"type":"string"}},"required":["schema","type","id","serial","name","account","ache_inhibitor","target_rates_required","alternate_names","bee_hazard","epa_number","state_registration","registration_number","inactive","label_url","sds_url","manufacturer","mass_per_volume","notes","organic","product_type","signal_word","use","active_ingredients","attachments","organic_listings","reviewed_at","created_at","updated_at"],"additionalProperties":false}');
    },
    479: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation","oneOf":[{"$ref":"./recommendation/v0"},{"$ref":"./recommendation/v1"}]}');
    },
    1412: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/accounts","type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/account_reference"}}');
    },
    4687: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/approved","oneOf":[{"type":"object","properties":{"at":{"type":"string"},"by":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"}},"required":["id","serial","name"],"additionalProperties":false}},"required":["at","by"],"additionalProperties":false},{"type":"null"}]}');
    },
    7489: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/fields","type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/field"}}');
    },
    3852: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/product_application","oneOf":[{"$ref":"./product_application/v0"},{"$ref":"./product_application/v1"}]}');
    },
    2847: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/product_application/v0","type":"object","properties":{"type":{"const":"IF2::Recommendation::ProductApplication"},"id":{"type":["null","string"]},"serial":{"type":["null","string","integer"]},"created_at":{"type":["null","string"]},"updated_at":{"type":["null","string"]},"application_method":{"type":["null","string"]},"crop_names":{"type":"array","items":{"type":"string"}},"notes":{"type":["null","string"]},"position":{"type":["null","integer"]},"rate":{"type":["null","string"]},"target":{"type":["null","string"]},"rei":{"const":""},"phi":{"const":""},"product":{"$ref":"https://schemas.miriamtech.com/if2/product"}},"required":["rate","target","product"],"additionalProperties":false}');
    },
    9308: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/product_application/v1","type":"object","properties":{"schema":{"const":"if2/recommendation/product_application/v1"},"type":{"const":"IF2::Recommendation::ProductApplication"},"id":{"type":"string"},"serial":{"type":["null","integer"]},"created_at":{"type":["null","string"]},"updated_at":{"type":["null","string"]},"application_method":{"type":["null","string"]},"crop_names":{"type":"array","items":{"type":"string"}},"notes":{"type":["null","string"]},"position":{"type":["null","integer"]},"rate":{"type":["null","string"]},"target":{"type":["null","string"]},"product":{"$ref":"https://schemas.miriamtech.com/if2/product"}},"required":["schema","type","id","serial","created_at","updated_at","application_method","crop_names","notes","position","rate","target","product"],"additionalProperties":false}');
    },
    9286: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/rejected","oneOf":[{"type":"object","properties":{"at":{"type":"string"},"reason":{"type":"string"},"by":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"}},"required":["id","serial","name"],"additionalProperties":false}},"required":["at","reason","by"],"additionalProperties":false},{"type":"null"}]}');
    },
    9589: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/replaces","oneOf":[{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":["null","integer"]},"name":{"type":"string"},"date":{"type":"string"},"status":{"$ref":"https://schemas.miriamtech.com/if2/recommendation/status"},"account_id":{"type":"string"},"written_by_id":{"type":"string"},"accounts":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":"string"}},"required":["type","id","serial","name","full_name"],"additionalProperties":false}}},"required":["type","id","name","date","status","account_id","accounts","written_by_id"],"additionalProperties":false},{"type":"null"}]}');
    },
    5142: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/status","enum":["draft","complete","void","rejected","replaced","pending-approval"]}');
    },
    5538: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/v0","type":"object","properties":{"type":{"const":"IF2::Recommendation"},"id":{"type":"string"},"serial":{"type":["null","integer"]},"created_at":{"type":"string"},"updated_at":{"type":"string"},"name":{"type":["null","string"]},"document_number":{"type":["null","string"]},"notes":{"type":["null","string"]},"coverage":{"type":["null","string","number"]},"phi":{"const":""},"rei":{"const":""},"written_by":{"$ref":"#/$defs/user_reference_with_licenses"},"account":{"$ref":"https://schemas.miriamtech.com/if2/account_reference"},"accounts":{"oneOf":[{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/account_reference"}},{"type":"null"}]},"replaces":{"oneOf":[{"$ref":"#/$defs/recommendation_reference"},{"type":"null"}]},"copied_from":{"type":["null","object"]},"date":{"oneOf":[{"type":"string","format":"date"},{"type":"null"}]},"areas_to_treat":{"type":["null","string"]},"timing":{"type":["null","string"]},"optimum_temperature":{"type":["null","string"]},"crop_names":{"type":"array","items":{"type":"string"}},"organic":{"type":"boolean"},"application_method":{"type":["null","string"]},"target_rate":{"type":["null","string"]},"tank_size":{"type":["null","string"]},"status":{"$ref":"#/$defs/status"},"product_applications":{"type":"array","items":{"$ref":"./product_application"}},"fields":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/field"}},"approved":{"$ref":"https://schemas.miriamtech.com/if2/recommendation/approved"},"rejected":{"$ref":"https://schemas.miriamtech.com/if2/recommendation/rejected"},"show_nutrient_totals":{"type":"boolean"},"show_product_totals":{"type":"boolean"},"show_map_when_printing":{"type":"boolean"},"use_per_applied_acre_verbiage":{"type":"boolean"},"target_gallons_per_acre":{"type":"string"}},"required":["type","id","created_at","updated_at","name","document_number","written_by","account","date","timing","optimum_temperature","crop_names","organic","application_method","target_rate","tank_size","status","product_applications","fields","notes"],"additionalProperties":false,"$defs":{"user_reference_with_licenses":{"type":"object","properties":{"type":{"const":"IF2::User"},"id":{"type":"string"},"serial":{"type":["null","string","integer"]},"name":{"type":"string"},"licenses":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/license"}}},"required":["id","name"],"additionalProperties":false},"recommendation_reference":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":["null","integer"]},"name":{"type":["null","string"]},"date":{"type":["null","string"]},"status":{"$ref":"#/$defs/status"},"account_id":{"type":["null","string"]},"written_by_id":{"type":["null","string"]},"accounts":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":["null","string"]}},"required":["type","id","serial","name","full_name"],"additionalProperties":false}}},"required":["type","id","account_id","written_by_id"],"additionalProperties":false},"status":{"oneOf":[{"enum":["draft","complete","void","voided","replaced","pending-approval"]},{"type":"null"}]}}}');
    },
    5245: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/v1","type":"object","properties":{"schema":{"const":"if2/recommendation/v1"},"type":{"const":"IF2::Recommendation"},"id":{"type":"string"},"serial":{"type":["null","integer"]},"created_at":{"type":"string"},"updated_at":{"type":"string"},"name":{"type":["null","string"]},"document_number":{"type":["null","string"]},"notes":{"type":["null","string"]},"coverage":{"type":"number","minimum":0,"maximum":1},"written_by":{"$ref":"./written_by"},"account":{"$ref":"https://schemas.miriamtech.com/if2/account_reference"},"accounts":{"$ref":"./accounts"},"replaces":{"$ref":"https://schemas.miriamtech.com/if2/recommendation/replaces"},"date":{"type":"string","format":"date"},"areas_to_treat":{"type":["null","string"]},"timing":{"type":["null","string"]},"optimum_temperature":{"type":["null","string"]},"crop_names":{"type":"array","items":{"type":"string"}},"organic":{"type":"boolean"},"application_method":{"type":["null","string"]},"target_rate":{"type":["null","string"]},"tank_size":{"type":["null","string"]},"status":{"$ref":"https://schemas.miriamtech.com/if2/recommendation/status"},"product_applications":{"type":"array","items":{"$ref":"./product_application"}},"fields":{"$ref":"./fields"},"approved":{"$ref":"https://schemas.miriamtech.com/if2/recommendation/approved"},"rejected":{"$ref":"https://schemas.miriamtech.com/if2/recommendation/rejected"},"show_nutrient_totals":{"type":"boolean"},"show_product_totals":{"type":"boolean"},"show_map_when_printing":{"type":"boolean"},"use_per_applied_acre_verbiage":{"type":"boolean"}},"required":["schema","type","id","serial","created_at","updated_at","name","document_number","written_by","account","accounts","replaces","date","areas_to_treat","timing","optimum_temperature","crop_names","organic","application_method","target_rate","tank_size","status","product_applications","fields","notes","coverage","approved","rejected","show_nutrient_totals","show_product_totals","show_map_when_printing","use_per_applied_acre_verbiage"],"additionalProperties":false}');
    },
    2511: t => {
      "use strict";

      t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/written_by","type":"object","properties":{"type":{"const":"IF2::User"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"licenses":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/license"}}},"required":["type","id","serial","name","licenses"],"additionalProperties":false}');
    }
  },
      u = {};

  function s(t) {
    var e = u[t];
    if (void 0 !== e) return e.exports;
    var r = u[t] = {
      exports: {}
    };
    return a[t].call(r.exports, r, r.exports, s), r.exports;
  }

  s.n = t => {
    var e = t && t.__esModule ? () => t.default : () => t;
    return s.d(e, {
      a: e
    }), e;
  }, s.d = (t, e) => {
    for (var r in e) s.o(e, r) && !s.o(t, r) && Object.defineProperty(t, r, {
      enumerable: !0,
      get: e[r]
    });
  }, s.g = function () {
    if ("object" == typeof globalThis) return globalThis;

    try {
      return this || new Function("return this")();
    } catch (t) {
      if ("object" == typeof window) return window;
    }
  }(), s.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), s.r = t => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  };
  var p = {};
  return (() => {
    "use strict";

    function t(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function e(t, r) {
      return e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
        return t.__proto__ = e, t;
      }, e(t, r);
    }

    function r(t, r) {
      if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(r && r.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(t, "prototype", {
        writable: !1
      }), r && e(t, r);
    }

    function n(t) {
      return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, n(t);
    }

    function o(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function i(t, e) {
      if (e && ("object" == n(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return o(t);
    }

    function c(t) {
      return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, c(t);
    }

    function a() {
      try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (t) {}

      return (a = function () {
        return !!t;
      })();
    }

    function u(t) {
      var r = "function" == typeof Map ? new Map() : void 0;
      return u = function (t) {
        if (null === t || !function (t) {
          try {
            return -1 !== Function.toString.call(t).indexOf("[native code]");
          } catch (e) {
            return "function" == typeof t;
          }
        }(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== r) {
          if (r.has(t)) return r.get(t);
          r.set(t, n);
        }

        function n() {
          return function (t, r, n) {
            if (a()) return Reflect.construct.apply(null, arguments);
            var o = [null];
            o.push.apply(o, r);
            var i = new (t.bind.apply(t, o))();
            return n && e(i, n.prototype), i;
          }(t, arguments, c(this).constructor);
        }

        return n.prototype = Object.create(t.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e(n, t);
      }, u(t);
    }

    s.r(p), s.d(p, {
      AbstractValidation: () => oe,
      AccountReference: () => je,
      AccountWithPath: () => Re,
      ActiveIngredient: () => Be,
      ApplicatorBase: () => lr,
      Contact: () => ur,
      ContactAddress: () => $e,
      ContactEmail: () => qe,
      ContactInfoItem: () => Te,
      ContactPhone: () => Je,
      Cultivar: () => yr,
      Failure: () => ne,
      Feature: () => Nr,
      FeatureBuilder: () => Tr,
      FeatureCollection: () => Fr,
      FeatureGeometry: () => Dr,
      FeatureGeometryBase: () => gr,
      Field: () => fn,
      FieldCompletion: () => hn,
      FieldCropCultivar: () => Yr,
      FieldCropReference: () => Kr,
      FieldCropRootStock: () => zr,
      FieldCropVariety: () => Vr,
      FieldReference: () => vn,
      FieldVariety: () => Zr,
      Formulation: () => Pn,
      GeoJSON: () => Ir,
      GeoJSONBase: () => dr,
      GeoJsonError: () => f,
      IF2JSModelSchemaValidator: () => Zt,
      IF2JsModelError: () => l,
      IncompatibleBaseUnitError: () => b,
      InvalidFeatureError: () => y,
      InvalidGeoJsonError: () => d,
      InvalidSchemaMigrationError: () => g,
      MassPerVolumeRequiredForLiquidProductsError: () => O,
      MissingBaseUnitError: () => v,
      Mix: () => kt,
      MixInto: () => wt,
      ModeOfAction: () => Ce,
      ModelReference: () => ve,
      MultiPolygonGeometry: () => wr,
      NutrientAnalysis: () => Sn,
      OrganicListing: () => Mn,
      OrganicProductValidation: () => Ln,
      PointGeometry: () => Ar,
      PolygonGeometry: () => Or,
      Presence: () => de,
      Product: () => Zn,
      ProductApplicationBase: () => po,
      ProductApplicationCalculation: () => Oo,
      ProductAttachment: () => Kn,
      ProductCropLabel: () => qn,
      ProductLabelValidation: () => Po,
      ProductRecommendationNote: () => So,
      ProductReference: () => oo,
      Quantity: () => ye,
      QuantityComparison: () => he,
      QuantityPresence: () => me,
      Recommendation: () => pi,
      RecommendationProductApplication: () => go,
      RecommendationReference: () => Fo,
      Reject: () => Vo,
      RootStock: () => en,
      Spec: () => et,
      SprayRecord: () => Mi,
      SprayRecordApplication: () => wi,
      SprayRecordApplicator: () => Oi,
      SprayRecordProductApplication: () => Ai,
      SprayRecordRecommendationReference: () => Ei,
      Sprayer: () => Ke,
      Spreader: () => Ze,
      TargetRateRequiredForPerVolumeProductsError: () => P,
      Team: () => Vi,
      TeamApplicator: () => Ii,
      Tractor: () => or,
      UnparsableUnitsError: () => h,
      UnsupportedGeometryTypeError: () => m,
      UpdatableBase: () => ge,
      UseType: () => cn,
      UserReference: () => ko,
      UserReferenceWithLicenses: () => Do,
      activatableMixin: () => ee,
      applicationMethodAttributeMixin: () => zt,
      bulletListString: () => Ct,
      caseInsensitiveSort: () => _t,
      checkableCollectionMixin: () => J,
      checkableMixin: () => Y,
      decimalToPercentString: () => Nt,
      editableMixin: () => G,
      expandableCollectionMixin: () => H,
      find: () => bt,
      findMany: () => Ot,
      genericSort: () => Rt,
      hideableMixin: () => re,
      highlightableMixin: () => te,
      humanize: () => Bt,
      idAttributeMixin: () => x,
      includesAll: () => ht,
      includesAny: () => mt,
      isString: () => xt,
      listString: () => Et,
      loadingStatusCollectionMixin: () => Yt,
      loggableMixin: () => Z,
      nameAttributeMixin: () => E,
      naturalSort: () => At,
      percentStringToDecimal: () => St,
      push: () => Pt,
      remove: () => jt,
      reportableMixin: () => ut,
      schemaAttributeMixin: () => Qt,
      schemaMixin: () => Xt,
      selectableMixin: () => st,
      serialAttributeMixin: () => M,
      sortByName: () => Dt,
      timestampAttributesMixin: () => ft,
      toJS: () => Mt,
      truncateZeros: () => Ft,
      typeAttributeMixin: () => I,
      uniq: () => yt,
      uniqBy: () => dt,
      updatableMixin: () => It,
      validatableMixin: () => Vt
    }), s(825), s(2010);

    var l = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        return t(this, u), (r = a.call(this, e)).name = r.constructor.name, r;
      }

      return u;
    }(u(Error));

    var f = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return u;
    }(l);

    var y = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.call(this, "Invalid GeoJSON feature");
      }

      return u;
    }(f);

    var d = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.call(this, "Invalid GeoJSON");
      }

      return u;
    }(f);

    var h = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        return t(this, u), a.call(this, "Unable to parse units: '".concat(e, "'"));
      }

      return u;
    }(l);

    var m = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        return t(this, u), (r = a.call(this, "Unsupported GeoJSON geometry type: '".concat(e, "'"))).type = e, r;
      }

      return u;
    }(f);

    var g = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        return t(this, u), a.call(this, "Schema migration for schema '".concat(e, "' did not change the schema"));
      }

      return u;
    }(l);

    var v = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        return t(this, u), (r = a.call(this, "Missing base unit for ".concat(null == e ? void 0 : e.name))).product = e, r;
      }

      return u;
    }(u(Error));

    s(8706);

    var b = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e, r) {
        var n, o;
        return t(this, u), (o = a.call(this, "Incompatible base unit ".concat((null == e || null === (n = e.formulation) || void 0 === n ? void 0 : n.baseUnit) || "", " with ").concat(r))).product = e, o;
      }

      return u;
    }(u(Error));

    var O = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e, r) {
        var n;
        return t(this, u), (n = a.call(this, "Mass per Volume is required on liquid products when calculating poundsPerAcre. ".concat(null == e ? void 0 : e.name, " does not have a massPerVolume"))).product = e, n.rate = r, n;
      }

      return u;
    }(u(Error));

    var P = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e, r) {
        var n;
        return t(this, u), (n = a.call(this, 'Target Rate required for productPerAcre calculation for "per volume" products.')).product = e, n.rate = r, n;
      }

      return u;
    }(u(Error));

    function j(t) {
      var e = function (t) {
        if ("object" != n(t) || !t) return t;
        var e = t[Symbol.toPrimitive];

        if (void 0 !== e) {
          var r = e.call(t, "string");
          if ("object" != n(r)) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return String(t);
      }(t);

      return "symbol" == n(e) ? e : e + "";
    }

    function w(t, e, r) {
      return (e = j(e)) in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function k(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, j(n.key), n);
      }
    }

    function R(t, e, r) {
      return e && k(t.prototype, e), r && k(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
    }

    function A() {
      return A = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (t, e, r) {
        var n = function (t, e) {
          for (; !{}.hasOwnProperty.call(t, e) && null !== (t = c(t)););

          return t;
        }(t, e);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(arguments.length < 3 ? t : r) : o.value;
        }
      }, A.apply(null, arguments);
    }

    function D(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function _(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? D(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : D(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    s(9432), s(2675), s(2008), s(3851), s(1629), s(3500), s(1278), s(7945), s(4185);

    var x = function (e) {
      return function (e) {
        r(u, e);
        var n,
            o,
            a = (n = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (o) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function u() {
          return t(this, u), a.apply(this, arguments);
        }

        return R(u, null, [{
          key: "getAttributeDefinition",
          value: function () {
            return _(_({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
              id: {
                name: "ID",
                key: "id",
                type: "string"
              }
            });
          }
        }]), u;
      }(e);
    };

    function S(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function C(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? S(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : S(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var E = function (e) {
      return function (e) {
        r(u, e);
        var n,
            o,
            a = (n = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (o) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function u() {
          return t(this, u), a.apply(this, arguments);
        }

        return R(u, null, [{
          key: "getAttributeDefinition",
          value: function () {
            return C(C({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
              name: {
                name: "Name",
                key: "name",
                type: "string"
              }
            });
          }
        }]), u;
      }(e);
    };

    function N(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function B(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? N(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : N(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var M = function (e) {
      return function (e) {
        r(u, e);
        var n,
            o,
            a = (n = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (o) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function u() {
          return t(this, u), a.apply(this, arguments);
        }

        return R(u, null, [{
          key: "getAttributeDefinition",
          value: function () {
            return B(B({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
              serial: {
                name: "Serial",
                key: "serial",
                type: "number"
              }
            });
          }
        }]), u;
      }(e);
    };

    function F(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function T(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? F(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : F(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var I = function (e) {
      return function (e) {
        r(u, e);
        var n,
            o,
            a = (n = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (o) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function u() {
          return t(this, u), a.apply(this, arguments);
        }

        return R(u, null, [{
          key: "getAttributeDefinition",
          value: function () {
            return T(T({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
              type: {
                name: "Type",
                key: "type",
                type: "string"
              }
            });
          }
        }]), u;
      }(e);
    };

    function L(t, e, r, n) {
      r && Object.defineProperty(t, e, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function $(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(t, e, i), null) : i;
    }

    var V = s(5314);

    var Y = function (e) {
      var n, a;
      return n = function (e) {
        r(p, e);
        var n,
            u,
            s = (n = p, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function p() {
          var e;
          t(this, p);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          return L(o(e = s.call.apply(s, [this].concat(n))), "isChecked", a, o(e)), e;
        }

        return R(p, [{
          key: "check",
          value: function () {
            this.isChecked = !0;
          }
        }, {
          key: "unCheck",
          value: function () {
            this.isChecked = !1;
          }
        }, {
          key: "toggleChecked",
          value: function () {
            this.isChecked = !this.isChecked;
          }
        }]), p;
      }(e), a = $(n.prototype, "isChecked", [V.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), $(n.prototype, "check", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "check"), n.prototype), $(n.prototype, "unCheck", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "unCheck"), n.prototype), $(n.prototype, "toggleChecked", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "toggleChecked"), n.prototype), n;
    };

    function q(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var r = 0, n = Array(e); r < e; r++) n[r] = t[r];

      return n;
    }

    function U(t, e) {
      if (t) {
        if ("string" == typeof t) return q(t, e);
        var r = {}.toString.call(t).slice(8, -1);
        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? q(t, e) : void 0;
      }
    }

    function z(t) {
      return function (t) {
        if (Array.isArray(t)) return q(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || U(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    s(3792), s(6099), s(2953), s(6033), s(7764);

    var J = function (e) {
      var n, a;
      return n = function (e) {
        r(p, e);
        var n,
            u,
            s = (n = p, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function p() {
          var e;
          t(this, p);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          return L(o(e = s.call.apply(s, [this].concat(n))), "_checked", a, o(e)), e;
        }

        return R(p, [{
          key: "checked",
          get: function () {
            return z(this._checked.keys());
          }
        }, {
          key: "numChecked",
          get: function () {
            return this._checked.size;
          }
        }, {
          key: "isChecked",
          value: function (t) {
            return this._checked.has(t);
          }
        }, {
          key: "toggleChecked",
          value: function (t) {
            this.isChecked(t) ? this.unCheck(t) : this.check(t);
          }
        }, {
          key: "checkMany",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e.check(t);
            });
          }
        }, {
          key: "unCheckMany",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e.unCheck(t);
            });
          }
        }, {
          key: "check",
          value: function (t) {
            this._checked.set(t, !0);
          }
        }, {
          key: "unCheck",
          value: function (t) {
            this._checked.delete(t);
          }
        }, {
          key: "setCheck",
          value: function (t, e) {
            e ? this.check(t) : this.unCheck(t);
          }
        }, {
          key: "unCheckAll",
          value: function () {
            this._checked.clear();
          }
        }]), p;
      }(e), a = $(n.prototype, "_checked", [V.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new Map();
        }
      }), $(n.prototype, "checked", [V.computed], Object.getOwnPropertyDescriptor(n.prototype, "checked"), n.prototype), $(n.prototype, "numChecked", [V.computed], Object.getOwnPropertyDescriptor(n.prototype, "numChecked"), n.prototype), $(n.prototype, "toggleChecked", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "toggleChecked"), n.prototype), $(n.prototype, "checkMany", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "checkMany"), n.prototype), $(n.prototype, "unCheckMany", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "unCheckMany"), n.prototype), $(n.prototype, "check", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "check"), n.prototype), $(n.prototype, "unCheck", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "unCheck"), n.prototype), $(n.prototype, "setCheck", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "setCheck"), n.prototype), $(n.prototype, "unCheckAll", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "unCheckAll"), n.prototype), n;
    };

    var G = function (e) {
      var n, a;
      return n = function (e) {
        r(p, e);
        var n,
            u,
            s = (n = p, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function p() {
          var e;
          t(this, p);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          return L(o(e = s.call.apply(s, [this].concat(n))), "isBeingEdited", a, o(e)), e;
        }

        return R(p, [{
          key: "openEdit",
          value: function () {
            this.isBeingEdited = !0;
          }
        }, {
          key: "closeEdit",
          value: function () {
            this.isBeingEdited = !1;
          }
        }, {
          key: "toggleEdit",
          value: function () {
            this.isBeingEdited = !this.isBeingEdited;
          }
        }]), p;
      }(e), a = $(n.prototype, "isBeingEdited", [V.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), $(n.prototype, "openEdit", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "openEdit"), n.prototype), $(n.prototype, "closeEdit", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "closeEdit"), n.prototype), $(n.prototype, "toggleEdit", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "toggleEdit"), n.prototype), n;
    };

    var H = function (e) {
      var n, a;
      return n = function (e) {
        r(p, e);
        var n,
            u,
            s = (n = p, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function p() {
          var e;
          t(this, p);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          return L(o(e = s.call.apply(s, [this].concat(n))), "_expanded", a, o(e)), e;
        }

        return R(p, [{
          key: "expanded",
          get: function () {
            return z(this._expanded.keys());
          }
        }, {
          key: "toggleExpanded",
          value: function (t) {
            this.isCollapsed(t) ? this.expand(t) : this.collapse(t);
          }
        }, {
          key: "expandMany",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e.expand(t);
            });
          }
        }, {
          key: "collapseMany",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e.collapse(t);
            });
          }
        }, {
          key: "expand",
          value: function (t) {
            this._expanded.set(t, !0);
          }
        }, {
          key: "collapse",
          value: function (t) {
            this._expanded.delete(t);
          }
        }, {
          key: "isExpanded",
          value: function (t) {
            return this._expanded.has(t);
          }
        }, {
          key: "isCollapsed",
          value: function (t) {
            return !this._expanded.has(t);
          }
        }, {
          key: "setExpand",
          value: function (t, e) {
            e ? this.expand(t) : this.collapse(t);
          }
        }, {
          key: "collapseAll",
          value: function () {
            this._expanded.clear();
          }
        }]), p;
      }(e), a = $(n.prototype, "_expanded", [V.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new Map();
        }
      }), $(n.prototype, "expanded", [V.computed], Object.getOwnPropertyDescriptor(n.prototype, "expanded"), n.prototype), $(n.prototype, "toggleExpanded", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "toggleExpanded"), n.prototype), $(n.prototype, "expandMany", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "expandMany"), n.prototype), $(n.prototype, "collapseMany", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "collapseMany"), n.prototype), $(n.prototype, "expand", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "expand"), n.prototype), $(n.prototype, "collapse", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "collapse"), n.prototype), $(n.prototype, "setExpand", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "setExpand"), n.prototype), $(n.prototype, "collapseAll", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "collapseAll"), n.prototype), n;
    };

    var K,
        Q,
        W,
        Z = function (e) {
      var n, o;
      return o = n = function (e) {
        r(u, e);
        var n,
            o,
            a = (n = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (o) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function u() {
          return t(this, u), a.apply(this, arguments);
        }

        return R(u, [{
          key: "logger",
          get: function () {
            return this.constructor.logger;
          }
        }], [{
          key: "setLogger",
          value: function (t) {
            this.logger = t;
          }
        }, {
          key: "resetLogger",
          value: function () {
            this.logger = console;
          }
        }]), u;
      }(e), w(n, "logger", console), o;
    },
        X = (s(2712), s(2062), s(4346), s(4871)),
        tt = s(7315),
        et = (s(113), s(4423), s(1699), s(6034), W = Q = function () {
      function e(r) {
        var n = this;
        t(this, e), w(this, "accessorsForKey", function (t) {
          return n.constructor.accessorsForAttribute(n.findAttribute(t));
        }), this.attributeDefinition = (null == r ? void 0 : r.attributeDefinition) || {}, this.defaultKey = (null == r ? void 0 : r.defaultKey) || "name";
      }

      return R(e, [{
        key: "findAttribute",
        value: function (t) {
          return Array.isArray(this.attributes) && this.attributes.find(function (e) {
            return [e.key, e.jsKey].includes(t);
          }) || void 0;
        }
      }, {
        key: "accessors",
        get: function () {
          return (0, X.flatten)((0, X.map)(this.constructor.accessorsForAttribute, this.attributes));
        }
      }, {
        key: "attributes",
        get: function () {
          return Object.values(this.attributeDefinition || {});
        }
      }, {
        key: "defaultAccessor",
        get: function () {
          var t = (0, X.head)((0, X.flatten)([this.accessorsForKey(this.defaultKey)]));
          if (null != t && t.attribute) return ["model", "modelCollection"].includes(t.attribute.type) ? this.constructor.descendantAccessor(t.attribute.modelClass.spec.defaultAccessor, t.attribute.key) : t;
        }
      }]), e;
    }(), w(Q, "accessorsForAttribute", function (t) {
      return t ? ["model", "modelCollection"].includes(t.type) ? Q.expandDescendantAccessors(t) : {
        path: [t.key],
        attribute: t
      } : {
        path: [],
        attribute: t
      };
    }), w(Q, "descendantAccessor", function (t, e) {
      return {
        path: [e].concat(t.path),
        attribute: t.attribute
      };
    }), w(Q, "expandDescendantAccessors", function (t) {
      return [{
        path: [t.key],
        attribute: t
      }, t.modelClass.spec.accessors.map(function (e) {
        return Q.descendantAccessor(e, t.key);
      })];
    }), $((K = W).prototype, "accessors", [V.computed], Object.getOwnPropertyDescriptor(K.prototype, "accessors"), K.prototype), $(K.prototype, "attributes", [V.computed], Object.getOwnPropertyDescriptor(K.prototype, "attributes"), K.prototype), $(K.prototype, "defaultAccessor", [V.computed], Object.getOwnPropertyDescriptor(K.prototype, "defaultAccessor"), K.prototype), K);

    function rt(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function nt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? rt(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : rt(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var ot = (0, X.path)(["attribute", "key"]),
        it = function (t) {
      return (0, X.compose)(function (e) {
        return (0, X.merge)(e, {
          path: [t].concat(e.path)
        });
      }, function (t) {
        return t.attribute.modelClass.spec.defaultAccessor;
      }, (0, X.find)(function (e) {
        return e.attribute.key === t;
      }));
    },
        ct = function (t) {
      return function (e) {
        return (0, X.compose)(X.uniq, (0, X.map)(function (t) {
          return (0, X.merge)(t, {
            path: (0, X.tail)(t.path)
          });
        }), (0, X.concat)([it(t)(e)]), function (t) {
          return (0, X.filter)(function (e) {
            return e.path.length > 1 && e.path[0] === t;
          });
        }(t))(e);
      };
    },
        at = (0, X.curry)(function (t, e) {
      return (0, X.map)(function (t) {
        return (0, X.objOf)(e, t);
      }, t);
    }),
        ut = function (e) {
      return function (e) {
        r(s, e);
        var n,
            a,
            u = (n = s, a = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (a) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function s() {
          var e;
          t(this, s);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          return w(o(e = u.call.apply(u, [this].concat(n))), "isReportable", !0), w(o(e), "mergeReportRows", (0, X.curry)(function (t, e) {
            return (0, X.flatten)(t).length < 1 ? e : t.reduce(function (t, e) {
              return (0, X.flatten)(t.length < 1 ? e : t.map(function (t) {
                return e.length < 1 ? t : e.map(function (e) {
                  return (0, X.mergeDeepRight)(t, e);
                });
              }));
            }, e);
          })), e;
        }

        return R(s, [{
          key: "accessorGroupsToReport",
          value: function (t) {
            var e = this,
                r = function (t) {
              var e = t.filter(function (t) {
                return 1 === t.path.length;
              });
              return (0, X.merge)({
                all: t
              }, (0, X.groupBy)(function (t) {
                return (0, X.pathEq)(["attribute", "type"], "modelCollection", t) ? "collections" : (0, X.pathEq)(["attribute", "type"], "model", t) ? "models" : "literals";
              })(e));
            }(t),
                n = function (t, e) {
              return (0, X.compose)((0, X.difference)(X.__, (0, X.map)(function (t) {
                return t.path[0];
              }, e.collections || [])), (0, X.map)(function (t) {
                return t.path[0];
              }), (0, X.filter)(function (t) {
                return t.path.length > 1;
              }))(t);
            }(t, r);

            return n.forEach(function (t) {
              var n = e.rootAccessorForKey(t);
              r.all.push(n), (0, X.propEq)("type", "modelCollection", n.attribute) && (r.collections = (0, X.compose)((0, X.filter)(Boolean), X.flatten, (0, X.concat)(r.collections || []))([n])), (0, X.propEq)("type", "model", n.attribute) && (r.models = (0, X.compose)((0, X.filter)(Boolean), X.flatten, (0, X.concat)(r.models || []))([n]));
            }), r;
          }
        }, {
          key: "reportLiterals",
          value: function (t) {
            return t ? [(0, X.pickAll)((0, X.map)(ot, (0, X.prop)("literals", t) || []).concat("id"), this)] : [];
          }
        }, {
          key: "reportCollections",
          value: function (t) {
            var e = this;
            return (0, X.map)((0, X.compose)(function (r) {
              return at((0, X.flatten)((0, X.map)(function (e) {
                return e.report(ct(r)(t.all));
              }, e[r])))(r);
            }, ot), (0, X.prop)("collections", t) || []);
          }
        }, {
          key: "reportModels",
          value: function (t) {
            var e = this;
            return (0, X.compose)((0, X.map)((0, X.compose)(function (r) {
              return at((0, X.flatten)(e[r].report(ct(r)(t.all))))(r);
            }, ot)), (0, X.reject)(function (t) {
              return !e[ot(t)];
            }))((0, X.prop)("models", t) || []);
          }
        }, {
          key: "rootAccessorForKey",
          value: function (t) {
            var e = this.constructor.spec.accessorsForKey(t);
            return Array.isArray(e) ? e[0] : e;
          }
        }, {
          key: "report",
          value: function (t) {
            var e = this,
                r = this.accessorGroupsToReport([].concat(t)),
                n = this.reportLiterals(r),
                o = this.reportCollections(r),
                i = this.reportModels(r);
            return (0, X.compose)((0, X.map)(function (t) {
              return nt(nt({}, t), {}, {
                _rowId: (0, tt.v4)(),
                model: e
              });
            }), this.mergeReportRows(i), this.mergeReportRows(o))(n);
          }
        }], [{
          key: "spec",
          get: function () {
            return new et({
              attributeDefinition: this.reportableAttributes,
              defaultKey: this.defaultKey
            });
          }
        }]), s;
      }(e);
    };

    var st = function (e) {
      var n, a;
      return n = function (e) {
        r(p, e);
        var n,
            u,
            s = (n = p, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function p() {
          var e;
          t(this, p);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          return L(o(e = s.call.apply(s, [this].concat(n))), "isSelected", a, o(e)), e;
        }

        return R(p, [{
          key: "select",
          value: function () {
            this.isSelected = !0;
          }
        }, {
          key: "deselect",
          value: function () {
            this.isSelected = !1;
          }
        }, {
          key: "toggleSelected",
          value: function () {
            this.isSelected = !this.isSelected;
          }
        }]), p;
      }(e), a = $(n.prototype, "isSelected", [V.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), $(n.prototype, "select", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "select"), n.prototype), $(n.prototype, "deselect", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "deselect"), n.prototype), $(n.prototype, "toggleSelected", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "toggleSelected"), n.prototype), n;
    };

    function pt(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function lt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? pt(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : pt(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var ft = function (e) {
      return function (e) {
        r(u, e);
        var n,
            o,
            a = (n = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (o) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function u() {
          return t(this, u), a.apply(this, arguments);
        }

        return R(u, null, [{
          key: "getAttributeDefinition",
          value: function () {
            return lt(lt({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
              createdAt: {
                name: "Created At",
                key: "createdAt",
                type: "string"
              },
              updatedAt: {
                name: "Updated At",
                key: "updatedAt",
                type: "string"
              }
            });
          }
        }]), u;
      }(e);
    },
        yt = (s(7495), s(5440), s(1415), s(3418), s(8431), function (t) {
      return z(new Set(t));
    }),
        dt = function (t, e) {
      return Array.from(new Map(e.map(function (e) {
        return [e[t], e];
      })).values());
    },
        ht = (0, X.curry)(function (t, e) {
      return t.every(function (t) {
        return e.includes(t);
      });
    }),
        mt = (0, X.curry)(function (t, e) {
      return (0, X.pipe)((0, X.intersection)(t), X.isEmpty, X.not)(e);
    });

    function gt(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function vt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? gt(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : gt(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    s(8980), s(4554);

    var bt = function (t, e, r) {
      var n = (r || {}).searchKey || "id";
      return t.find(function (t) {
        return t[n] === e;
      });
    },
        Ot = function (t, e) {
      var r = t.reduce(function (t, e) {
        return t.set(e.id, e), t;
      }, new Map());
      return e.reduce(function (t, e) {
        var n = r.get(e);
        return n && t.push(n), t;
      }, []);
    },
        Pt = function (t, e, r, n) {
      return (0, V.runInAction)(function () {
        var o = n || {},
            i = o.searchKey || "id",
            c = vt(vt({}, r), {}, {
          id: r.id || r._id
        }),
            a = bt(t, c[i], {
          searchKey: i
        });
        return a ? a.update(c) : (a = e(c), Object.keys(o.initProps || {}).forEach(function (t) {
          a[t] = o.initProps[t];
        }), (0, V.runInAction)(function () {
          return t.push(a);
        })), a;
      });
    },
        jt = function (t, e, r) {
      return (0, V.runInAction)(function () {
        var n = (r || {}).searchKey || "id",
            o = t.findIndex(function (t) {
          return t[n] === e;
        });
        if (o >= 0) return t.splice(o, 1)[0];
      });
    };

    var wt = (0, X.curry)((0, X.uncurryN)(2, function (e) {
      return function () {
        return function (e) {
          r(u, e);
          var n,
              o,
              a = (n = u, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
                e = c(n);

            if (o) {
              var r = c(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);

            return i(this, t);
          });

          function u() {
            return t(this, u), a.apply(this, arguments);
          }

          return u;
        }(X.pipe.apply(void 0, arguments)(e));
      };
    })),
        kt = wt(function e() {
      t(this, e);
    }),
        Rt = function (t, e) {
      return t < e ? -1 : t > e ? 1 : 0;
    },
        At = function (t, e) {
      return String(t).localeCompare(String(e), navigator.languages[0] || navigator.language, {
        numeric: !0,
        ignorePunctuation: !0
      });
    },
        Dt = function (t, e) {
      return t.name && e.name ? At(String(t.name).toLowerCase(), String(e.name).toLowerCase()) : 0;
    },
        _t = function (t, e) {
      return Rt(t.toLowerCase(), e.toLowerCase());
    },
        xt = (s(4782), s(8130), s(150), s(8598), s(9868), s(744), s(2762), function (t) {
      return "string" == typeof t || t instanceof String;
    }),
        St = function (t) {
      return xt(t) ? (e = "%" !== t.slice(-1) ? t : t.slice(0, -1), e = Number(e), Number.isNaN(e) ? null : e / 100) : null;
      var e;
    },
        Ct = function (t) {
      return t.map(function (t) {
        return "\t• ".concat(t);
      }).join("\n");
    },
        Et = function (t) {
      if (t.length < 2) return t[0] || "";
      var e = [].concat(t.slice(0, -2).join(", ") || []),
          r = t.slice(-2),
          n = e.length ? r.join(", and ") : r.join(" and ");
      return e.concat(n).join(", ");
    },
        Nt = function (t) {
      if (null == t || "" === t) return null;
      var e = Number(t);
      if (Number.isNaN(e)) return null;
      var r,
          n = 100 * e;
      return r = n >= 100 ? n.toFixed(0) : n.toFixed(2).replace(/\.?0*$/, ""), "".concat(r, "%");
    },
        Bt = function (t) {
      return t.replace(/([A-Z])/g, " $1").trim().split(" ").map(function (t) {
        return "".concat(t.slice(0, 1).toUpperCase()).concat(t.slice(1));
      }).join(" ");
    },
        Mt = (s(875), function t(e) {
      return e ? "function" == typeof e.slice && Array.isArray(e.slice()) ? e.slice().map(t) : "function" == typeof e.toJS ? e.toJS() : "object" === n(e) && Object.getPrototypeOf(e) === Object.prototype ? Object.keys(e).reduce(function (r, n) {
        return r[n] = t(e[n]), r;
      }, {}) : (0, V.toJS)(e) : (0, V.toJS)(e);
    }),
        Ft = function (t) {
      if (!Number.isNaN(Number(t))) return "".concat(t).replace(/\.0*$/, "").replace(/(\d*\.\d*[1-9])0+$/, "$1");
    };

    function Tt(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    var It = function (e) {
      var n, a, u, s;
      return s = u = function (e) {
        r(s, e);
        var n,
            a,
            u = (n = s, a = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (a) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function s() {
          var e;
          t(this, s);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          var c = (e = u.call.apply(u, [this].concat(n))).allAttributes.reduce(function (t, r) {
            var n,
                o,
                i = t;
            return i[r.key] = null !== (n = null !== (o = e[r.key]) && void 0 !== o ? o : r.defaultValue) && void 0 !== n ? n : e.constructor.defaultValueFor(r.type), i;
          }, {});
          return (0, V.extendObservable)(o(e), c), e;
        }

        return R(s, [{
          key: "allAttributes",
          get: function () {
            return this.constructor._allAttributes;
          }
        }, {
          key: "attributeDefinition",
          get: function () {
            return this.constructor.attributeDefinition;
          }
        }, {
          key: "_attributeMap",
          get: function () {
            var t = this;
            return this.allAttributes.reduce(function (e, r) {
              return e[r.key] = r, e[r.jsKey] = r, e[t.constructor.toSnakeCase(r.key)] = r, e;
            }, {});
          }
        }, {
          key: "attributes",
          get: function () {
            var t = this;
            return this.allAttributes.map(function (e) {
              return {
                key: e.key,
                value: t[e.key]
              };
            });
          }
        }, {
          key: "duplicate",
          value: function () {
            return new this.constructor(this.toJS());
          }
        }, {
          key: "findAttribute",
          value: function (t) {
            return this.attributeDefinition[t] || this._attributeMap[t];
          }
        }, {
          key: "serialize",
          value: function () {
            return console.warn("".concat(this.constructor.name, ".serialize() is deprecated! please use toJS() instead")), console.trace(), this.toJS();
          }
        }, {
          key: "toJS",
          value: function () {
            var t = this;
            return this.allAttributes.reduce(function (e, r) {
              if ("rev" === r.key) return e;
              var n = r.jsKey || t.constructor.toSnakeCase(r.key);
              return "string" === r.type ? (e[n] = t[r.key] || null, e) : "number" === r.type ? (e[n] = 0 === t[r.key] ? 0 : t[r.key] || null, e) : "model" === r.type && t[r.key] && "function" == typeof t[r.key].toJS ? (e[n] = t[r.key].toJS(), e) : "modelCollection" === r.type ? (e[n] = t[r.key].map(function (t) {
                return t && "function" == typeof t.toJS && t.toJS();
              }).filter(Boolean), e) : "array" === r.type ? (e[n] = Mt(t[r.key] || []), e) : "object" === r.type ? (e[n] = Mt(t[r.key]), e) : (e[n] = t[r.key], e);
            }, {});
          }
        }, {
          key: "toJSON",
          value: function () {
            return this.toJS();
          }
        }, {
          key: "defaultValueOf",
          value: function (t) {
            var e;
            return null === (e = this.findAttribute(t)) || void 0 === e ? void 0 : e.defaultValue;
          }
        }, {
          key: "updateFromDocument",
          value: function (t) {
            return this.constructor._validateDocument(t), this.update(this.constructor._migratedDocument(t), {
              fromDocument: !0
            });
          }
        }, {
          key: "update",
          value: function (t) {
            var e = this,
                r = Lt(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}),
                n = t || {},
                o = [],
                i = [],
                c = [];
            return Object.keys(n).forEach(function (t) {
              var r = e.findAttribute(t);
              r && ("string" !== r.type ? "boolean" !== r.type ? "number" !== r.type ? "array" !== r.type ? "object" !== r.type ? "model" !== r.type ? "modelCollection" === r.type && c.push({
                key: r.key,
                value: n[t],
                modelClass: r.modelClass,
                searchKey: r.searchKey || "id"
              }) : i.push({
                key: r.key,
                value: n[t],
                modelClass: r.modelClass
              }) : o.push({
                key: r.key,
                value: n[t]
              }) : o.push({
                key: r.key,
                value: n[t] || []
              }) : o.push({
                key: r.key,
                value: 0 === n[t] ? 0 : n[t] || ""
              }) : o.push({
                key: r.key,
                value: n[t] || !1
              }) : o.push({
                key: r.key,
                value: n[t] || ""
              }));
            }), this.updateSimpleAttributes(o), i.forEach(function (t) {
              return e.updateModelAttribute(t, r);
            }), this.updateModelCollectionAttributes(c, r), this;
          }
        }, {
          key: "updateSimpleAttributes",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e[t.key] = t.value;
            });
          }
        }, {
          key: "updateModelAttribute",
          value: function (t) {
            var e = Lt(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
            null != t.value ? this[t.key] = $t(t.modelClass, this[t.key], t.value, e) : this[t.key] = t.value;
          }
        }, {
          key: "updateCollectionAttributeElement",
          value: function (t, e) {
            var r = Lt(arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}),
                n = this[t.key].find(function (r) {
              return r[t.searchKey] === e[t.searchKey];
            });
            return $t(t.modelClass, n, e, r);
          }
        }, {
          key: "updateModelCollectionAttribute",
          value: function (t) {
            var e = this,
                r = Lt(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
            return (t.value || []).map(function (n) {
              return e.updateCollectionAttributeElement(t, n, r);
            });
          }
        }, {
          key: "updateModelCollectionAttributes",
          value: function (t) {
            var e = this,
                r = Lt(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
            t.forEach(function (t) {
              e[t.key] = e.updateModelCollectionAttribute(t, r);
            });
          }
        }], [{
          key: "defaultValueFor",
          value: function (t) {
            return {
              string: "",
              number: "",
              boolean: !1,
              array: [],
              modelCollection: []
            }[t];
          }
        }, {
          key: "toCamelCase",
          value: function (t) {
            return t.replace(/(_[a-z])/g, function (t) {
              return t[1].toUpperCase();
            });
          }
        }, {
          key: "toSnakeCase",
          value: function (t) {
            return t.replace(/([A-Z])/g, function (t) {
              return "_".concat(t.toLowerCase());
            });
          }
        }, {
          key: "getAttributeDefinition",
          value: function () {
            return this._attributeDefinition;
          }
        }, {
          key: "attributeDefinition",
          get: function () {
            return this.getAttributeDefinition();
          }
        }, {
          key: "_allAttributes",
          get: function () {
            return Object.values(this.attributeDefinition);
          }
        }, {
          key: "_migratedDocument",
          value: function (t) {
            return "function" == typeof this.migratedSchema ? this.migratedSchema(t) : t;
          }
        }, {
          key: "_validateDocument",
          value: function (t) {
            "function" == typeof this.validateSchema && this.validateSchema(t);
          }
        }, {
          key: "fromDocument",
          value: function (t) {
            var e = new this();
            return e.updateFromDocument(t), e;
          }
        }]), s;
      }(e), w(u, "_attributeDefinition", {}), $(n = s, "_attributeDefinition", [V.observable], (a = (a = Object.getOwnPropertyDescriptor(n, "_attributeDefinition")) ? a.value : void 0, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        initializer: function () {
          return a;
        }
      }), n), $(n.prototype, "allAttributes", [V.computed], Object.getOwnPropertyDescriptor(n.prototype, "allAttributes"), n.prototype), $(n.prototype, "attributeDefinition", [V.computed], Object.getOwnPropertyDescriptor(n.prototype, "attributeDefinition"), n.prototype), $(n.prototype, "_attributeMap", [V.computed], Object.getOwnPropertyDescriptor(n.prototype, "_attributeMap"), n.prototype), $(n.prototype, "attributes", [V.computed], Object.getOwnPropertyDescriptor(n.prototype, "attributes"), n.prototype), $(n.prototype, "update", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "update"), n.prototype), $(n.prototype, "updateSimpleAttributes", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "updateSimpleAttributes"), n.prototype), $(n.prototype, "updateModelAttribute", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "updateModelAttribute"), n.prototype), $(n.prototype, "updateCollectionAttributeElement", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "updateCollectionAttributeElement"), n.prototype), $(n.prototype, "updateModelCollectionAttribute", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "updateModelCollectionAttribute"), n.prototype), $(n.prototype, "updateModelCollectionAttributes", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "updateModelCollectionAttributes"), n.prototype), n;
    };

    function Lt(t) {
      return function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? Tt(Object(r), !0).forEach(function (e) {
            w(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Tt(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }({
        fromDocument: !1
      }, t || {});
    }

    function $t(t, e, r, n) {
      if (e) return n.fromDocument ? e.updateFromDocument(r) : e.update(r), e;
      var o = t;
      return n.fromDocument ? o.fromDocument(r) : new o(r);
    }

    s(6449);

    var Vt = function (e) {
      var n, o, a;
      return a = o = function (e) {
        r(u, e);
        var n,
            o,
            a = (n = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (o) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function u() {
          return t(this, u), a.apply(this, arguments);
        }

        return R(u, [{
          key: "allValidators",
          value: function () {
            return Object.values(this.validatorDefinition);
          }
        }, {
          key: "selectValidators",
          value: function (t) {
            var e = this;
            return null != t && t.length ? t.reduce(function (t, r) {
              var n = e.validatorDefinition[r];
              return n && t.push(n), t;
            }, []) : this.allValidators();
          }
        }, {
          key: "isValid",
          get: function () {
            return 0 === this.validate().length;
          }
        }, {
          key: "failures",
          value: function () {
            var t = this;
            return this.validations.map(function (e) {
              return e.failures(t);
            }).flat();
          }
        }, {
          key: "validate",
          value: function (t) {
            var e = this;
            return this.selectValidators(t).map(function (t) {
              if (t) {
                if ("function" == typeof t.validate) return t.validate();
                var r = e[t.key];
                if (!r) return {
                  key: t.key,
                  value: r,
                  msg: t.msg || e.constructor.blankErrorMsg
                };

                if ("model" === t.type && "validate" in r) {
                  var n = r.validate();
                  return null != n && n.length ? {
                    key: t.key,
                    type: "model",
                    value: n,
                    msg: t.msg || "model has invalid properties"
                  } : null;
                }

                if ("modelCollection" === t.type) {
                  if (null == r || !r.length) return {
                    key: t.key,
                    type: "modelCollection",
                    value: r,
                    msg: t.msg || e.constructor.blankErrorMsg
                  };
                  var o = r.map(function (t) {
                    if ("validate" in t) {
                      var e = t.validate();
                      if (!Array.isArray(e) || e.length) return e;
                    }
                  }).filter(Boolean);
                  return null != o && o.length ? {
                    key: t.key,
                    type: "modelCollection",
                    value: o,
                    msg: t.msg || "modelCollection has invalid models"
                  } : null;
                }

                return null;
              }
            }).filter(Boolean);
          }
        }]), u;
      }(e), w(o, "blankErrorMsg", "should not be blank"), $((n = a).prototype, "failures", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "failures"), n.prototype), $(n.prototype, "validate", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "validate"), n.prototype), n;
    };

    var Yt = function (e) {
      var n, a, u;
      return n = function (e) {
        r(l, e);
        var n,
            s,
            p = (n = l, s = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (s) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function l() {
          var e;
          t(this, l);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          return L(o(e = p.call.apply(p, [this].concat(n))), "_pending", a, o(e)), L(o(e), "_loaded", u, o(e)), e;
        }

        return R(l, [{
          key: "pending",
          get: function () {
            return z(this._pending.keys());
          }
        }, {
          key: "loaded",
          get: function () {
            return z(this._loaded.keys());
          }
        }, {
          key: "isPending",
          value: function (t) {
            return this._pending.has(t);
          }
        }, {
          key: "isLoaded",
          value: function (t) {
            return this._loaded.has(t);
          }
        }, {
          key: "setPending",
          value: function (t, e) {
            e ? this._pending.set(t, !0) : this._pending.delete(t);
          }
        }, {
          key: "setLoaded",
          value: function (t, e) {
            e ? this._loaded.set(t, !0) : this._loaded.delete(t);
          }
        }, {
          key: "finishPending",
          value: function (t) {
            this.setPending(t, !1), this.setLoaded(t, !0);
          }
        }]), l;
      }(e), a = $(n.prototype, "_pending", [V.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new Map();
        }
      }), u = $(n.prototype, "_loaded", [V.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new Map();
        }
      }), $(n.prototype, "pending", [V.computed], Object.getOwnPropertyDescriptor(n.prototype, "pending"), n.prototype), $(n.prototype, "loaded", [V.computed], Object.getOwnPropertyDescriptor(n.prototype, "loaded"), n.prototype), $(n.prototype, "setPending", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "setPending"), n.prototype), $(n.prototype, "setLoaded", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "setLoaded"), n.prototype), n;
    };

    function qt(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ut(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? qt(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qt(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    s(1761);

    var zt = function (e) {
      var n, o;
      return o = n = function (e) {
        r(u, e);
        var n,
            o,
            a = (n = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (o) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function u() {
          return t(this, u), a.apply(this, arguments);
        }

        return R(u, null, [{
          key: "getAttributeDefinition",
          value: function () {
            return Ut(Ut({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
              applicationMethod: {
                name: "Application Method",
                key: "applicationMethod",
                type: "string"
              }
            });
          }
        }, {
          key: "requiresTankSize",
          value: function (t) {
            var e = (0, X.find)((0, X.propEq)("text", t))(this.applicationMethods);
            return Boolean(null == e ? void 0 : e.tankSize);
          }
        }, {
          key: "requiresRate",
          value: function (t) {
            var e = (0, X.find)((0, X.propEq)("text", t))(this.applicationMethods);
            return Boolean(null == e ? void 0 : e.requiresRate);
          }
        }, {
          key: "requiresSpreader",
          value: function (t) {
            return Boolean(t.match(/spread/i));
          }
        }, {
          key: "requiresSprayer",
          value: function (t) {
            return this.requiresRate(t);
          }
        }, {
          key: "requiresTractor",
          value: function (t) {
            var e = (0, X.find)((0, X.propEq)("text", t))(this.applicationMethods);
            return Boolean(null == e ? void 0 : e.requiresTractor);
          }
        }]), u;
      }(e), w(n, "applicationMethods", [{
        text: "Aerial",
        coverage: !1,
        tankSize: !0,
        requiresRate: !0
      }, {
        text: "Airblast",
        coverage: !0,
        tankSize: !0,
        requiresRate: !0,
        requiresTractor: !0
      }, {
        text: "Broadcast Spray",
        coverage: !1,
        tankSize: !0,
        requiresRate: !0,
        requiresTractor: !0
      }, {
        text: "Broadcast Spread",
        coverage: !0,
        tankSize: !1,
        requiresTractor: !0
      }, {
        text: "Aerial Spread",
        coverage: !0,
        tankSize: !1
      }, {
        text: "Hand Applied",
        coverage: !0,
        tankSize: !1
      }, {
        text: "Injection",
        coverage: !1,
        tankSize: !1
      }, {
        text: "Banded Spray",
        coverage: !0,
        tankSize: !0,
        requiresRate: !0,
        requiresTractor: !0
      }, {
        text: "Subsurface Shank",
        coverage: !1,
        tankSize: !1,
        requiresTractor: !0
      }, {
        text: "Spot Spray",
        coverage: !0,
        tankSize: !0,
        requiresRate: !0,
        requiresTractor: !0
      }]), o;
    };

    function Jt(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Gt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Jt(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Jt(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Ht,
        Kt,
        Qt = function (e) {
      var n, o, a, u;
      return u = a = function (e) {
        r(u, e);
        var n,
            o,
            a = (n = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (o) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function u() {
          return t(this, u), a.apply(this, arguments);
        }

        return R(u, null, [{
          key: "getSchemaMigrations",
          value: function () {
            return this._schemaMigrations;
          }
        }, {
          key: "getAttributeDefinition",
          value: function () {
            return Gt(Gt({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
              schema: {
                name: "Schema",
                key: "schema",
                type: "string"
              }
            });
          }
        }, {
          key: "migratedSchema",
          value: function (t) {
            for (var e = this.getSchemaMigrations(), r = Gt({}, t);;) {
              var n = r.schema;
              if ("default" === n) throw new Error("'default' is not a valid schema!");
              var o = n || "default";
              if (!Object.prototype.hasOwnProperty.call(e, o)) break;
              if ((r = e[o](r)).schema === n) throw new g(n);
            }

            return r;
          }
        }]), u;
      }(e), w(a, "_schemaMigrations", {}), $(n = u, "_schemaMigrations", [V.observable], (o = (o = Object.getOwnPropertyDescriptor(n, "_schemaMigrations")) ? o.value : void 0, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        initializer: function () {
          return o;
        }
      }), n), n;
    },
        Wt = s(9683),
        Zt = (Ht = new Wt.SchemaValidator(), (Kt = s(3286)).keys().forEach(function (t) {
      Ht.addSchema(Kt(t));
    }), Ht);

    var Xt = function (e) {
      return function (e) {
        r(u, e);
        var n,
            o,
            a = (n = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (o) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function u() {
          return t(this, u), a.apply(this, arguments);
        }

        return R(u, null, [{
          key: "getSchemaId",
          value: function () {
            throw new Error("getSchemaId should be defined by base class");
          }
        }, {
          key: "validateSchema",
          value: function (t) {
            Zt.validate(this.getSchemaId(), t);
          }
        }]), u;
      }(e);
    };

    var te = function (e) {
      var n, a;
      return n = function (e) {
        r(p, e);
        var n,
            u,
            s = (n = p, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function p() {
          var e;
          t(this, p);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          return L(o(e = s.call.apply(s, [this].concat(n))), "isHighlighted", a, o(e)), e;
        }

        return R(p, [{
          key: "highlight",
          value: function () {
            this.isHighlighted = !0;
          }
        }, {
          key: "unHighlight",
          value: function () {
            this.isHighlighted = !1;
          }
        }, {
          key: "toggleHighlighted",
          value: function () {
            this.isHighlighted = !this.isHighlighted;
          }
        }]), p;
      }(e), a = $(n.prototype, "isHighlighted", [V.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), $(n.prototype, "highlight", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "highlight"), n.prototype), $(n.prototype, "unHighlight", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "unHighlight"), n.prototype), $(n.prototype, "toggleHighlighted", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "toggleHighlighted"), n.prototype), n;
    };

    var ee = function (e) {
      var n, a;
      return n = function (e) {
        r(p, e);
        var n,
            u,
            s = (n = p, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function p() {
          var e;
          t(this, p);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          return L(o(e = s.call.apply(s, [this].concat(n))), "isActive", a, o(e)), e;
        }

        return R(p, [{
          key: "activate",
          value: function () {
            this.isActive = !0;
          }
        }, {
          key: "deactivate",
          value: function () {
            this.isActive = !1;
          }
        }, {
          key: "setActive",
          value: function (t) {
            this.isActive = t;
          }
        }, {
          key: "toggleActive",
          value: function () {
            this.isActive = !this.isActive;
          }
        }]), p;
      }(e), a = $(n.prototype, "isActive", [V.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), $(n.prototype, "activate", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "activate"), n.prototype), $(n.prototype, "deactivate", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "deactivate"), n.prototype), $(n.prototype, "setActive", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "setActive"), n.prototype), $(n.prototype, "toggleActive", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "toggleActive"), n.prototype), n;
    };

    var re = function (e) {
      var n, a;
      return n = function (e) {
        r(p, e);
        var n,
            u,
            s = (n = p, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = c(n);

          if (u) {
            var r = c(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);

          return i(this, t);
        });

        function p() {
          var e;
          t(this, p);

          for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

          return L(o(e = s.call.apply(s, [this].concat(n))), "isHidden", a, o(e)), e;
        }

        return R(p, [{
          key: "hide",
          value: function () {
            this.isHidden = !0;
          }
        }, {
          key: "show",
          value: function () {
            this.isHidden = !1;
          }
        }, {
          key: "setHidden",
          value: function (t) {
            this.isHidden = t;
          }
        }, {
          key: "toggleHidden",
          value: function () {
            this.isHidden = !this.isHidden;
          }
        }]), p;
      }(e), a = $(n.prototype, "isHidden", [V.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), $(n.prototype, "hide", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "hide"), n.prototype), $(n.prototype, "show", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "show"), n.prototype), $(n.prototype, "setHidden", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "setHidden"), n.prototype), $(n.prototype, "toggleHidden", [V.action], Object.getOwnPropertyDescriptor(n.prototype, "toggleHidden"), n.prototype), n;
    },
        ne = (s(9463), function () {
      function e() {
        var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        t(this, e), this.key = r.key, this.value = r.value, this.fullMessage = r.fullMessage, this.attributeLabel = r.attributeLabel, this.description = r.description, this.subFailure = r.subFailure;
      }

      return R(e, [{
        key: "msg",
        get: function () {
          return this.message;
        }
      }, {
        key: "message",
        get: function () {
          if (this.fullMessage) return this.fullMessage;
          var t = this.attributeLabel,
              e = this.description;
          return this.subFailure && (e = this.subFailure.message || this.subFailure.description, this.subFailure.message || (t += " ".concat(this.subFailure.attributeLabel))), "".concat(t, " ").concat(e);
        }
      }], [{
        key: "newFrom",
        value: function (t, r) {
          var n = new e({
            key: t.attribute,
            attributeLabel: t.attributeLabel,
            value: t.value(r)
          });
          return t.options.fullMessage ? n.fullMessage = t.options.fullMessage : (n.attributeLabel = t.attributeLabel, n.description = t.description), n;
        }
      }]), e;
    }()),
        oe = function () {
      function e(r) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        t(this, e), this.attribute = r, this.options = n;
      }

      return R(e, [{
        key: "attributeLabel",
        get: function () {
          return this.options.attributeLabel ? this.options.attributeLabel : this.attribute.replace(/^\w/, function (t) {
            return t.toUpperCase();
          });
        }
      }, {
        key: "description",
        get: function () {
          return this.options.description || this.defaultDescription;
        }
      }, {
        key: "value",
        value: function (t) {
          return t[this.attribute];
        }
      }, {
        key: "failures",
        value: function (t) {
          var e = this,
              r = this.value(t),
              n = [],
              o = this.failure(t);
          return o && n.push(o), r && this.constructor.isValidatable(r) && (n = n.concat(r.failures().map(function (t) {
            return e.adopt(t);
          }))), n;
        }
      }, {
        key: "adopt",
        value: function (t) {
          return new ne({
            key: this.attribute,
            attributeLabel: this.attributeLabel,
            subFailure: t
          });
        }
      }], [{
        key: "isValidatable",
        value: function (t) {
          return "object" === n(t) && "failures" in t && "validations" in t;
        }
      }]), e;
    }(),
        ie = (s(3288), s(8781), s(8718), s(4298), s(5428), s(5211)),
        ce = s.n(ie);

    var ae = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e, r) {
        return t(this, u), a.call(this, "Units '".concat(e, "' and '").concat(r, "' are not compatible"));
      }

      return u;
    }(l);

    var ue,
        se = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.call(this, "Missing required quantity");
      }

      return u;
    }(l);

    var pe = new Map();
    pe.set("<1>", "1");
    var le = new Map([["<googol>", "googol"], ["<kibi>", "Ki"], ["<mebi>", "Mi"], ["<gibi>", "Gi"], ["<tebi>", "Ti"], ["<pebi>", "Pi"], ["<exi>", "Ei"], ["<zebi>", "Zi"], ["<yebi>", "Yi"], ["<yotta>", "Y"], ["<zetta>", "Z"], ["<exa>", "E"], ["<peta>", "P"], ["<tera>", "T"], ["<giga>", "G"], ["<mega>", "M"], ["<kilo>", "k"], ["<hecto>", "h"], ["<deca>", "da"], ["<deci>", "d"], ["<centi>", "c"], ["<milli>", "m"], ["<micro>", "u"], ["<nano>", "n"], ["<pico>", "p"], ["<femto>", "f"], ["<atto>", "a"], ["<zepto>", "z"], ["<yocto>", "y"]]),
        fe = new Map(ce().getUnits().map(function (t) {
      return ["<".concat(t, ">"), "liter" === t ? "L" : "short-ton" === t ? "ton" : ce().getAliases(t)[0]];
    })),
        ye = (ue = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        return t(this, u), (r = a.call(this, e)).update(e), r;
      }

      return R(u, [{
        key: "displayValue",
        get: function () {
          return this.constructor.format(this.scalar, this.units, {
            formatUnits: !0
          });
        }
      }, {
        key: "isBlank",
        get: function () {
          return "" === this.displayValue;
        }
      }, {
        key: "numeratorUnits",
        get: function () {
          return new (ce())({
            scalar: 1,
            numerator: this.toQty().numerator
          }).units();
        }
      }, {
        key: "update",
        value: function (t) {
          var e = t;
          if (!e && 0 !== e) return this.scalar = "", this.units = "", this;
          if ("function" == typeof e.toJS && (e = t.toJS()), "function" == typeof e.toLowerCase && e.toLowerCase().includes("dry")) return this.scalar = 1, this.units = "Dry", this;
          "function" == typeof e.replace && (e = e.replace(/\/100 gal/, "/hgal"));

          try {
            if (0 !== e && "0" !== e && !e) return this.scalar = "", this.units = "", this;

            if (e && "function" == typeof e.match) {
              var r = e.match(/^([0-9]+)\/([0-9]+)/);

              if (r) {
                var n = r[1] / r[2];
                e = e.replace(r[0], n.toString());
              }
            }

            var o = ce()(e);
            this.scalar = o.scalar, this.units = o.units();
          } catch (e) {
            if (!(e instanceof ce().Error)) throw e;
            this.logger.info("Ignoring bad/unknown quantity: ".concat(t));
          }

          return this;
        }
      }, {
        key: "updateScalar",
        value: function (t) {
          this.scalar = t || 0 === t ? Number(t) : "";
        }
      }, {
        key: "format",
        value: function (t) {
          return this.constructor.format(this.scalar, this.units, t);
        }
      }, {
        key: "compareTo",
        value: function (t) {
          if (!this.constructor.isQuantity(t)) return this.compareTo(new u(t));
          if (t.isBlank) throw new se();
          var e = this.toQty(),
              r = t.toQty();
          if (!e.isCompatible(r)) throw new ae(e.units(), r.units());
          return Math.abs(e.baseScalar - r.baseScalar) <= 1e-10 ? 0 : e.baseScalar < r.baseScalar ? -1 : e.baseScalar > r.baseScalar ? 1 : void 0;
        }
      }, {
        key: "eq",
        value: function (t) {
          try {
            return 0 === this.compareTo(t);
          } catch (e) {
            if (e instanceof se) return null != t && !!this.isBlank;
            if (e instanceof ae) return !1;
            throw e;
          }
        }
      }, {
        key: "gt",
        value: function (t) {
          return 1 === this.compareTo(t);
        }
      }, {
        key: "gte",
        value: function (t) {
          return this.compareTo(t) >= 0;
        }
      }, {
        key: "lt",
        value: function (t) {
          return -1 === this.compareTo(t);
        }
      }, {
        key: "lte",
        value: function (t) {
          return this.compareTo(t) <= 0;
        }
      }, {
        key: "mul",
        value: function (t) {
          var e = this.constructor.isQuantity(t);
          return "" === this.scalar || e && "" === t.scalar || "" === t || !t ? new this.constructor("") : new this.constructor(this.toQty().mul(this.constructor.isQuantity(t) ? t.toQty() : t).toString());
        }
      }, {
        key: "add",
        value: function (t) {
          var e = this.constructor.isQuantity(t),
              r = ce()(Number(this.scalar), this.units).add(e ? ce()(Number(t.scalar), t.units) : t);
          return new this.constructor(r.toString());
        }
      }, {
        key: "div",
        value: function (t) {
          var e = this.constructor.isQuantity(t);
          if ("" === this.scalar || e && "" === t.scalar || "" === t || !t) return new this.constructor("");
          var r = ce()(Number(this.scalar), this.units).div(e ? ce()(Number(t.scalar), t.units) : t);
          return new this.constructor(r.toString());
        }
      }, {
        key: "isCompatible",
        value: function (t) {
          return this.toQty().isCompatible(this.constructor.isQuantity(t) ? t.toQty() : t);
        }
      }, {
        key: "isZero",
        value: function () {
          return 0 === this.scalar || "0" === this.scalar;
        }
      }, {
        key: "kind",
        value: function (t) {
          var e = this.constructor.isQuantity(t);
          return ce()(this.scalar, this.units).kind(e ? ce()(t.scalar, t.units) : t);
        }
      }, {
        key: "sub",
        value: function (t) {
          var e = this.constructor.isQuantity(t),
              r = ce()(Number(this.scalar), this.units).sub(e ? ce()(Number(t.scalar), t.units) : t);
          return new this.constructor(r.toString());
        }
      }, {
        key: "to",
        value: function (t) {
          return new this.constructor(ce()(this.toJS()).to(t));
        }
      }, {
        key: "toJS",
        value: function () {
          return this.format({
            precise: !0
          });
        }
      }, {
        key: "toQty",
        value: function () {
          return "Dry" === this.units ? ce()(30, "min") : this.scalar || 0 === this.scalar ? ce()(Number(this.scalar), this.units) : ce()(this.units);
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          return {
            scalar: {
              name: "Scalar",
              key: "scalar",
              type: "string"
            },
            units: {
              name: "Units",
              key: "units",
              type: "string"
            }
          };
        }
      }, {
        key: "displayValue",
        value: function (t) {
          return this.isQuantity(t) ? t.displayValue : "";
        }
      }, {
        key: "isCompatible",
        value: function (t, e) {
          var r;
          return this.isQuantity(t) ? t.isCompatible(e) : null === (r = new this(t)) || void 0 === r ? void 0 : r.isCompatible(e);
        }
      }, {
        key: "isQuantity",
        value: function (t) {
          var e,
              r = (null == t || null === (e = t.constructor) || void 0 === e ? void 0 : e.attributeDefinition) || {},
              n = r.scalar,
              o = r.units;
          return !!n && !!o;
        }
      }, {
        key: "isQuantityTruthy",
        value: function (t) {
          return this.isQuantity(t) && !t.isBlank && !this.isZero(t);
        }
      }, {
        key: "isZero",
        value: function (t) {
          return 0 === t || "0" === t || (u.isQuantity(t) ? t.isZero() : new u(t).isZero());
        }
      }, {
        key: "format",
        value: function (t, e, r) {
          if (1 === t && "Dry" === e) return "Dry";
          var n = t;
          return 0 !== n && (n = this.formatScalar(t, r)), [].concat(0 === n ? n : n || []).concat((null != r && r.formatUnits ? this.formatUnits(e) : e) || []).join(" ");
        }
      }, {
        key: "formatScalar",
        value: function (t, e) {
          var r = (e || {}).digits,
              n = e || {},
              o = n.fixed,
              i = n.precise;

          if (Number.isFinite(t)) {
            if (i) return Number(t);
            r = 0 === r ? 0 : r || 2;
            var c = t.toFixed(r);
            return o ? c : Number(c);
          }

          return t || "";
        }
      }, {
        key: "formatUnits",
        value: function (t) {
          var e = ce().parse(t || "");
          if (!e) throw new h(t);
          var r = this.stringifyUnitArray(e.numerator),
              n = this.stringifyUnitArray(e.denominator),
              o = "1" === r,
              i = "1" === n;
          if (o && i) return "";
          var c = [].concat(o ? [] : r || []).concat(i ? [] : "/".concat(n)).join("");
          return (c = c.replace(/1\/acre/, "/acre")).replace(/\/hgal/, "/100 gal");
        }
      }, {
        key: "stringifyUnitArray",
        value: function (t) {
          if (!t) return "";
          var e = t.toString(),
              r = pe.get(e);
          return r || (r = this.simplifyUnitNames(this.getUnitNames(t)).join("*"), pe.set(e, r), r);
        }
      }, {
        key: "getUnitNames",
        value: function (t) {
          for (var e, r, n = [], o = 0; o < t.length; o += 1) {
            e = t[o], r = t[o + 1];
            var i = le.get(e);
            i ? (n.push("".concat(i).concat(fe.get(r))), o += 1) : n.push(fe.get(e));
          }

          return n;
        }
      }, {
        key: "simplifyUnitNames",
        value: function (t) {
          var e = {};
          return t.reduce(function (t, r) {
            var n = e[r];
            return n || (n = [r, 0], e[r] = n, t.push(n)), n[1] += 1, t;
          }, []).map(function (t) {
            return t[0] + (t[1] > 1 ? t[1] : "");
          });
        }
      }, {
        key: "toQty",
        value: function (t) {
          return ce()(t);
        }
      }, {
        key: "max",
        value: function () {
          for (var t = this, e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];

          var o = [].concat(r).filter(function (e) {
            return e && t.isQuantity(e) && e.toJS();
          });
          return o.length ? o.reduce(function (t, e) {
            return e.gte(t) ? e : t;
          }) : new this("");
        }
      }]), u;
    }(kt(It, Z)), $(ue.prototype, "displayValue", [V.computed], Object.getOwnPropertyDescriptor(ue.prototype, "displayValue"), ue.prototype), $(ue.prototype, "isBlank", [V.computed], Object.getOwnPropertyDescriptor(ue.prototype, "isBlank"), ue.prototype), $(ue.prototype, "update", [V.action], Object.getOwnPropertyDescriptor(ue.prototype, "update"), ue.prototype), $(ue.prototype, "updateScalar", [V.action], Object.getOwnPropertyDescriptor(ue.prototype, "updateScalar"), ue.prototype), ue);

    var de = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        var e;
        t(this, u);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = a.call.apply(a, [this].concat(n))).defaultDescription = "must not be blank", e;
      }

      return R(u, [{
        key: "failure",
        value: function (t) {
          var e = this.value(t);
          if ((!this.options.onlyIf || this.options.onlyIf()) && (ye.isQuantity(e) ? !ye.isQuantityTruthy(e) : null == e || 0 === e.length)) return ne.newFrom(this, t);
        }
      }]), u;
    }(oe);

    var he = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "failureDescription",
        value: function (t) {
          var e = this.value(t);
          return this.options.optional && !e ? null : this.fails("gt", e) ? "must be greater than ".concat(this.optionDisplayValue("gt")) : this.fails("gte", e) ? "must be greater than or equal to ".concat(this.optionDisplayValue("gte")) : this.fails("lt", e) ? "must be less than ".concat(this.optionDisplayValue("lt")) : this.fails("lte", e) ? "must be less than or equal to ".concat(this.optionDisplayValue("lte")) : null;
        }
      }, {
        key: "failure",
        value: function (t) {
          var e = this.failureDescription(t);

          if (e) {
            var r = ne.newFrom(this, t);
            return r.description = this.options.description || e, r;
          }
        }
      }, {
        key: "optionDisplayValue",
        value: function (t) {
          return ye.isQuantity(this.options[t]) ? this.options[t].displayValue : this.options[t];
        }
      }, {
        key: "optionIsSet",
        value: function (t) {
          return void 0 !== this.options[t] && null !== this.options[t];
        }
      }, {
        key: "fails",
        value: function (t, e) {
          if (!this.optionIsSet(t)) return !1;
          if (!e) return !0;
          if (!ye.isQuantity(e)) return !0;
          var r = this.options[t];
          return ye.isQuantity(r) ? !e[t](r) : "gt" === t ? !(e.scalar > r) : "gte" === t ? !(e.scalar >= r) : "lt" === t ? !(e.scalar < r) : "lte" === t ? !(e.scalar <= r) : void 0;
        }
      }]), u;
    }(oe);

    var me = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "failures",
        value: function (t) {
          var e = [],
              r = this.value(t);
          return null != r && r.scalar || e.push(new ne({
            key: this.attribute,
            subFailure: new ne({
              key: "scalar",
              fullMessage: "scalar must not be blank or zero"
            })
          })), null != r && r.units || e.push(new ne({
            key: this.attribute,
            subFailure: new ne({
              key: "units",
              fullMessage: "units must not be blank"
            })
          })), e;
        }
      }]), u;
    }(oe);

    var ge = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        return t(this, u), (r = a.call(this, e)).update(e), r;
      }

      return u;
    }(kt(It));

    var ve = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "fromModel",
        value: function (t) {
          return new this({
            id: t.id,
            type: t.type,
            name: t.name
          });
        }
      }, {
        key: "fromModelArray",
        value: function (t) {
          var e = this;
          return t.map(function (t) {
            return e.fromModel(t);
          });
        }
      }]), u;
    }(wt(ge, x, E, I, Vt));

    function be(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Oe(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? be(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : be(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Pe,
        je = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "toJS",
        value: function () {
          var t = A(c(u.prototype), "toJS", this).call(this);
          return t.name = t.name || "", t.full_name = t.full_name || "", t;
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return Oe(Oe({}, t), {}, {
            type: Oe(Oe({}, t.type), {}, {
              defaultValue: "IF2::Account"
            }),
            fullName: {
              name: "Full Name",
              key: "fullName",
              type: "string"
            }
          });
        }
      }, {
        key: "fromAccount",
        value: function (t) {
          return new u({
            id: t.id,
            serial: t.serial,
            name: t.name,
            fullName: t.fullName
          });
        }
      }, {
        key: "fromModel",
        value: function (t) {
          return this.fromAccount(t);
        }
      }, {
        key: "isAccountReference",
        value: function (t) {
          return t instanceof u;
        }
      }]), u;
    }(wt(ve, M));

    function we(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ke(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? we(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : we(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Re = (Pe = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "clientPathString",
        get: function () {
          for (var t = this.clientPath.concat(this), e = [], r = t.length; r > 0; r -= 1) {
            var n = t.pop();

            if (n.fullName) {
              e.unshift(n.fullName);
              break;
            }

            e.unshift(n.name);
          }

          return e.join(": ");
        }
      }], [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/account_reference";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          return ke(ke({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            clientPath: {
              name: "Client Path",
              key: "clientPath",
              type: "modelCollection",
              modelClass: je
            }
          });
        }
      }, {
        key: "fromAccount",
        value: function (t) {
          return new u({
            id: t.id,
            serial: t.serial,
            name: t.name,
            fullName: t.fullName,
            clientPath: t.clientPath
          });
        }
      }, {
        key: "fromModel",
        value: function (t) {
          return this.fromAccount(t);
        }
      }, {
        key: "isAccountWithPath",
        value: function (t) {
          return t instanceof u;
        }
      }]), u;
    }(wt(je, Xt)), $(Pe.prototype, "clientPathString", [V.computed], Object.getOwnPropertyDescriptor(Pe.prototype, "clientPathString"), Pe.prototype), Pe);

    function Ae(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function De(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ae(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ae(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    s(6910);

    var _e,
        xe,
        Se,
        Ce = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "toJS",
        value: function () {
          var t,
              e = A(c(u.prototype), "toJS", this).call(this);
          return e.parent = e.parent || (null === (t = this.parent) || void 0 === t ? void 0 : t.toJS()) || null, e;
        }
      }], [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/mode_of_action";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return De(De({}, t), {}, {
            schema: De(De({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: De(De({}, t.type), {}, {
              defaultValue: this.type
            }),
            action: {
              name: "Action",
              key: "action",
              type: "string"
            },
            groupNumber: {
              name: "Group Number",
              key: "groupNumber",
              type: "string"
            },
            description: {
              name: "Description",
              key: "description",
              type: "string"
            },
            parent: {
              name: "Parent",
              key: "parent",
              type: "object"
            }
          });
        }
      }]), u;
    }(wt(ge, x, I, Qt, Xt));

    function Ee(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ne(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ee(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ee(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Ce, "type", "IF2::ModeOfAction"), w(Ce, "schema", "if2/mode_of_action/v1");
    var Be = (Se = xe = function (e) {
      r(s, e);
      var o,
          a,
          u = (o = s, a = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(o);

        if (a) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function s() {
        return t(this, s), u.apply(this, arguments);
      }

      return R(s, [{
        key: "fullText",
        get: function () {
          return [].concat(this.name || []).concat(this.cas || []).concat(this.alternateNames || []).join(" ").toLowerCase();
        }
      }, {
        key: "newPrimaryName",
        value: function (t) {
          var e = this.name;
          this.update({
            alternateNames: yt(this.alternateNames.filter(function (e) {
              return e !== t;
            }).concat(e)).sort(_t)
          }), this.name = t;
        }
      }, {
        key: "update",
        value: function (t) {
          return "object" === n(t) && "percent" in t && null !== t.percent && (t.percent = Number(t.percent)), A(c(s.prototype), "update", this).call(this, t);
        }
      }], [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/product/active_ingredient";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(s), "getAttributeDefinition", this).call(this);
          return Ne(Ne({}, t), {}, {
            type: Ne(Ne({}, t.type), {}, {
              defaultValue: this.type
            }),
            shortName: {
              name: "Short Name",
              key: "shortName",
              type: "string"
            },
            cas: {
              name: "CAS",
              key: "cas",
              type: "string"
            },
            pcCode: {
              name: "PC Code",
              key: "pcCode",
              type: "string"
            },
            percent: {
              name: "Percent",
              key: "percent",
              type: "number"
            },
            liquidConcentration: {
              name: "Liquid Concentration",
              key: "liquidConcentration",
              type: "model",
              modelClass: ye
            },
            modesOfAction: {
              name: "Mode of Action",
              key: "modesOfAction",
              type: "modelCollection",
              modelClass: Ce
            },
            toxicityClass: {
              name: "Toxicity Class",
              key: "toxicityClass",
              type: "string"
            },
            toxicityCategory: {
              name: "Toxicity Category",
              key: "toxicityCategory",
              type: "string"
            },
            alternateNames: {
              name: "Alternate Name",
              key: "alternateNames",
              type: "array"
            },
            limitedByEspp: {
              name: "Limited By ESPP",
              key: "limitedByEspp",
              type: "boolean"
            }
          });
        }
      }]), s;
    }(wt(ge, x, E, I, Xt)), w(xe, "type", "IF2::ActiveIngredient"), $((_e = Se).prototype, "fullText", [V.computed], Object.getOwnPropertyDescriptor(_e.prototype, "fullText"), _e.prototype), $(_e.prototype, "newPrimaryName", [V.action], Object.getOwnPropertyDescriptor(_e.prototype, "newPrimaryName"), _e.prototype), $(_e.prototype, "update", [V.action], Object.getOwnPropertyDescriptor(_e.prototype, "update"), _e.prototype), _e);

    function Me(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Fe(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Me(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Me(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    s(4170);

    var Te = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "from",
        value: function (t) {
          return new this(t);
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          return Fe(Fe({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            label: {
              name: "Label",
              key: "label",
              type: "string"
            },
            primary: {
              name: "Primary",
              key: "primary",
              type: "boolean"
            }
          });
        }
      }]), u;
    }(ge);

    function Ie(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Le(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ie(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ie(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var $e = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          return Le(Le({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            value: {
              name: "Value",
              key: "value",
              type: "string"
            }
          });
        }
      }]), u;
    }(Te);

    function Ve(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ye(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ve(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ve(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var qe = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          return Ye(Ye({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            address: {
              name: "Address",
              key: "address",
              type: "string"
            }
          });
        }
      }]), u;
    }(Te);

    function Ue(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ze(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ue(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ue(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Je = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          return ze(ze({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            number: {
              name: "Number",
              key: "number",
              type: "string"
            }
          });
        }
      }]), u;
    }(Te);

    function Ge(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function He(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ge(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ge(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Ke = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return He(He({}, t), {}, {
            type: He(He({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Re
            },
            licensePlateNumber: {
              name: "License Plate Number",
              key: "licensePlateNumber",
              type: "string"
            },
            tankSize: {
              name: "Tank Size",
              key: "tankSize",
              type: "model",
              modelClass: ye
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            }
          });
        }
      }]), u;
    }(wt(ge, x, M, E, I));

    function Qe(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function We(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Qe(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Qe(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Ke, "type", "IF2::Sprayer");

    var Ze = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return We(We({}, t), {}, {
            type: We(We({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Re
            },
            licensePlateNumber: {
              name: "License Plate Number",
              key: "licensePlateNumber",
              type: "string"
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            }
          });
        }
      }]), u;
    }(wt(ge, x, M, E, I));

    function Xe(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function tr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Xe(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Xe(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Ze, "type", "IF2::Spreader");

    var er,
        rr,
        nr,
        or = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return tr(tr({}, t), {}, {
            type: tr(tr({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Re
            },
            licensePlateNumber: {
              name: "License Plate Number",
              key: "licensePlateNumber",
              type: "string"
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            }
          });
        }
      }]), u;
    }(wt(ge, x, M, E, I));

    function ir(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function cr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ir(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ir(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(or, "type", "IF2::Tractor");
    var ar,
        ur = (nr = rr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "name",
        get: function () {
          return [].concat(this.firstName || []).concat(this.lastName || []).join(" ");
        }
      }, {
        key: "address",
        get: function () {
          return (this.primaryAddress || {
            value: ""
          }).value;
        }
      }, {
        key: "primaryAddress",
        get: function () {
          return this.addresses.length < 1 ? new $e() : this.addresses.find(function (t) {
            return t.primary;
          }) || this.addresses[0];
        }
      }, {
        key: "email",
        get: function () {
          return (this.primaryEmail || {
            address: ""
          }).address;
        }
      }, {
        key: "primaryEmail",
        get: function () {
          return this.emails.length < 1 ? new qe() : this.emails.find(function (t) {
            return t.primary;
          }) || this.hasEmail && this.emails[0];
        }
      }, {
        key: "phone",
        get: function () {
          return (this.primaryPhone || {
            number: ""
          }).number;
        }
      }, {
        key: "primaryPhone",
        get: function () {
          return this.phones.length < 1 ? new Je() : this.phones.find(function (t) {
            return t.primary;
          }) || this.phones[0];
        }
      }, {
        key: "fullText",
        get: function () {
          return [this.firstName, this.lastName].concat(this.addresses.map(function (t) {
            return t.value;
          }), this.emails.map(function (t) {
            return t.address;
          }), this.phones.map(function (t) {
            return t.number;
          })).join(" ");
        }
      }, {
        key: "hasEmail",
        get: function () {
          return this.emails.length > 0;
        }
      }, {
        key: "setPhone",
        value: function (t) {
          var e = this.primaryPhone || new Je({
            number: t,
            primary: !0
          });
          e.number = t, Pt(this.phones, Je.from.bind(Je), e, {
            searchKey: "number"
          });
        }
      }, {
        key: "setAddress",
        value: function (t) {
          var e = this.primaryAddress || new $e({
            value: t,
            primary: !0
          });
          e.value = t, Pt(this.addresses, $e.from.bind($e), e, {
            searchKey: "value"
          });
        }
      }, {
        key: "setEmail",
        value: function (t) {
          var e = this.primaryEmail || new qe({
            address: t,
            primary: !0
          });
          e.address = t, Pt(this.emails, qe.from.bind(qe), e, {
            searchKey: "address"
          });
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return cr(cr({}, t), {}, {
            type: cr(cr({}, t.type), {}, {
              defaultValue: this.type
            }),
            firstName: {
              name: "First Name",
              key: "firstName",
              type: "string"
            },
            lastName: {
              name: "Last Name",
              key: "lastName",
              type: "string"
            },
            licenseNumber: {
              name: "License Number",
              key: "licenseNumber",
              type: "string"
            },
            addresses: {
              name: "Address",
              key: "addresses",
              type: "modelCollection",
              modelClass: $e,
              searchKey: "value"
            },
            emails: {
              name: "Email",
              key: "emails",
              type: "modelCollection",
              modelClass: qe,
              searchKey: "address"
            },
            phones: {
              name: "Phone",
              key: "phones",
              type: "modelCollection",
              modelClass: Je,
              searchKey: "number"
            },
            categories: {
              name: "Categories",
              key: "categories",
              type: "array"
            },
            defaultSprayer: {
              name: "Default Sprayer",
              key: "defaultSprayer",
              type: "model",
              modelClass: Ke
            },
            defaultSpreader: {
              name: "Default Spreader",
              key: "defaultSpreader",
              type: "model",
              modelClass: Ze
            },
            defaultTractor: {
              name: "Default Tractor",
              key: "defaultTractor",
              type: "model",
              modelClass: or
            },
            userId: {
              name: "User ID",
              key: "userId",
              type: "string"
            }
          });
        }
      }]), u;
    }(wt(ge, x, I, M)), w(rr, "type", "IF2::Contact"), w(rr, "sortByLastName", function (t, e) {
      return At(t.lastName.toLowerCase(), e.lastName.toLowerCase());
    }), $((er = nr).prototype, "name", [V.computed], Object.getOwnPropertyDescriptor(er.prototype, "name"), er.prototype), $(er.prototype, "address", [V.computed], Object.getOwnPropertyDescriptor(er.prototype, "address"), er.prototype), $(er.prototype, "primaryAddress", [V.computed], Object.getOwnPropertyDescriptor(er.prototype, "primaryAddress"), er.prototype), $(er.prototype, "email", [V.computed], Object.getOwnPropertyDescriptor(er.prototype, "email"), er.prototype), $(er.prototype, "primaryEmail", [V.computed], Object.getOwnPropertyDescriptor(er.prototype, "primaryEmail"), er.prototype), $(er.prototype, "phone", [V.computed], Object.getOwnPropertyDescriptor(er.prototype, "phone"), er.prototype), $(er.prototype, "primaryPhone", [V.computed], Object.getOwnPropertyDescriptor(er.prototype, "primaryPhone"), er.prototype), $(er.prototype, "fullText", [V.computed], Object.getOwnPropertyDescriptor(er.prototype, "fullText"), er.prototype), $(er.prototype, "hasEmail", [V.computed], Object.getOwnPropertyDescriptor(er.prototype, "hasEmail"), er.prototype), er);

    function sr(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function pr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? sr(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : sr(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var lr = (ar = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "name",
        get: function () {
          var t;
          return (null === (t = this.contact) || void 0 === t ? void 0 : t.name) || "";
        }
      }, {
        key: "phone",
        get: function () {
          var t;
          return (null === (t = this.contact) || void 0 === t ? void 0 : t.phone) || "";
        }
      }, {
        key: "address",
        get: function () {
          var t;
          return (null === (t = this.contact) || void 0 === t ? void 0 : t.address) || "";
        }
      }, {
        key: "email",
        get: function () {
          var t;
          return (null === (t = this.contact) || void 0 === t ? void 0 : t.email) || "";
        }
      }, {
        key: "licenseNumber",
        get: function () {
          var t;
          return (null === (t = this.contact) || void 0 === t ? void 0 : t.licenseNumber) || "";
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          return pr(pr({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            contact: {
              name: "Contact",
              key: "contact",
              type: "model",
              modelClass: ur,
              defaultValue: new ur()
            },
            tractor: {
              name: "Tractor",
              key: "tractor",
              type: "model",
              modelClass: or
            },
            sprayer: {
              name: "Sprayer",
              key: "sprayer",
              type: "model",
              modelClass: Ke
            },
            spreader: {
              name: "Spreader",
              key: "spreader",
              type: "model",
              modelClass: Ze
            }
          });
        }
      }]), u;
    }(wt(ge, x, M, I)), $(ar.prototype, "name", [V.computed], Object.getOwnPropertyDescriptor(ar.prototype, "name"), ar.prototype), $(ar.prototype, "phone", [V.computed], Object.getOwnPropertyDescriptor(ar.prototype, "phone"), ar.prototype), $(ar.prototype, "address", [V.computed], Object.getOwnPropertyDescriptor(ar.prototype, "address"), ar.prototype), $(ar.prototype, "email", [V.computed], Object.getOwnPropertyDescriptor(ar.prototype, "email"), ar.prototype), $(ar.prototype, "licenseNumber", [V.computed], Object.getOwnPropertyDescriptor(ar.prototype, "licenseNumber"), ar.prototype), ar);

    var fr,
        yr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return u;
    }(wt(ge, E));

    var dr = (fr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "jsonString",
        get: function () {
          return JSON.stringify(this);
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          return {
            type: {
              name: "Type",
              key: "type",
              type: "string"
            }
          };
        }
      }]), u;
    }(kt(It)), $(fr.prototype, "jsonString", [V.computed], Object.getOwnPropertyDescriptor(fr.prototype, "jsonString"), fr.prototype), fr);

    function hr(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function mr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? hr(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : hr(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var gr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        return t(this, u), (r = a.call(this, e)).update(e), r;
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          return mr(mr({}, dr.getAttributeDefinition()), {}, {
            coordinates: {
              name: "Coordinate",
              key: "coordinates",
              type: "array"
            }
          });
        }
      }]), u;
    }(dr);

    function vr(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function br(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? vr(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : vr(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Or = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = gr.getAttributeDefinition();
          return br(br({}, t), {}, {
            type: br(br({}, t.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }]), u;
    }(gr);

    function Pr(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function jr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Pr(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Pr(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Or, "type", "Polygon");

    var wr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = gr.getAttributeDefinition();
          return jr(jr({}, t), {}, {
            type: jr(jr({}, t.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }]), u;
    }(gr);

    function kr(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Rr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? kr(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : kr(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(wr, "type", "MultiPolygon");

    var Ar = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = gr.getAttributeDefinition();
          return Rr(Rr({}, t), {}, {
            type: Rr(Rr({}, t.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }]), u;
    }(gr);

    w(Ar, "type", "Point");

    var Dr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        t(this, u);
        var n = e || {};
        if (r = a.call(this, n), !n.type) throw new Error("Not valid GeoJSON");

        switch (n.type) {
          case "Point":
            return i(r, new r.constructor.PointGeometryClass(n));

          case "Polygon":
            return i(r, new r.constructor.PolygonGeometryClass(n));

          case "MultiPolygon":
            return i(r, new r.constructor.MultiPolygonGeometryClass(n));

          default:
            throw new m(n.type);
        }

        return r;
      }

      return u;
    }(gr);

    function _r(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function xr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? _r(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : _r(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Dr, "PointGeometryClass", Ar), w(Dr, "PolygonGeometryClass", Or), w(Dr, "MultiPolygonGeometryClass", wr);

    var Sr,
        Cr,
        Er,
        Nr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        return t(this, u), (r = a.call(this, e)).update(e), r;
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = dr.getAttributeDefinition();
          return xr(xr({}, t), {}, {
            type: xr(xr({}, t.type), {}, {
              defaultValue: this.type
            }),
            geometry: {
              name: "Geometry",
              key: "geometry",
              type: "model",
              modelClass: Dr
            },
            properties: {
              name: "Properties",
              key: "properties",
              type: "object"
            }
          });
        }
      }]), u;
    }(dr);

    function Br(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Mr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Br(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Br(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Nr, "type", "Feature");
    var Fr = (Er = Cr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        return t(this, u), (r = a.call(this, e)).update(e), r;
      }

      return R(u, [{
        key: "updateCollectionAttributeElement",
        value: function (t, e) {
          return ["FeatureCollection", "Feature"].includes(e.type) ? new ("FeatureCollection" === e.type ? this.constructor.FeatureCollectionClass : this.constructor.FeatureClass)(e) : A(c(u.prototype), "updateCollectionAttributeElement", this).call(this, t, e);
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var t = dr.getAttributeDefinition();
          return Mr(Mr({}, t), {}, {
            type: Mr(Mr({}, t.type), {}, {
              defaultValue: "FeatureCollection"
            }),
            features: {
              name: "Feature",
              key: "features",
              type: "modelCollection"
            }
          });
        }
      }]), u;
    }(dr), w(Cr, "type", "FeatureCollection"), w(Cr, "FeatureCollectionClass", Cr), w(Cr, "FeatureClass", Nr), $((Sr = Er).prototype, "updateCollectionAttributeElement", [V.action], Object.getOwnPropertyDescriptor(Sr.prototype, "updateCollectionAttributeElement"), Sr.prototype), Sr);

    var Tr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        t(this, u);
        var n = e || {};
        if (r = a.call(this, n), !n.type) throw new d();

        switch (n.type) {
          case "FeatureCollection":
            return i(r, new r.constructor.FeatureCollectionClass(n));

          case "Feature":
            return i(r, new r.constructor.FeatureClass(n));

          default:
            throw new y();
        }

        return r;
      }

      return u;
    }(dr);

    w(Tr, "FeatureCollectionClass", Fr), w(Tr, "FeatureClass", Nr), s(8459);

    var Ir = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        t(this, u);
        var n = e || {
          type: "FeatureCollection",
          features: []
        };
        if ("string" == typeof n && (n = JSON.parse(n)), r = a.call(this, n), !n.type) throw new d();
        return "FeatureCollection" === n.type || "Feature" === n.type ? i(r, new r.constructor.FeatureBuilderClass(n)) : i(r, new r.constructor.FeatureGeometryClass(n));
      }

      return R(u, null, [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/field/geo_json";
        }
      }]), u;
    }(wt(dr, Xt));

    function Lr(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function $r(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Lr(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Lr(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Ir, "FeatureBuilderClass", Tr), w(Ir, "FeatureGeometryClass", Dr);

    var Vr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          return $r($r({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            percent: {
              name: "Percent",
              key: "percent",
              type: "string"
            }
          });
        }
      }]), u;
    }(wt(ge, E));

    var Yr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return u;
    }(wt(ge, E));

    function qr(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ur(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? qr(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qr(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var zr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          return Ur(Ur({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            percent: {
              name: "Percent",
              key: "percent",
              type: "string"
            }
          });
        }
      }]), u;
    }(wt(ge, E));

    function Jr(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Gr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Jr(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Jr(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Hr,
        Kr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          return Gr(Gr({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            varieties: {
              name: "Variety",
              key: "varieties",
              type: "modelCollection",
              searchKey: "name",
              modelClass: Vr
            },
            cultivars: {
              name: "Cultivar",
              key: "cultivars",
              type: "modelCollection",
              searchKey: "id",
              modelClass: Yr
            },
            rootStocks: {
              name: "Rootstock",
              key: "rootStocks",
              type: "modelCollection",
              searchKey: "id",
              modelClass: zr
            },
            useTypes: {
              name: "Use Type",
              key: "useTypes",
              type: "array"
            }
          });
        }
      }]), u;
    }(wt(ge, x, E));

    function Qr(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Wr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Qr(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Qr(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Kr, "type", "IF2::Crop");
    var Zr = (Hr = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "update",
        value: function (t) {
          var e = t || {};
          return "percentage" in e ? e.percentage = null === e.percentage ? null : Number(e.percentage) : "percent" in e && (e.percentage = null === e.percent ? null : Number(e.percent) / 100), A(c(u.prototype), "update", this).call(this, e);
        }
      }, {
        key: "percent",
        get: function () {
          return "number" != typeof this.percentage ? null : 100 * this.percentage;
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          return Wr(Wr({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            percentage: {
              name: "Percentage",
              key: "percentage",
              type: "number",
              defaultValue: 1
            }
          });
        }
      }]), u;
    }(wt(ge, E)), $(Hr.prototype, "update", [V.action], Object.getOwnPropertyDescriptor(Hr.prototype, "update"), Hr.prototype), $(Hr.prototype, "percent", [V.computed], Object.getOwnPropertyDescriptor(Hr.prototype, "percent"), Hr.prototype), Hr);

    function Xr(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function tn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Xr(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Xr(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var en = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          return tn(tn({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            percentage: {
              key: "percentage",
              type: "number",
              defaultValue: 1
            }
          });
        }
      }]), u;
    }(wt(ge, E));

    var rn,
        nn,
        on,
        cn = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return u;
    }(wt(ge, E));

    function an(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function un(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? an(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : an(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var sn,
        pn,
        ln,
        fn = (on = nn = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "acreage",
        get: function () {
          return this.area.displayValue;
        }
      }, {
        key: "acres",
        get: function () {
          var t;
          return (null === (t = this.area) || void 0 === t ? void 0 : t.scalar) || 0;
        }
      }, {
        key: "clientPathFieldName",
        get: function () {
          return [].concat(this.account.clientPathString || []).concat(this.name).join(": ");
        }
      }, {
        key: "countyName",
        get: function () {
          return this.county ? this.county.match(/county/i) ? this.county : "".concat(this.county, " County") : null;
        }
      }, {
        key: "cropName",
        get: function () {
          return this.crop.name || "";
        }
      }, {
        key: "fullText",
        get: function () {
          return [this.clientPathFieldName, this.cropName, this.organic ? "organic" : "", this.varieties.filter(function (t) {
            return !!t;
          }).map(function (t) {
            return t.name;
          }).join(" ")].filter(function (t) {
            return !!t;
          }).join(" ");
        }
      }, {
        key: "fullTextLowercase",
        get: function () {
          return this.fullText.toLowerCase();
        }
      }, {
        key: "gps",
        get: function () {
          if (!this.latitude && !this.longitude) return "";
          var t = parseFloat(this.latitude).toFixed(4),
              e = parseFloat(this.longitude).toFixed(4);
          return "".concat(t, ",").concat(e);
        }
      }, {
        key: "textIndex",
        get: function () {
          return [this.clientPathFieldName, this.cropName, this.organic ? "organic" : "", this.varieties.filter(function (t) {
            return !!t;
          }).map(function (t) {
            return t.name;
          }).join(" ")].filter(function (t) {
            return !!t;
          }).join(" ").toLowerCase();
        }
      }, {
        key: "varieties",
        get: function () {
          var t;
          return null !== (t = this.fieldVarieties) && void 0 !== t && t.length ? this.fieldVarieties : this.crop.varieties;
        }
      }, {
        key: "varietyNames",
        get: function () {
          return this.varieties.slice().sort(function (t, e) {
            return t.percent === e.percent ? Dt(t, e) : parseFloat(e.percent) - parseFloat(t.percent);
          }).map(function (t) {
            return t.name;
          }).join(", ");
        }
      }], [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/field";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return un(un({}, t), {}, {
            schema: un(un({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: un(un({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Re,
              defaultValue: new Re()
            },
            crop: {
              name: "Crop",
              key: "crop",
              type: "model",
              modelClass: Kr,
              defaultValue: new Kr()
            },
            fieldVarieties: {
              name: "Variety",
              key: "fieldVarieties",
              jsKey: "varieties",
              type: "modelCollection",
              searchKey: "name",
              modelClass: Zr
            },
            county: {
              name: "County",
              key: "county",
              type: "string"
            },
            yearPlanted: {
              name: "Year Planted",
              key: "yearPlanted",
              type: "string"
            },
            area: {
              name: "Area",
              key: "area",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            rowSpacing: {
              name: "Row Spacing",
              key: "rowSpacing",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            plantSpacing: {
              key: "plantSpacing",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            treeDensity: {
              key: "treeDensity",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            irrigationRate: {
              key: "irrigationRate",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            elevation: {
              key: "elevation",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            },
            nearestRegion: {
              key: "nearestRegion",
              type: "string"
            },
            harvestLot: {
              key: "harvestLot",
              type: "string"
            },
            previousCrop: {
              key: "previousCrop",
              type: "string"
            },
            longitude: {
              name: "Longitude",
              key: "longitude",
              type: "string"
            },
            latitude: {
              name: "Latitude",
              key: "latitude",
              type: "string"
            },
            nonBearing: {
              name: "Non Bearing",
              key: "nonBearing",
              type: "boolean"
            },
            geoJson: {
              name: "GeoJSON",
              key: "geoJson",
              type: "model",
              modelClass: Ir
            },
            acidWaterTreatment: {
              key: "acidWaterTreatment",
              type: "boolean"
            },
            organic: {
              name: "Organic",
              key: "organic",
              type: "boolean"
            },
            transitional: {
              key: "transitional",
              type: "boolean"
            },
            transitionalDate: {
              key: "transitionalDate",
              type: "string"
            },
            organicDate: {
              name: "Organic Date",
              key: "organicDate",
              type: "string"
            },
            accountingReference: {
              name: "Accounting Reference",
              key: "accountingReference",
              type: "string"
            },
            inactive: {
              name: "Inactive",
              key: "inactive",
              type: "boolean"
            },
            cultivars: {
              key: "cultivars",
              type: "modelCollection",
              searchKey: "name",
              modelClass: yr
            },
            rootStocks: {
              key: "rootStocks",
              type: "modelCollection",
              searchKey: "name",
              modelClass: en
            },
            useTypes: {
              key: "useTypes",
              type: "modelCollection",
              searchKey: "name",
              modelClass: cn
            }
          });
        }
      }]), u;
    }(wt(ge, x, E, st, M, ft, Qt, Xt, I, Y)), w(nn, "type", "IF2::Field"), w(nn, "schema", "if2/field/v1"), $((rn = on).prototype, "acreage", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "acreage"), rn.prototype), $(rn.prototype, "acres", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "acres"), rn.prototype), $(rn.prototype, "clientPathFieldName", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "clientPathFieldName"), rn.prototype), $(rn.prototype, "countyName", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "countyName"), rn.prototype), $(rn.prototype, "cropName", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "cropName"), rn.prototype), $(rn.prototype, "fullText", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "fullText"), rn.prototype), $(rn.prototype, "fullTextLowercase", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "fullTextLowercase"), rn.prototype), $(rn.prototype, "gps", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "gps"), rn.prototype), $(rn.prototype, "textIndex", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "textIndex"), rn.prototype), $(rn.prototype, "varieties", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "varieties"), rn.prototype), $(rn.prototype, "varietyNames", [V.computed], Object.getOwnPropertyDescriptor(rn.prototype, "varietyNames"), rn.prototype), rn);

    function yn(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function dn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? yn(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : yn(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var hn = (ln = pn = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "treatedAcres",
        get: function () {
          return parseFloat(this.acres || 0) * parseFloat(this.coveragePercentage || 0) / 100;
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return dn(dn({}, t), {}, {
            type: dn(dn({}, t.type), {}, {
              defaultValue: this.type
            }),
            applicationId: {
              name: "Application ID",
              key: "applicationId",
              type: "number"
            },
            field: {
              name: "Field",
              key: "field",
              type: "model",
              modelClass: fn,
              defaultValue: new fn()
            },
            acres: {
              name: "Acres",
              key: "acres",
              type: "number"
            },
            percentage: {
              name: "Percentage",
              key: "percentage",
              type: "number"
            },
            coveragePercentage: {
              name: "Coverage Percentage",
              key: "coveragePercentage",
              type: "number"
            }
          });
        }
      }]), u;
    }(wt(ge, x, M, I)), w(pn, "type", "IF2::SprayRecord::FieldCompletion"), $((sn = ln).prototype, "treatedAcres", [V.computed], Object.getOwnPropertyDescriptor(sn.prototype, "treatedAcres"), sn.prototype), sn);

    function mn(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function gn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? mn(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : mn(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var vn = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return gn(gn({}, t), {}, {
            type: gn(gn({}, t.type), {}, {
              defaultValue: "IF2::Field"
            }),
            crop: {
              name: "Crop",
              key: "crop",
              type: "model",
              modelClass: ve,
              defaultValue: new ve()
            }
          });
        }
      }]), u;
    }(ve);

    function bn(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function On(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? bn(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : bn(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Pn = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          return On(On({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            description: {
              name: "Description",
              key: "description",
              type: "string"
            },
            baseUnit: {
              name: "Base Unit",
              key: "baseUnit",
              type: "string"
            }
          });
        }
      }]), u;
    }(wt(ge, I));

    function jn(t, e) {
      if (null == t) return {};

      var r,
          n,
          o = function (t, e) {
        if (null == t) return {};
        var r = {};

        for (var n in t) if ({}.hasOwnProperty.call(t, n)) {
          if (e.includes(n)) continue;
          r[n] = t[n];
        }

        return r;
      }(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) r = i[n], e.includes(r) || {}.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
      }

      return o;
    }

    var wn,
        kn = ["n", "p", "k", "humicAcid"];

    function Rn(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function An(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Rn(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Rn(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Dn,
        _n,
        xn,
        Sn = (wn = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "npkLabel",
        value: function (t) {
          var e = this.constructor.attributeDefinition,
              r = e.n,
              n = e.p,
              o = e.k;
          return [u.nutrientLabelComponent(this[r.key], "", t), u.nutrientLabelComponent(this[n.key], "", t), u.nutrientLabelComponent(this[o.key], "", t)];
        }
      }, {
        key: "metalsLabel",
        value: function () {
          var t = this,
              e = this.constructor.attributeDefinition,
              r = (e.n, e.p, e.k, e.humicAcid, jn(e, kn));
          return Object.keys(r).map(function (e) {
            return u.nutrientLabelComponent(t[e], Bt(e));
          });
        }
      }, {
        key: "humicAcidLabel",
        value: function () {
          var t = this.constructor.attributeDefinition.humicAcid;
          return u.nutrientLabelComponent(this[t.key], "HA");
        }
      }, {
        key: "label",
        get: function () {
          return "".concat(this.npkLabel(Math.floor).concat(this.metalsLabel()).concat(this.humicAcidLabel()).filter(Boolean).join("-"));
        }
      }, {
        key: "appliedNutrientKeys",
        get: function () {
          var t = this;
          return Object.keys(this).filter(function (e) {
            return Number(t[e]);
          });
        }
      }], [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/product/nutrient_analysis";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          return An(An({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            n: {
              name: "N",
              key: "n",
              type: "string"
            },
            p: {
              name: "P",
              key: "p",
              type: "string"
            },
            k: {
              name: "K",
              key: "k",
              type: "string"
            },
            s: {
              name: "S",
              key: "s",
              type: "string"
            },
            ca: {
              name: "Ca",
              key: "ca",
              type: "string"
            },
            mg: {
              name: "Mg",
              key: "mg",
              type: "string"
            },
            al: {
              name: "Al",
              key: "al",
              type: "string"
            },
            b: {
              name: "B",
              key: "b",
              type: "string"
            },
            cu: {
              name: "Cu",
              key: "cu",
              type: "string"
            },
            fe: {
              name: "Fe",
              key: "fe",
              type: "string"
            },
            mn: {
              name: "Mn",
              key: "mn",
              type: "string"
            },
            mo: {
              name: "Mo",
              key: "mo",
              type: "string"
            },
            si: {
              name: "Si",
              key: "si",
              type: "string"
            },
            zn: {
              name: "Zn",
              key: "zn",
              type: "string"
            },
            humicAcid: {
              name: "Humic Acid",
              key: "humicAcid",
              jsKey: "humicAcid",
              type: "string"
            }
          });
        }
      }, {
        key: "nutrientLabelComponent",
        value: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Ft,
              n = Number(t);
          return e && 0 === n ? "" : "".concat(r(t) || "0").concat(e);
        }
      }]), u;
    }(wt(ge, Xt)), $(wn.prototype, "label", [V.computed], Object.getOwnPropertyDescriptor(wn.prototype, "label"), wn.prototype), $(wn.prototype, "appliedNutrientKeys", [V.computed], Object.getOwnPropertyDescriptor(wn.prototype, "appliedNutrientKeys"), wn.prototype), wn),
        Cn = (s(1688), s(5416)),
        En = s.n(Cn);

    function Nn(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Bn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Nn(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Nn(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Mn = (xn = _n = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "isExpired",
        get: function () {
          return !!this.expires && new Date() > new Date(this.expires);
        }
      }, {
        key: "displayExpireDate",
        get: function () {
          return this.expires ? En()(this.momentFriendlyDate, "YYYY-MM-DD").format("MMMM DD, YYYY") : "";
        }
      }, {
        key: "momentFriendlyDate",
        get: function () {
          return new Date(this.expires).toISOString();
        }
      }, {
        key: "update",
        value: function (t) {
          return A(c(u.prototype), "update", this).call(this, Bn(Bn({}, t), {}, {
            type: u.type
          }));
        }
      }], [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/product/organic_listing";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return Bn(Bn({}, t), {}, {
            schema: Bn(Bn({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: Bn(Bn({}, t.type), {}, {
              defaultValue: this.type
            }),
            reference: {
              name: "Reference",
              key: "reference",
              type: "string"
            },
            agency: {
              name: "Agency",
              key: "agency",
              type: "string"
            },
            number: {
              name: "Number",
              key: "number",
              type: "string"
            },
            expires: {
              name: "Expires",
              key: "expires",
              type: "string"
            }
          });
        }
      }]), u;
    }(wt(ge, M, ft, I, Qt, Xt)), w(_n, "type", "IF2::Product::OrganicListing"), w(_n, "schema", "if2/product/organic_listing/v1"), $((Dn = xn).prototype, "isExpired", [V.computed], Object.getOwnPropertyDescriptor(Dn.prototype, "isExpired"), Dn.prototype), $(Dn.prototype, "displayExpireDate", [V.computed], Object.getOwnPropertyDescriptor(Dn.prototype, "displayExpireDate"), Dn.prototype), $(Dn.prototype, "momentFriendlyDate", [V.computed], Object.getOwnPropertyDescriptor(Dn.prototype, "momentFriendlyDate"), Dn.prototype), $(Dn.prototype, "update", [V.action], Object.getOwnPropertyDescriptor(Dn.prototype, "update"), Dn.prototype), Dn);

    var Fn,
        Tn,
        In,
        Ln = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "failures",
        value: function (t) {
          var e = this,
              r = [];
          return t.productApplications.forEach(function (n) {
            var o = e.constructor.failureMessage(t, n);
            o && r.push(new ne({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }], [{
        key: "failureMessage",
        value: function (t, e) {
          var r;
          if (null != t && t.organic && (null === (r = e.product) || void 0 === r || !r.isOrganic)) return "".concat(e.product.name, " cannot be used on an organic recommendation");
        }
      }]), u;
    }(oe);

    function $n(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              c,
              a = [],
              u = !0,
              s = !1;

          try {
            if (i = (r = r.call(t)).next, 0 === e) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (a.push(n.value), a.length !== e); u = !0);
          } catch (t) {
            s = !0, o = t;
          } finally {
            try {
              if (!u && null != r.return && (c = r.return(), Object(c) !== c)) return;
            } finally {
              if (s) throw o;
            }
          }

          return a;
        }
      }(t, e) || U(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Vn(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Yn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Vn(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Vn(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    s(5086);
    var qn = (In = Tn = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "hasMaxPerApplicationConstraint",
        get: function () {
          return ye.isQuantityTruthy(this.maxPerApplication);
        }
      }, {
        key: "satisfiesMaxPerApplicationConstraint",
        value: function (t) {
          return !this.hasMaxPerApplicationConstraint || !ye.isQuantityTruthy(t.rate) || (this.maxPerApplication.isCompatible(t.rate) ? t.rate.lte(this.maxPerApplication) : this.maxPerApplication.isCompatible(t.productPerAcre) ? !t.gallonsPerAcre || t.productPerAcre.lte(this.maxPerApplication) : !this.maxPerApplication.isCompatible(t.productPerVolume) || !t.gallonsPerAcre || t.productPerVolume.lte(this.maxPerApplication));
        }
      }, {
        key: "update",
        value: function (t) {
          return A(c(u.prototype), "update", this).call(this, Yn(Yn({}, t), {}, {
            type: u.type
          }));
        }
      }], [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/product/crop_label";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return Yn(Yn({}, t), {}, {
            schema: Yn(Yn({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: Yn(Yn({}, t.type), {}, {
              defaultValue: this.type
            }),
            crop: {
              name: "Crop",
              key: "crop",
              type: "string"
            },
            applicationMethods: {
              name: "Application Method",
              key: "applicationMethods",
              type: "array"
            },
            phi: {
              name: "PHI",
              key: "phi",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            rei: {
              name: "REI",
              key: "rei",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            minSprayRate: {
              name: "Min. Spray Rate",
              key: "minSprayRate",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            maxSprayRate: {
              name: "Max. Spray Rate",
              key: "maxSprayRate",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            minTreatmentInterval: {
              name: "Min Treatment Interval",
              key: "minTreatmentInterval",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            maxApplicationsPerYear: {
              name: "Max Applications Per Year",
              key: "maxApplicationsPerYear",
              type: "number"
            },
            maxPerApplication: {
              name: "Max Per Application",
              key: "maxPerApplication",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            maxPerYear: {
              name: "Max Per Year",
              key: "maxPerYear",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            productId: {
              name: "Product ID",
              key: "productId",
              type: "number"
            },
            specialConditions: {
              name: "Special Conditions",
              key: "specialConditions",
              type: "object"
            }
          });
        }
      }]), u;
    }(wt(ge, x, M, ft, I, Qt, Xt)), w(Tn, "type", "IF2::Product::CropLabel"), w(Tn, "schema", "if2/product/crop_label/v1"), $((Fn = In).prototype, "hasMaxPerApplicationConstraint", [V.computed], Object.getOwnPropertyDescriptor(Fn.prototype, "hasMaxPerApplicationConstraint"), Fn.prototype), $(Fn.prototype, "update", [V.action], Object.getOwnPropertyDescriptor(Fn.prototype, "update"), Fn.prototype), Fn);

    function Un(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function zn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Un(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Un(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Jn,
        Gn,
        Hn,
        Kn = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/product/attachment";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return zn(zn({}, t), {}, {
            schema: zn(zn({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: zn(zn({}, t.type), {}, {
              defaultValue: this.type
            }),
            productId: {
              name: "Product ID",
              key: "productId",
              type: "string"
            },
            title: {
              name: "Title",
              key: "title",
              type: "string"
            },
            url: {
              name: "Url",
              key: "url",
              type: "string"
            },
            filename: {
              name: "Filename",
              key: "filename",
              type: "string"
            }
          });
        }
      }]), u;
    }(wt(ge, M, I, Qt, Xt, ft));

    function Qn(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Wn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Qn(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Qn(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Kn, "type", "IF2::Product::Attachment"), w(Kn, "schema", "if2/product/attachment/v1");
    var Zn = (Hn = Gn = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "baseUnit",
        get: function () {
          return this.formulation && this.formulation.baseUnit;
        }
      }, {
        key: "baseUnitPerArea",
        get: function () {
          return "".concat(this.baseUnit, "/m^2");
        }
      }, {
        key: "baseUnitPerVolume",
        get: function () {
          return "".concat(this.baseUnit, "/L");
        }
      }, {
        key: "epaExempt",
        get: function () {
          return "Exempt" === this.epaNumber;
        }
      }, {
        key: "hasNutrientAnalysis",
        get: function () {
          return !!this.nutrientAnalysis;
        }
      }, {
        key: "nutrientAnalysisLabel",
        get: function () {
          return this.hasNutrientAnalysis ? this.nutrientAnalysis.label : "";
        }
      }, {
        key: "isActive",
        get: function () {
          return !this.inactive;
        }
      }, {
        key: "isRestricted",
        get: function () {
          return "restricted" === this.use;
        }
      }, {
        key: "rateUnitChoices",
        get: function () {
          var t = [],
              e = this.baseUnit || "",
              r = !e;

          if (t.push({
            group: "Standard",
            value: "".concat(e, "/acre")
          }), t.push({
            group: "Standard",
            value: "".concat(e, "/hgal"),
            displayName: "".concat(e, "/100 gal")
          }), !r) {
            var n = new ye(e),
                o = [];
            n.isCompatible(new ye("kg")) ? o = [{
              system: "US",
              numerators: ["oz", "lbs", "tn"],
              denominators: ["acre", "hgal"]
            }, {
              system: "Metric (SI)",
              numerators: ["grams", "kg"],
              denominators: ["hectare", "l"]
            }, {
              system: "Hybrid (US/Metric)",
              numerators: ["grams", "kg"],
              denominators: ["acre", "hgal"]
            }] : n.isCompatible(new ye("L")) && (o = [{
              system: "US",
              numerators: ["floz", "pt", "qt", "gal"],
              denominators: ["acre", "hgal"]
            }, {
              system: "Metric (SI)",
              numerators: ["ml", "l"],
              denominators: ["hectare"]
            }, {
              system: "Metric (SI)",
              numerators: ["ml"],
              denominators: ["l"]
            }, {
              system: "Hybrid (US/Metric)",
              numerators: ["ml", "l"],
              denominators: ["acre"]
            }, {
              system: "Hybrid (US/Metric)",
              numerators: ["ml"],
              denominators: ["gal", "hgal"]
            }]), o.forEach(function (r) {
              var n = r.system,
                  o = r.numerators;
              r.denominators.forEach(function (r) {
                o.filter(function (t) {
                  return t !== e;
                }).forEach(function (e) {
                  var o = "".concat(e, "/").concat(r);
                  t.push({
                    group: n,
                    value: o,
                    displayName: ye.formatUnits(o)
                  });
                });
              });
            });
          }

          return t;
        }
      }, {
        key: "displayStateRegistration",
        get: function () {
          var t = this,
              e = "";
          return this.epaExempt && this.stateRegistration && Object.keys(this.stateRegistration).length > 0 && (e = Object.keys(this.stateRegistration).sort().map(function (e) {
            return "".concat(e.toUpperCase(), " ").concat(t.stateRegistration[e]);
          }).join(", ")), e;
        }
      }, {
        key: "searchText",
        get: function () {
          var t, e;
          return [].concat(this.name || []).concat(this.manufacturer || []).concat((null === (t = this.activeIngredients) || void 0 === t ? void 0 : t.map(function (t) {
            return t.name;
          })) || []).concat(this.alternateNames || []).concat(this.productType || []).concat((null === (e = this.formulation) || void 0 === e ? void 0 : e.description) || []).concat(this.epaNumber || []).concat(this.nutrientAnalysisLabel || []).join(" ").toLowerCase();
        }
      }, {
        key: "isOrganic",
        get: function () {
          return !!(this.organicListings && this.organicListings.length > 0);
        }
      }, {
        key: "limitedByEspp",
        get: function () {
          return this.activeIngredients.some(function (t) {
            return t.limitedByEspp;
          });
        }
      }, {
        key: "getPrimaryOrganicListing",
        value: function () {
          var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            WSDA: 3,
            OMRI: 2,
            NOP: 1
          };

          if (this.isOrganic) {
            var r = $n(this.organicListings, 1)[0];
            return this.organicListings.forEach(function (n) {
              t.constructor.getAgencyPriority(e, n.agency) > t.constructor.getAgencyPriority(e, r.agency) && (r = n);
            }), r;
          }
        }
      }, {
        key: "labelsForUseOn",
        value: function (t) {
          return this.constructor.labelsForUseOn(t, this.cropLabels);
        }
      }, {
        key: "isLabeledForUseOn",
        value: function (t) {
          return this.constructor.isLabeledForUseOn(t, this.cropLabels);
        }
      }, {
        key: "isForUseOn",
        value: function (t) {
          return this.constructor.isForUseOn(t, this.cropLabels, this.organic);
        }
      }, {
        key: "isLabeledFor",
        value: function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.constructor.isLabeledFor(this.cropLabels, t);
        }
      }, {
        key: "labelsMatching",
        value: function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.constructor.labelsMatching(this.cropLabels, t);
        }
      }, {
        key: "toJS",
        value: function () {
          var t,
              e = A(c(u.prototype), "toJS", this).call(this);
          return e.mass_per_volume = e.mass_per_volume || (null === (t = this.massPerVolume) || void 0 === t ? void 0 : t.toJS()) || null, e;
        }
      }], [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/product";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return Wn(Wn({}, t), {}, {
            schema: Wn(Wn({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: Wn(Wn({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Re,
              defaultValue: new Re()
            },
            manufacturer: {
              name: "Manufacturer",
              key: "manufacturer",
              type: "string"
            },
            epaNumber: {
              name: "EPA Number",
              key: "epaNumber",
              type: "string"
            },
            signalWord: {
              name: "Signal Word",
              key: "signalWord",
              type: "string"
            },
            productType: {
              name: "Product Type",
              key: "productType",
              type: "string"
            },
            use: {
              name: "Use",
              key: "use",
              type: "string"
            },
            formulation: {
              name: "Formulation",
              key: "formulation",
              type: "model",
              modelClass: Pn,
              defaultValue: new Pn()
            },
            alternateNames: {
              name: "Alternate Name",
              key: "alternateNames",
              type: "array"
            },
            activeIngredients: {
              name: "Active Ingredient",
              key: "activeIngredients",
              type: "modelCollection",
              modelClass: Be
            },
            nutrientAnalysis: {
              name: "Nutrient Analysis",
              key: "nutrientAnalysis",
              type: "model",
              modelClass: Sn
            },
            stateRegistration: {
              name: "State Registration",
              key: "stateRegistration",
              type: "object"
            },
            labelUrl: {
              name: "Label URL",
              key: "labelUrl",
              type: "string"
            },
            sdsUrl: {
              name: "SDS URL",
              key: "sdsUrl",
              type: "string"
            },
            beeHazard: {
              name: "Bee Hazard",
              key: "beeHazard",
              type: "string"
            },
            organic: {
              name: "Organic",
              key: "organic",
              type: "boolean"
            },
            organicListings: {
              name: "Organic Listing",
              key: "organicListings",
              type: "modelCollection",
              searchKey: "serial",
              modelClass: Mn
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            },
            reviewedAt: {
              name: "Reviewed At",
              key: "reviewedAt",
              type: "string"
            },
            inactive: {
              name: "Inactive",
              key: "inactive",
              type: "boolean"
            },
            cropLabels: {
              name: "Crop Labels",
              key: "cropLabels",
              type: "modelCollection",
              modelClass: qn
            },
            acheInhibitor: {
              name: "Ache Inhibitor",
              key: "acheInhibitor",
              type: "boolean"
            },
            targetRatesRequired: {
              name: "Target Rates Required",
              key: "targetRatesRequired",
              type: "boolean"
            },
            registrationNumber: {
              name: "Registration Number",
              key: "registrationNumber",
              type: "string"
            },
            massPerVolume: {
              name: "Weight Per Volume",
              key: "massPerVolume",
              type: "model",
              modelClass: ye
            },
            attachments: {
              name: "Attachments",
              key: "attachments",
              type: "modelCollection",
              modelClass: Kn
            }
          });
        }
      }, {
        key: "getAgencyPriority",
        value: function (t, e) {
          return t[e] || 0;
        }
      }, {
        key: "labelsMatching",
        value: function (t, e) {
          return t.filter(function (t) {
            return !(e.crop && t.crop !== e.crop || e.applicationMethod && t.applicationMethods && !t.applicationMethods.includes(e.applicationMethod));
          });
        }
      }, {
        key: "isLabeledFor",
        value: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return !(0, X.isEmpty)(this.labelsMatching(t, e));
        }
      }, {
        key: "labelsForUseOn",
        value: function (t, e) {
          var r = this;
          return (0, X.isEmpty)(t.cropNames) ? this.labelsMatching(e, {
            applicationMethod: t.applicationMethod
          }) : (0, X.reduce)(function (n, o) {
            return n.concat(r.labelsMatching(e, {
              crop: o,
              applicationMethod: t.applicationMethod
            }));
          }, [], t.cropNames);
        }
      }, {
        key: "isLabeledForUseOn",
        value: function (t, e) {
          var r = this;
          return (0, X.isEmpty)(t.cropNames) ? !t.applicationMethod || this.isLabeledFor(e, {
            applicationMethod: t.applicationMethod
          }) : (0, X.all)(function (n) {
            return r.isLabeledFor(e, {
              crop: n,
              applicationMethod: t.applicationMethod
            });
          }, t.cropNames);
        }
      }, {
        key: "isForUseOn",
        value: function (t, e, r) {
          return !(t.organic && !r) && this.isLabeledForUseOn(t, e);
        }
      }]), u;
    }(wt(ge, x, E, M, ft, I, Qt, Xt)), w(Gn, "type", "IF2::Product"), w(Gn, "schema", "if2/product/v1"), w(Gn, "sortByName", function (t, e) {
      return At(t.name.toLowerCase(), e.name.toLowerCase());
    }), $((Jn = Hn).prototype, "baseUnit", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "baseUnit"), Jn.prototype), $(Jn.prototype, "baseUnitPerArea", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "baseUnitPerArea"), Jn.prototype), $(Jn.prototype, "baseUnitPerVolume", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "baseUnitPerVolume"), Jn.prototype), $(Jn.prototype, "epaExempt", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "epaExempt"), Jn.prototype), $(Jn.prototype, "hasNutrientAnalysis", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "hasNutrientAnalysis"), Jn.prototype), $(Jn.prototype, "nutrientAnalysisLabel", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "nutrientAnalysisLabel"), Jn.prototype), $(Jn.prototype, "isActive", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "isActive"), Jn.prototype), $(Jn.prototype, "isRestricted", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "isRestricted"), Jn.prototype), $(Jn.prototype, "rateUnitChoices", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "rateUnitChoices"), Jn.prototype), $(Jn.prototype, "displayStateRegistration", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "displayStateRegistration"), Jn.prototype), $(Jn.prototype, "searchText", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "searchText"), Jn.prototype), $(Jn.prototype, "isOrganic", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "isOrganic"), Jn.prototype), $(Jn.prototype, "limitedByEspp", [V.computed], Object.getOwnPropertyDescriptor(Jn.prototype, "limitedByEspp"), Jn.prototype), Jn);

    function Xn(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function to(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Xn(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Xn(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var eo,
        ro,
        no,
        oo = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return to(to({}, t), {}, {
            type: to(to({}, t.type), {}, {
              defaultValue: "IF2::Product"
            })
          });
        }
      }, {
        key: "fromProduct",
        value: function (t) {
          return new u({
            id: t.id,
            serial: t.serial,
            name: t.name,
            type: t.type
          });
        }
      }, {
        key: "fromModel",
        value: function (t) {
          return this.fromProduct(t);
        }
      }]), u;
    }(wt(ve, M));

    function io(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function co(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? io(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : io(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var ao,
        uo,
        so,
        po = (no = ro = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "isPerArea",
        get: function () {
          var t;
          return null === (t = this.rate) || void 0 === t ? void 0 : t.isCompatible(ye.toQty(this.product.baseUnitPerArea));
        }
      }, {
        key: "isPerVolume",
        get: function () {
          var t;
          return null === (t = this.rate) || void 0 === t ? void 0 : t.isCompatible(ye.toQty(this.product.baseUnitPerVolume));
        }
      }, {
        key: "isLiquid",
        get: function () {
          return new ye(this.product.baseUnit).isCompatible("L");
        }
      }, {
        key: "isDry",
        get: function () {
          return new ye(this.product.baseUnit).isCompatible("lbs");
        }
      }, {
        key: "productPerAcre",
        value: function (t) {
          if (this.isPerVolume) {
            if (!ye.isQuantityTruthy(new ye(t))) throw new P(this.product, this.rate);
            return this.rate.mul(t);
          }

          return this.rate;
        }
      }, {
        key: "poundsPerAcre",
        value: function (t) {
          if (this.isLiquid) {
            var e;
            if (!ye.isQuantityTruthy(new ye(null === (e = this.product) || void 0 === e ? void 0 : e.massPerVolume))) throw new O(this.product);
            return this.productPerAcre(t).mul(this.product.massPerVolume).to("lbs/acre");
          }

          if (this.isDry) return this.productPerAcre(t).to("lbs/acre");
          throw new b(this.product, '"lbs" or "L"');
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return co(co({}, t), {}, {
            id: co(co({}, t.id), {}, {
              defaultValue: (0, tt.v4)()
            }),
            type: co(co({}, t.type), {}, {
              defaultValue: this.type
            }),
            product: {
              name: "Product",
              key: "product",
              type: "model",
              modelClass: Zn,
              defaultValue: new Zn()
            },
            rate: {
              name: "Rate",
              key: "rate",
              type: "model",
              modelClass: ye
            },
            target: {
              name: "Target",
              key: "target",
              type: "string"
            },
            position: {
              name: "Position",
              key: "position",
              type: "number"
            }
          });
        }
      }, {
        key: "from",
        value: function (t) {
          return new this(t);
        }
      }]), u;
    }(wt(ge, x, M, I)), w(ro, "type", "IF2::ProductApplicationBase"), $((eo = no).prototype, "isPerArea", [V.computed], Object.getOwnPropertyDescriptor(eo.prototype, "isPerArea"), eo.prototype), $(eo.prototype, "isPerVolume", [V.computed], Object.getOwnPropertyDescriptor(eo.prototype, "isPerVolume"), eo.prototype), $(eo.prototype, "isLiquid", [V.computed], Object.getOwnPropertyDescriptor(eo.prototype, "isLiquid"), eo.prototype), $(eo.prototype, "isDry", [V.computed], Object.getOwnPropertyDescriptor(eo.prototype, "isDry"), eo.prototype), eo);

    function lo(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function fo(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? lo(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : lo(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var yo,
        ho,
        mo,
        go = (so = uo = function (e) {
      r(s, e);
      var n,
          a,
          u = (n = s, a = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (a) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function s() {
        var e;
        t(this, s);

        for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

        return w(o(e = u.call.apply(u, [this].concat(n))), "validations", [new de("product"), new he("rate", {
          gt: 0
        })]), e;
      }

      return R(s, [{
        key: "name",
        get: function () {
          var t;
          return (null === (t = this.product) || void 0 === t ? void 0 : t.name) || "";
        }
      }, {
        key: "cropLabels",
        get: function () {
          var t = this,
              e = this.product.cropLabels.filter(function (e) {
            return t.cropNames.includes(e.crop);
          });
          return this.applicationMethod ? e.filter(function (e) {
            return e.applicationMethods.length < 1 || e.applicationMethods.includes(t.applicationMethod);
          }) : e;
        }
      }, {
        key: "phi",
        get: function () {
          return this.cropLabels.reduce(function (t, e) {
            return !e.phi || !e.phi.toJS() || t && t.toJS() && t.gte(e.phi) ? t : e.phi;
          }, new ye(""));
        }
      }, {
        key: "rei",
        get: function () {
          return this.cropLabels.reduce(function (t, e) {
            return !e.rei || !e.rei.toJS() || t && t.toJS() && t.gte(e.rei) ? t : e.rei;
          }, new ye(""));
        }
      }, {
        key: "setProduct",
        value: function (t) {
          var e,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          this.update({
            product: t.toJS()
          }), t && (null !== (e = this.rate) && void 0 !== e && e.units && !ye.isCompatible(this.rate.units.split("/")[0], t.baseUnit) && (this.rate.units = ""), r && (this.notes = r.text));
        }
      }, {
        key: "isOrganic",
        get: function () {
          var t;
          return null === (t = this.product) || void 0 === t ? void 0 : t.isOrganic;
        }
      }], [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/recommendation/product_application";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(s), "getAttributeDefinition", this).call(this);
          return fo(fo({}, t), {}, {
            schema: fo(fo({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: fo(fo({}, t.type), {}, {
              defaultValue: this.type
            }),
            applicationMethod: {
              name: "Application Method",
              key: "applicationMethod",
              type: "string"
            },
            cropNames: {
              name: "Crop Names",
              key: "cropNames",
              type: "array"
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            }
          });
        }
      }]), s;
    }(wt(po, ft, Qt, Xt, Vt)), w(uo, "type", "IF2::Recommendation::ProductApplication"), w(uo, "schema", "if2/recommendation/product_application/v1"), $((ao = so).prototype, "name", [V.computed], Object.getOwnPropertyDescriptor(ao.prototype, "name"), ao.prototype), $(ao.prototype, "cropLabels", [V.computed], Object.getOwnPropertyDescriptor(ao.prototype, "cropLabels"), ao.prototype), $(ao.prototype, "phi", [V.computed], Object.getOwnPropertyDescriptor(ao.prototype, "phi"), ao.prototype), $(ao.prototype, "rei", [V.computed], Object.getOwnPropertyDescriptor(ao.prototype, "rei"), ao.prototype), $(ao.prototype, "setProduct", [V.action], Object.getOwnPropertyDescriptor(ao.prototype, "setProduct"), ao.prototype), $(ao.prototype, "isOrganic", [V.computed], Object.getOwnPropertyDescriptor(ao.prototype, "isOrganic"), ao.prototype), ao);

    function vo(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function bo(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? vo(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : vo(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Oo = (mo = ho = function (e) {
      r(s, e);
      var n,
          a,
          u = (n = s, a = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (a) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function s() {
        var e;
        t(this, s);

        for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

        return w(o(e = u.call.apply(u, [this].concat(n))), "unitLimit", .75), w(o(e), "isMetric", function (t) {
          return ["mL", "L", "grams", "g", "kg"].includes(t);
        }), w(o(e), "toLargeUnit", function (t) {
          var r = e.isMetric(t.units),
              n = t.isCompatible("lbs");
          return r && n ? t.to("kg") : r && !n ? t.to("L") : !r && n ? t.to("lbs") : r || n || !t.isCompatible("gal") ? t : t.to("gal");
        }), w(o(e), "toSmallUnit", function (t) {
          var e;

          switch (t.units) {
            case "kg":
              e = "grams";
              break;

            case "L":
              e = "mL";
              break;

            case "lbs":
              e = "oz";
              break;

            case "gal":
              e = "floz";
              break;

            default:
              e = t.units;
          }

          return t.to(e);
        }), e;
      }

      return R(s, [{
        key: "totalAcres",
        get: function () {
          return 0 === this.totalAcresScalar || this.totalAcresScalar ? new ye("".concat(this.totalAcresScalar, " acre")) : new ye("");
        }
      }, {
        key: "productTotalQuantity",
        get: function () {
          var t, e, r, n, o, i, c;
          return (0 === (null === (t = this.rate) || void 0 === t ? void 0 : t.scalar) || null !== (e = this.rate) && void 0 !== e && e.scalar) && (0 === (null === (r = this.totalAcres) || void 0 === r ? void 0 : r.scalar) || null !== (n = this.totalAcres) && void 0 !== n && n.scalar) ? (this.isPerArea && (o = null === (i = this.rate) || void 0 === i ? void 0 : i.mul(this.totalAcres)), this.isPerVolume && (o = null === (c = this.rate) || void 0 === c ? void 0 : c.mul(this.gallonsPerAcre).mul(this.totalAcres)), o ? (0 !== o.scalar && o.units && (o = this.toLargeUnit(o)).scalar < this.unitLimit && (o = this.toSmallUnit(o)), o.updateScalar(o.scalar * this.coverage), o) : new ye("")) : new ye("");
        }
      }, {
        key: "productPerAcre",
        get: function () {
          return this.isPerVolume ? this.rate.mul(this.gallonsPerAcre) : this.rate;
        }
      }, {
        key: "productPerVolume",
        get: function () {
          var t = new ye(this.gallonsPerAcre);
          return ye.isQuantityTruthy(t) ? this.isPerArea ? this.rate.div(t) : this.rate : new ye();
        }
      }, {
        key: "productTankAmount",
        get: function () {
          var t, e, r, n, o, i, c, a;
          if (0 !== (null === (t = this.rate) || void 0 === t ? void 0 : t.scalar) && (null === (e = this.rate) || void 0 === e || !e.scalar) || 0 !== (null === (r = this.tankSize) || void 0 === r ? void 0 : r.scalar) && (null === (n = this.tankSize) || void 0 === n || !n.scalar) || "1/acre" === (null === (o = this.rate) || void 0 === o ? void 0 : o.units) || "1/hgal" === (null === (i = this.rate) || void 0 === i ? void 0 : i.units)) return new ye("");

          if (this.isPerArea) {
            var u, s;
            if (ye.isZero(this.gallonsPerAcre)) return new ye("");
            a = null === (u = this.rate) || void 0 === u || null === (s = u.div(this.gallonsPerAcre)) || void 0 === s ? void 0 : s.mul(this.tankSize);
          }

          return this.isPerVolume && (a = this.rate.mul(this.tankSize)), a ? (a.isCompatible(null === (c = this.rate) || void 0 === c ? void 0 : c.numeratorUnits) && (a = a.to(this.rate.numeratorUnits)), a) : new ye("");
        }
      }, {
        key: "isPerArea",
        get: function () {
          var t, e;
          return null === (t = this.rate) || void 0 === t ? void 0 : t.isCompatible(ye.toQty(null === (e = this.product) || void 0 === e ? void 0 : e.baseUnitPerArea));
        }
      }, {
        key: "isPerVolume",
        get: function () {
          var t, e;
          return null === (t = this.rate) || void 0 === t ? void 0 : t.isCompatible(ye.toQty(null === (e = this.product) || void 0 === e ? void 0 : e.baseUnitPerVolume));
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          return bo(bo({}, A(c(s), "getAttributeDefinition", this).call(this)), {}, {
            totalAcresScalar: {
              name: "Total Acres",
              key: "totalAcresScalar",
              type: "number"
            },
            gallonsPerAcre: {
              name: "Gallons Per Acre",
              key: "gallonsPerAcre",
              type: "string"
            },
            tankSize: {
              name: "Tank Size",
              key: "tankSize",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            coverage: {
              name: "Coverage",
              key: "coverage",
              type: "number",
              defaultValue: 1
            }
          });
        }
      }]), s;
    }(go), w(ho, "type", "IF2::Recommendation::ProductApplicationCalculation"), $((yo = mo).prototype, "totalAcres", [V.computed], Object.getOwnPropertyDescriptor(yo.prototype, "totalAcres"), yo.prototype), $(yo.prototype, "productTotalQuantity", [V.computed], Object.getOwnPropertyDescriptor(yo.prototype, "productTotalQuantity"), yo.prototype), $(yo.prototype, "productPerAcre", [V.computed], Object.getOwnPropertyDescriptor(yo.prototype, "productPerAcre"), yo.prototype), $(yo.prototype, "productPerVolume", [V.computed], Object.getOwnPropertyDescriptor(yo.prototype, "productPerVolume"), yo.prototype), $(yo.prototype, "productTankAmount", [V.computed], Object.getOwnPropertyDescriptor(yo.prototype, "productTankAmount"), yo.prototype), $(yo.prototype, "isPerArea", [V.computed], Object.getOwnPropertyDescriptor(yo.prototype, "isPerArea"), yo.prototype), $(yo.prototype, "isPerVolume", [V.computed], Object.getOwnPropertyDescriptor(yo.prototype, "isPerVolume"), yo.prototype), yo);

    var Po = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "failures",
        value: function (t) {
          var e = [];
          return e = (e = (e = (e = e.concat(this.cropAndMethodFailures(t))).concat(this.maxPerApplicationFailures(t))).concat(this.minSprayRateFailures(t))).concat(this.maxSprayRateFailures(t));
        }
      }, {
        key: "cropAndMethodFailures",
        value: function (t) {
          var e = this,
              r = [];
          return t.productApplications.forEach(function (n) {
            var o = e.constructor.cropAndMethodFailure(t, n);
            o && r.push(new ne({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }, {
        key: "maxPerApplicationFailures",
        value: function (t) {
          var e = this,
              r = [];
          return t.productApplications.forEach(function (n) {
            var o = e.constructor.maxPerApplicationFailure(t, n);
            o && r.push(new ne({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }, {
        key: "minSprayRateFailures",
        value: function (t) {
          var e = this,
              r = [];
          return t.productApplications.forEach(function (n) {
            var o = e.constructor.minSprayRateFailure(t, n);
            o && r.push(new ne({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }, {
        key: "maxSprayRateFailures",
        value: function (t) {
          var e = this,
              r = [];
          return t.productApplications.forEach(function (n) {
            var o = e.constructor.maxSprayRateFailure(t, n);
            o && r.push(new ne({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }], [{
        key: "maxPerApplicationFailure",
        value: function (t, e) {
          var r = t.newCalculationFor(e);

          if (e.product && "function" == typeof e.product.labelsForUseOn) {
            var n = e.product.labelsForUseOn(t);

            if (e.rate.scalar && e.rate.units) {
              var o = n.filter(function (t) {
                return !t.satisfiesMaxPerApplicationConstraint(r);
              });
              return (0, X.isEmpty)(o) ? void 0 : "".concat(r.rate.displayValue, " exceeds the labeled max application rate for ").concat(e.product.name, ": ").concat(Et(o.map(function (t) {
                return [t.crop, t.maxPerApplication.displayValue].join(" -> ");
              })));
            }
          }
        }
      }, {
        key: "cropAndMethodFailure",
        value: function (t, e) {
          if (e.product && "function" == typeof e.product.isLabeledForUseOn && !e.product.isLabeledForUseOn(t)) return "".concat(e.product.name, " is not labeled for the given crops and application method");
        }
      }, {
        key: "minSprayRateFailure",
        value: function (t, e) {
          var r,
              n = (null === (r = e.product) || void 0 === r ? void 0 : r.labelsForUseOn(t)) || [];
          if (ye.isQuantityTruthy(t.targetRate) && n.some(function (e) {
            return ye.isQuantityTruthy(e.minSprayRate) && t.targetRate.lt(e.minSprayRate);
          })) return "".concat(t.targetRate.displayValue, " is less than the minimimum required spray rate for ").concat(e.product.name);
        }
      }, {
        key: "maxSprayRateFailure",
        value: function (t, e) {
          var r,
              n = (null === (r = e.product) || void 0 === r ? void 0 : r.labelsForUseOn(t)) || [];
          if (ye.isQuantityTruthy(t.targetRate) && n.some(function (e) {
            return ye.isQuantityTruthy(e.maxSprayRate) && t.targetRate.gt(e.maxSprayRate);
          })) return "".concat(t.targetRate.displayValue, " is greater than the maximum required spray rate for ").concat(e.product.name);
        }
      }]), u;
    }(oe);

    function jo(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function wo(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? jo(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : jo(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var ko = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return wo(wo({}, t), {}, {
            type: wo(wo({}, t.type), {}, {
              defaultValue: "IF2::User"
            })
          });
        }
      }, {
        key: "fromUser",
        value: function (t) {
          return new u({
            id: t.id,
            serial: t.serial,
            type: t.type,
            name: t.name
          });
        }
      }, {
        key: "fromModel",
        value: function (t) {
          return this.fromUser(t);
        }
      }]), u;
    }(wt(ve, M));

    function Ro(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ao(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ro(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ro(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Do = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/recommendation/written_by";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          return Ao(Ao({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            licenses: {
              key: "licenses",
              type: "array"
            }
          });
        }
      }, {
        key: "fromUser",
        value: function (t) {
          return new u({
            id: t.id,
            serial: t.serial,
            type: t.type,
            name: t.name,
            licenses: t.licenses
          });
        }
      }, {
        key: "fromModel",
        value: function (t) {
          return this.fromUser(t);
        }
      }]), u;
    }(wt(ko, Xt));

    function _o(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function xo(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? _o(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : _o(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var So = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return xo(xo({}, t), {}, {
            type: xo(xo({}, t.type), {}, {
              defaultValue: this.type
            }),
            product: {
              name: "Product",
              key: "product",
              type: "model",
              modelClass: oo,
              defaultValue: new oo()
            },
            text: {
              name: "Text",
              key: "text",
              type: "string"
            },
            title: {
              name: "Title",
              key: "title",
              type: "string"
            },
            user: {
              name: "User",
              key: "user",
              type: "model",
              modelClass: Do,
              defaultValue: new Do()
            }
          });
        }
      }]), u;
    }(wt(ge, x, I, G));

    w(So, "type", "IF2::Product::RecommendationNote");
    var Co = s(619),
        Eo = s.n(Co);

    var No = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "failures",
        value: function (t) {
          var e = this,
              r = [];
          return t.fields.forEach(function (n) {
            var o = e.constructor.failureMessage(t, n);
            o && r.push(new ne({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }], [{
        key: "failureMessage",
        value: function (t, e) {
          return !t.organic && e.organic ? "".concat(e.name, " is an organic field and cannot be included on a non-organic recommendation") : !t.organic && e.transitional ? "".concat(e.name, " is a transitional field and cannot be included on a non-organic recommendation") : void 0;
        }
      }]), u;
    }(oe);

    function Bo(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Mo(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Bo(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Bo(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Fo = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/recommendation/replaces";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return Mo(Mo({}, t), {}, {
            type: Mo(Mo({}, t.type), {}, {
              defaultValue: "IF2::Recommendation"
            }),
            date: {
              name: "Date",
              key: "date",
              type: "string"
            },
            accountId: {
              name: "Account Id",
              key: "accountId",
              type: "string"
            },
            status: {
              name: "Status",
              key: "status",
              type: "string"
            },
            accounts: {
              key: "accounts",
              type: "modelCollection",
              modelClass: je
            },
            writtenById: {
              name: "Written By Id",
              key: "writtenById",
              type: "string"
            }
          });
        }
      }, {
        key: "isRecommendationReference",
        value: function (t) {
          return t instanceof u;
        }
      }, {
        key: "fromRecommendation",
        value: function (t) {
          return new this({
            id: t.id,
            serial: t.serial,
            type: t.type,
            name: t.title,
            date: t.date,
            account_id: t.account.id,
            status: t.status,
            accounts: t.accounts,
            written_by_id: t.writtenBy.id
          });
        }
      }, {
        key: "fromModel",
        value: function (t) {
          return this.fromRecommendation(t);
        }
      }]), u;
    }(wt(ve, M, Xt));

    var To = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "failureDescription",
        value: function (t) {
          var e = this.value(t);
          return this.options.optional && !e ? null : this.fails("gt", e) ? "must be greater than ".concat(this.options.gt) : this.fails("gte", e) ? "must be greater than or equal to ".concat(this.options.gte) : this.fails("lt", e) ? "must be less than ".concat(this.options.lt) : this.fails("lte", e) ? "must be less than or equal to ".concat(this.options.lte) : null;
        }
      }, {
        key: "failure",
        value: function (t) {
          var e = this.failureDescription(t);

          if (e) {
            var r = ne.newFrom(this, t);
            return r.description = this.options.description || e, r;
          }
        }
      }, {
        key: "fails",
        value: function (t, e) {
          if (!e) return !0;
          var r = this.options[t];
          return null != r && ("gt" === t ? !(e > r) : "gte" === t ? !(e >= r) : "lt" === t ? !(e < r) : "lte" === t ? !(e <= r) : void 0);
        }
      }]), u;
    }(oe);

    var Io = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "failures",
        value: function (t) {
          var e = this,
              r = this.value(t);
          return Array.isArray(r) ? r.reduce(function (t, r) {
            return e.constructor.isValidatable(r) ? t.concat(r.failures().map(function (t) {
              return e.adopt(t);
            })) : t;
          }, []) : [];
        }
      }]), u;
    }(oe);

    function Lo(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function $o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Lo(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Lo(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Vo = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/recommendation/rejected";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          return $o($o({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            by: {
              name: "By",
              key: "by",
              type: "model",
              modelClass: ko,
              defaultValue: new ko()
            },
            reason: {
              name: "Reason",
              key: "reason",
              type: "string"
            },
            at: {
              name: "At",
              key: "at",
              type: "string"
            }
          });
        }
      }, {
        key: "isReject",
        value: function (t) {
          return t instanceof u;
        }
      }]), u;
    }(wt(ge, Xt));

    var Yo = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e) {
        var r;
        return t(this, u), (r = a.call(this, "Missing weight per volume on ".concat(null == e ? void 0 : e.name))).product = e, r;
      }

      return u;
    }(u(Error));

    var qo = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u(e, r) {
        var n;
        return t(this, u), (n = a.call(this, "Unknown unit '".concat(r, "' for ").concat(null == e ? void 0 : e.name))).product = e, n;
      }

      return u;
    }(u(Error)),
        Uo = function () {
      function e(r, n) {
        t(this, e), this.productApplicationCalculation = r, this.map = n;
      }

      return R(e, [{
        key: "product",
        get: function () {
          return this.productApplicationCalculation.product;
        }
      }, {
        key: "rate",
        get: function () {
          return this.productApplicationCalculation.rate;
        }
      }, {
        key: "productPerAcre",
        get: function () {
          return this.productApplicationCalculation.productPerAcre;
        }
      }, {
        key: "isPerArea",
        get: function () {
          return this.productApplicationCalculation.isPerArea;
        }
      }, {
        key: "isPerVolume",
        get: function () {
          return this.productApplicationCalculation.isPerVolume;
        }
      }, {
        key: "isLiquid",
        get: function () {
          return new ye(this.product.baseUnit).isCompatible("L");
        }
      }, {
        key: "isDry",
        get: function () {
          return new ye(this.product.baseUnit).isCompatible("lbs");
        }
      }, {
        key: "isIncalculable",
        get: function () {
          return !this.product || !this.product.hasNutrientAnalysis || !ye.isQuantityTruthy(this.productPerAcre);
        }
      }, {
        key: "appliedNutrientKeys",
        get: function () {
          return this.product.nutrientAnalysis.appliedNutrientKeys;
        }
      }, {
        key: "checkForNutrientError",
        value: function () {
          var t = !1;
          return this.product.baseUnit || (this.addNutrientError(new v(this.product)), t = !0), this.isLiquid && !ye.isQuantityTruthy(this.product.massPerVolume) && (this.addNutrientError(new Yo(this.product)), t = !0), (this.isPerVolume || this.isPerArea) && (this.isLiquid || this.isDry) || (this.addNutrientError(new qo(this.product, this.rate.units)), t = !0), t;
        }
      }, {
        key: "addNutrientError",
        value: function (t) {
          return this.map.has("incompleteAnalysis") ? this.map.get("incompleteAnalysis").push(t) : this.map.set("incompleteAnalysis", [t]), this.map;
        }
      }, {
        key: "addNutrient",
        value: function (t, e) {
          this.map.has(t) ? this.map.set(t, this.map.get(t).add(e)) : this.map.set(t, e);
        }
      }, {
        key: "addDryProductNutrients",
        value: function (t) {
          var e = this.productPerAcre.mul(Number(this.product.nutrientAnalysis[t]) / 100).to("lbs/acre");
          this.addNutrient(t, e);
        }
      }, {
        key: "addLiquidProductNutrients",
        value: function (t) {
          var e = this.productPerAcre.mul(this.product.massPerVolume).mul(Number(this.product.nutrientAnalysis[t]) / 100).to("lbs/acre");
          this.addNutrient(t, e);
        }
      }]), e;
    }(),
        zo = function () {
      function e(r) {
        t(this, e), this.productApplicationCalculations = r, this.totals = this.constructor.getTotals(this.productApplicationCalculations);
      }

      return R(e, null, [{
        key: "getTotals",
        value: function (t) {
          return t.reduce(function (t, e) {
            var r = new Uo(e, t);
            return r.isIncalculable || r.checkForNutrientError() || r.appliedNutrientKeys.forEach(function (t) {
              r.isLiquid && r.addLiquidProductNutrients(t), r.isDry && r.addDryProductNutrients(t);
            }), t;
          }, new Map().set("n", new ye("0 lbs/acre")).set("p", new ye("0 lbs/acre")).set("k", new ye("0 lbs/acre")));
        }
      }]), e;
    }();

    var Jo = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "failures",
        value: function (t) {
          var e = this,
              r = [];
          return t.productApplications.forEach(function (n) {
            t.fields.forEach(function (o) {
              var i = e.constructor.failureMessage(t, n, o);
              i && r.push(new ne({
                key: e.attribute,
                value: n,
                fullMessage: i
              }));
            });
          }), r;
        }
      }], [{
        key: "failureMessage",
        value: function (t, e, r) {
          var n;
          if ((null === (n = e.product) || void 0 === n || !n.isOrganic) && r.transitional) return "".concat(e.product.name, ' cannot be used on transitional field "').concat(r.name, '"');
        }
      }]), u;
    }(oe);

    var Go,
        Ho,
        Ko,
        Qo,
        Wo,
        Zo,
        Xo,
        ti,
        ei,
        ri = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "failure",
        value: function (t) {
          var e = this.value(t);

          if (!this.options.onlyIf || this.options.onlyIf()) {
            var r = new ye(e);
            if (!ye.isQuantityTruthy(r)) return;
            if (!r.isCompatible(this.options.isCompatibleWith)) return this.options.description = "".concat(r.units, " is not compatible with ").concat(this.options.isCompatibleWith, "."), ne.newFrom(this, t);
          }
        }
      }]), u;
    }(oe),
        ni = ["target_gallons_per_acre", "copied_from"];

    function oi(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ii(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? oi(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : oi(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var ci,
        ai,
        ui,
        si = ["draft", "complete", "void", "replaced", "pending-approval"],
        pi = (ei = ti = function (e) {
      r(s, e);
      var n,
          a,
          u = (n = s, a = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (a) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function s() {
        var e;
        t(this, s);

        for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

        return w(o(e = u.call.apply(u, [this].concat(n))), "validations", [new de("documentNumber", {
          attributeLabel: "Document Number",
          fullMessage: "Document number has not yet been assigned. The recommendation must have synced with the server before a number can be assigned"
        }), new de("date"), new de("applicationMethod"), new de("targetRate", {
          onlyIf: function () {
            return e.constructor.requiresRate(e.applicationMethod);
          }
        }), new Ln("productApplications"), new Jo("productApplications"), new Po("productApplications"), new To("coverage", {
          gt: 0,
          lte: 1,
          description: "must be > 0 and <= 100"
        }), new Io("productApplications"), new No("fields"), new ri("tankSize", {
          onlyIf: function () {
            return e.constructor.requiresTankSize(e.applicationMethod);
          },
          isCompatibleWith: "L"
        }), new ri("targetRate", {
          onlyIf: function () {
            return e.constructor.requiresRate(e.applicationMethod);
          },
          isCompatibleWith: "L/acre"
        })]), L(o(e), "void", Ho, o(e)), w(o(e), "findProductApplication", function (t) {
          return e.productApplications.find(function (e) {
            return e.id === t;
          });
        }), L(o(e), "pushProductApplication", Ko, o(e)), L(o(e), "removeProductApplication", Qo, o(e)), L(o(e), "moveProductApplication", Wo, o(e)), L(o(e), "addField", Zo, o(e)), L(o(e), "removeField", Xo, o(e)), e;
      }

      return R(s, [{
        key: "associatedAccountIds",
        get: function () {
          var t;
          return yt([].concat((null === (t = this.account) || void 0 === t ? void 0 : t.id) || []).concat((this.accounts || []).map(function (t) {
            return t.id;
          })));
        }
      }, {
        key: "totalAcres",
        get: function () {
          return this.fields.reduce(function (t, e) {
            var r, n;
            return null != e && e.area.isCompatible("acre") && (n = null == e ? void 0 : e.area.to("acre")), t + ((null === (r = n) || void 0 === r ? void 0 : r.scalar) || 0);
          }, 0);
        }
      }, {
        key: "title",
        get: function () {
          return this.name || this.dateTitle;
        }
      }, {
        key: "dateTitle",
        get: function () {
          return En()(this.date, ["M/D/YYYY", "YYYY-MM-DD"]).format("M/D/YYYY") || "";
        }
      }, {
        key: "updatedAtTitle",
        get: function () {
          return En()(this.updatedAt, ["M/D/YYYY", "YYYY-MM-DD"]).format("M/D/YYYY") || "";
        }
      }, {
        key: "fieldAccounts",
        get: function () {
          return dt("id", this.fields.map(function (t) {
            return t.account;
          }));
        }
      }, {
        key: "maxPhi",
        get: function () {
          return ye.max.apply(ye, z(this.productApplications.map(function (t) {
            return t.phi;
          })));
        }
      }, {
        key: "maxRei",
        get: function () {
          return ye.max.apply(ye, z(this.productApplications.map(function (t) {
            return t.rei;
          })));
        }
      }, {
        key: "isComplete",
        get: function () {
          return "complete" === this.status;
        }
      }, {
        key: "isDraft",
        get: function () {
          return !this.status || "draft" === this.status;
        }
      }, {
        key: "isProvisional",
        get: function () {
          return !this.documentNumber;
        }
      }, {
        key: "isVoid",
        get: function () {
          return "void" === this.status || "replaced" === this.status;
        }
      }, {
        key: "isReplaced",
        get: function () {
          return "replaced" === this.status;
        }
      }, {
        key: "isRejected",
        get: function () {
          return Vo.isReject(this.rejected);
        }
      }, {
        key: "isPendingApproval",
        get: function () {
          return "pending-approval" === this.status;
        }
      }, {
        key: "defaultFilename",
        get: function () {
          var t = "".concat(this.defaultFilenameBase, ".pdf");
          return Eo()(t, {
            replacement: "_"
          });
        }
      }, {
        key: "defaultFilenameBase",
        get: function () {
          var t;
          return [].concat(this.formatDate("YYYY-MM-DD") || []).concat((null === (t = this.account) || void 0 === t ? void 0 : t.name) || []).concat(this.name ? "- ".concat(this.name) : []).concat(this.isDraft ? "[Draft]" : []).concat("(".concat(this.documentNumber || "provisional", ")")).join(" ");
        }
      }, {
        key: "defaultFilenamePendingApproval",
        get: function () {
          var t = "".concat(this.defaultFilenameBase, " (pending approval).pdf");
          return Eo()(t, {
            replacement: "_"
          });
        }
      }, {
        key: "hasProductNotes",
        get: function () {
          return this.productApplications.filter(function (t) {
            return t.notes.trim().length > 0;
          }).length > 0;
        }
      }, {
        key: "productNotes",
        get: function () {
          return this.productApplications.map(function (t) {
            return t.notes;
          }).join("\n");
        }
      }, {
        key: "productApplicationCalculations",
        get: function () {
          var t = this;
          return (this.productApplications || []).map(function (e) {
            return t.newCalculationFor(e);
          });
        }
      }, {
        key: "currentCropNamesFromFields",
        get: function () {
          return yt((this.fields || []).map(function (t) {
            return t.cropName;
          }));
        }
      }, {
        key: "coveragePercentString",
        get: function () {
          return Nt(this.coverage);
        }
      }, {
        key: "hasErrors",
        get: function () {
          return this.failures().length > 0;
        }
      }, {
        key: "nutrientTotals",
        get: function () {
          return zo.getTotals(this.productApplicationCalculations);
        }
      }, {
        key: "hasNutrients",
        get: function () {
          return this.productApplications.some(function (t) {
            return t.product.hasNutrientAnalysis;
          });
        }
      }, {
        key: "targetGallonsPerAcre",
        get: function () {
          return this.targetRate;
        }
      }, {
        key: "newCalculationFor",
        value: function (t) {
          var e, r;
          return new Oo(ii(ii({}, t.toJS()), {}, {
            tankSize: (null === (e = this.tankSize) || void 0 === e ? void 0 : e.toJS()) || "",
            totalAcresScalar: this.totalAcres,
            gallonsPerAcre: (null === (r = this.targetRate) || void 0 === r ? void 0 : r.displayValue) || "",
            coverage: this.coverage
          }));
        }
      }, {
        key: "fieldsForAccount",
        value: function (t) {
          return this.fields.filter(function (e) {
            return e.account.id === t.id;
          });
        }
      }, {
        key: "formatDate",
        value: function (t) {
          return En()(this.date, ["M/D/YYYY", "YYYY-MM-DD"]).format(t);
        }
      }, {
        key: "toJS",
        value: function () {
          var t,
              e,
              r,
              n,
              o = A(c(s.prototype), "toJS", this).call(this);
          return o.replaces = o.replaces || (null === (t = this.replaces) || void 0 === t ? void 0 : t.toJS()) || null, o.approved = o.approved || (null === (e = this.approved) || void 0 === e ? void 0 : e.toJS()) || null, o.rejected = o.rejected || (null === (r = this.rejected) || void 0 === r ? void 0 : r.toJS()) || null, o.target_rate = o.target_rate || (null === (n = this.targetRate) || void 0 === n ? void 0 : n.toJS()) || null, o;
        }
      }], [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/recommendation";
        }
      }, {
        key: "getSchemaMigrations",
        value: function () {
          return ii(ii({}, A(c(s), "getSchemaMigrations", this).call(this)), {}, {
            default: li,
            "if2/recommendation/v0": li
          });
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(s), "getAttributeDefinition", this).call(this);
          return ii(ii({}, t), {}, {
            schema: ii(ii({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: ii(ii({}, t.type), {}, {
              defaultValue: this.type
            }),
            rev: {
              key: "rev",
              jsKey: "_rev",
              type: "string"
            },
            date: {
              name: "Date",
              key: "date",
              type: "string"
            },
            timing: {
              name: "Timing",
              key: "timing",
              type: "string"
            },
            writtenBy: {
              name: "Written By",
              key: "writtenBy",
              type: "model",
              modelClass: Do,
              defaultValue: new Do()
            },
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Re,
              defaultValue: new Re()
            },
            accounts: {
              name: "Accounts",
              key: "accounts",
              type: "modelCollection",
              modelClass: Re
            },
            documentNumber: {
              name: "Document Number",
              key: "documentNumber",
              type: "string"
            },
            replaces: {
              name: "Replaces",
              key: "replaces",
              type: "model",
              modelClass: Fo
            },
            cropNames: {
              name: "Crop Names",
              key: "cropNames",
              type: "array"
            },
            organic: {
              name: "Organic",
              key: "organic",
              type: "boolean"
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            },
            targetRate: {
              name: "Target GPA",
              key: "targetRate",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            productApplications: {
              name: "Product Application",
              key: "productApplications",
              type: "modelCollection",
              modelClass: go
            },
            fields: {
              name: "Field",
              key: "fields",
              type: "modelCollection",
              modelClass: fn
            },
            status: {
              name: "Status",
              key: "status",
              type: "string",
              defaultValue: "draft"
            },
            tankSize: {
              name: "Tank Size",
              key: "tankSize",
              type: "model",
              modelClass: ye,
              defaultValue: new ye("")
            },
            optimumTemperature: {
              name: "Optimum Temperature",
              key: "optimumTemperature",
              type: "string"
            },
            areasToTreat: {
              name: "Areas To Treat",
              key: "areasToTreat",
              type: "string",
              defaultValue: this.areasToTreatOptions[0]
            },
            rejected: {
              name: "Rejected",
              key: "rejected",
              type: "model",
              modelClass: Vo
            },
            coverage: {
              name: "Coverage",
              key: "coverage",
              type: "number",
              defaultValue: 1
            },
            showMapWhenPrinting: {
              key: "showMapWhenPrinting",
              type: "boolean"
            },
            showProductTotals: {
              name: "Show Product Totals",
              key: "showProductTotals",
              type: "boolean",
              defaultValue: !0
            },
            showNutrientTotals: {
              name: "Show Nutrient Totals",
              key: "showNutrientTotals",
              type: "boolean",
              defaultValue: !0
            },
            usePerAppliedAcreVerbiage: {
              name: "Use Per Applied Acre Verbiage",
              key: "usePerAppliedAcreVerbiage",
              type: "boolean"
            }
          });
        }
      }, {
        key: "isRecommendation",
        value: function (t) {
          return t instanceof s;
        }
      }, {
        key: "groupRecommendationsByAccount",
        value: function (t) {
          return (0, X.groupBy)(function (t) {
            var e;
            return null === (e = t.account) || void 0 === e ? void 0 : e.name;
          })(t);
        }
      }]), s;
    }(wt(ge, x, M, E, I, ft, zt, Qt, Xt, Y, Vt)), w(ti, "type", "IF2::Recommendation"), w(ti, "schema", "if2/recommendation/v1"), w(ti, "findAppOptionByText", function (t) {
      return ti.applicationMethods.find(function (e) {
        return e.text === t;
      });
    }), w(ti, "areasToTreatOptions", ["See Block List"]), w(ti, "timingOptions", ["Today", "Next 7 Days", "Next 14 Days"]), w(ti, "optimumTemperatureOptions", ["35º - 85ºF", "40º - 75ºF", "40º - 80ºF", "45º - 75ºF", "45º - 80ºF"]), w(ti, "targetRateOptions", ["25", "50", "80", "100", "200", "400"]), w(ti, "tankSizeOptions", ["100", "150", "200", "300", "400", "500"]), w(ti, "draftFilter", function (t) {
      return (0, X.compose)((0, X.anyPass)([(0, X.equals)("draft"), X.isNil, X.isEmpty]), t("status"));
    }), w(ti, "rejectedFilter", function (t) {
      return (0, X.compose)((0, X.anyPass)([(0, X.is)(Object), (0, X.is)(String)]), t("rejected"));
    }), w(ti, "statusFilter", (0, X.curry)(function (t, e) {
      return (0, X.compose)((0, X.equals)(t), e("status"));
    })), w(ti, "voidFilter", function (t) {
      return (0, X.compose)((0, X.anyPass)([(0, X.equals)("void"), (0, X.equals)("replaced")]), t("status"));
    }), Ho = $((Go = ei).prototype, "void", [V.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), $(Go.prototype, "associatedAccountIds", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "associatedAccountIds"), Go.prototype), $(Go.prototype, "totalAcres", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "totalAcres"), Go.prototype), $(Go.prototype, "title", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "title"), Go.prototype), $(Go.prototype, "dateTitle", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "dateTitle"), Go.prototype), $(Go.prototype, "updatedAtTitle", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "updatedAtTitle"), Go.prototype), $(Go.prototype, "fieldAccounts", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "fieldAccounts"), Go.prototype), $(Go.prototype, "maxPhi", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "maxPhi"), Go.prototype), $(Go.prototype, "maxRei", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "maxRei"), Go.prototype), $(Go.prototype, "isComplete", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "isComplete"), Go.prototype), $(Go.prototype, "isDraft", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "isDraft"), Go.prototype), $(Go.prototype, "isProvisional", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "isProvisional"), Go.prototype), $(Go.prototype, "isVoid", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "isVoid"), Go.prototype), $(Go.prototype, "isReplaced", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "isReplaced"), Go.prototype), $(Go.prototype, "isRejected", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "isRejected"), Go.prototype), $(Go.prototype, "isPendingApproval", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "isPendingApproval"), Go.prototype), $(Go.prototype, "defaultFilename", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "defaultFilename"), Go.prototype), $(Go.prototype, "defaultFilenameBase", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "defaultFilenameBase"), Go.prototype), $(Go.prototype, "defaultFilenamePendingApproval", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "defaultFilenamePendingApproval"), Go.prototype), $(Go.prototype, "hasProductNotes", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "hasProductNotes"), Go.prototype), $(Go.prototype, "productNotes", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "productNotes"), Go.prototype), $(Go.prototype, "productApplicationCalculations", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "productApplicationCalculations"), Go.prototype), $(Go.prototype, "currentCropNamesFromFields", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "currentCropNamesFromFields"), Go.prototype), $(Go.prototype, "coveragePercentString", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "coveragePercentString"), Go.prototype), $(Go.prototype, "hasErrors", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "hasErrors"), Go.prototype), $(Go.prototype, "nutrientTotals", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "nutrientTotals"), Go.prototype), $(Go.prototype, "hasNutrients", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "hasNutrients"), Go.prototype), $(Go.prototype, "targetGallonsPerAcre", [V.computed], Object.getOwnPropertyDescriptor(Go.prototype, "targetGallonsPerAcre"), Go.prototype), Ko = $(Go.prototype, "pushProductApplication", [V.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var t = this;
        return function (e) {
          var r = t.productApplications.find(function (t) {
            return t.id === e.id;
          });
          r ? r.update(e.toJS()) : t.productApplications.push(e);
        };
      }
    }), Qo = $(Go.prototype, "removeProductApplication", [V.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var t = this;
        return function (e) {
          var r = t.productApplications.findIndex(function (t) {
            return t.id === e.id;
          });
          r < 0 || t.productApplications.splice(r, 1);
        };
      }
    }), Wo = $(Go.prototype, "moveProductApplication", [V.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var t = this;
        return function (e, r) {
          var n = t.productApplications.findIndex(function (t) {
            return t.id === e.id;
          });

          if (!(n < 0 || r < 0 || n === r)) {
            var o = $n(t.productApplications.splice(n, 1), 1)[0];

            if (o) {
              t.productApplications.splice(r, 0, o);
              var i = [];
              return t.productApplications.forEach(function (t, e) {
                t.position !== e && (t.update({
                  position: e
                }), i.push(t));
              }), i;
            }
          }
        };
      }
    }), Zo = $(Go.prototype, "addField", [V.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var t = this;
        return function (e) {
          return t.fields.push(e);
        };
      }
    }), Xo = $(Go.prototype, "removeField", [V.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var t = this;
        return function (e) {
          var r = t.fields.findIndex(function (t) {
            return t.id === e.id;
          });
          r < 0 || t.fields.splice(r, 1);
        };
      }
    }), Go);

    function li(t) {
      t.target_gallons_per_acre, t.copied_from;
      var e = jn(t, ni),
          r = ii(ii(ii({}, {
        replaces: null,
        approved: null,
        rejected: null,
        show_nutrient_totals: !0,
        show_product_totals: !0,
        show_map_when_printing: !1,
        use_per_applied_acre_verbiage: !1,
        accounts: []
      }), e), {
        schema: "if2/recommendation/v1"
      });
      r.status = e.status || si[0], "voided" === e.status && (r.status = "void"), r.coverage = parseFloat(e.coverage || 1), yi(r, {
        target_rate: e.target_gallons_per_acre || null
      });
      var n = {
        type: "IF2::Account",
        full_name: "",
        client_path: []
      },
          o = {
        type: "IF2::Account",
        full_name: ""
      };
      di(r.account, n, o);
      var i = r.accounts;
      return Array.isArray(i) && i.forEach(function (t) {
        di(t, n, o);
      }), fi(r.written_by) && yi(r.written_by, {
        type: "IF2::User",
        licenses: []
      }), r;
    }

    function fi(t) {
      return "object" === n(t) && !Array.isArray(t) && null !== t;
    }

    function yi(t, e) {
      Object.keys(e).forEach(function (r) {
        t[r] = t[r] || e[r];
      });
    }

    function di(t, e, r) {
      fi(t) && (yi(t, e), Array.isArray(t.client_path) && t.client_path.forEach(function (t) {
        fi(t) && yi(t, r);
      }));
    }

    function hi(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function mi(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? hi(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : hi(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    s(5506);
    var gi,
        vi,
        bi,
        Oi = (ui = ai = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "computedGallonsApplied",
        get: function () {
          var t;
          if (this.gallonsApplied) return this.gallonsApplied;
          var e = new ye(this.tanksCompleted),
              r = new ye(null === (t = this.sprayer) || void 0 === t ? void 0 : t.tankSize);
          return ye.isQuantityTruthy(e) && this.tanksCompleted && ye.isQuantityTruthy(r) && r.isCompatible("gal") ? r.mul(e).to("gal").scalar : 0;
        }
      }, {
        key: "matchesTargetGallonsPerAcre",
        value: function (t) {
          return this.constructor.gallonsPerAcreScalar(this.sprayRate) === parseFloat(t);
        }
      }, {
        key: "warningTranslationKeysGiven",
        value: function (t) {
          var e,
              r = [];
          return this.sprayer && this.spreader && this.sprayer.id && this.spreader.id && r.push("this_applicator_has_both_sprayer_and_spreader"), this.sprayer && this.sprayer.id && ["Broadcast Spread"].includes(t) && r.push("applicator_has_a_sprayer_for_a_spreader_only_application_method"), this.spreader && this.spreader.id && ["Aerial", "Airblast", "Broadcast Spray", "Banded Spray"].includes(t) && r.push("applicator_has_a_spreader_for_a_sprayer_only_application_method"), null !== (e = this.tractor) && void 0 !== e && e.id || !["Airblast", "Broadcast Spray", "Banded Spray", "Subsurface Shank"].includes(t) || r.push("applicator_requires_a_tractor_for_this_application_method"), r;
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return mi(mi({}, t), {}, {
            type: mi(mi({}, t.type), {}, {
              defaultValue: this.type
            }),
            applicationId: {
              name: "Application ID",
              key: "applicationId",
              type: "number"
            },
            gallonsApplied: {
              name: "Gallons Applied",
              key: "gallonsApplied",
              type: "number"
            },
            sprayRate: {
              name: "Spray Rate",
              key: "sprayRate",
              type: "model",
              modelClass: ye
            },
            tanksCompleted: {
              name: "Tanks Completed",
              key: "tanksCompleted",
              type: "number"
            },
            tankCleaned: {
              name: "Tank Cleaned",
              key: "tankCleaned",
              type: "boolean"
            }
          });
        }
      }, {
        key: "gallonsPerAcreScalar",
        value: function (t) {
          return ye.isCompatible(t, "gal/acre") && new ye(t).to("gal/acre").scalar || null;
        }
      }, {
        key: "predictedAcresTreated",
        value: function (t, e) {
          var r = ye.isQuantityTruthy(new ye(t.sprayRate)) && this.gallonsPerAcreScalar(t.sprayRate) || parseFloat(e);
          return r && t.computedGallonsApplied ? t.computedGallonsApplied / r : 0;
        }
      }]), u;
    }(lr), w(ai, "type", "IF2::SprayRecord::Applicator"), $((ci = ui).prototype, "computedGallonsApplied", [V.computed], Object.getOwnPropertyDescriptor(ci.prototype, "computedGallonsApplied"), ci.prototype), ci);

    function Pi(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ji(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Pi(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Pi(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var wi = (bi = vi = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, [{
        key: "isOvernight",
        get: function () {
          var t = this.constructor.parseTime(this.startTime),
              e = this.constructor.parseTime(this.stopTime);
          return t && t > e;
        }
      }, {
        key: "windDirectionAndSpeed",
        get: function () {
          var t,
              e = ye.displayValue(this.lowWindSpeed),
              r = ye.displayValue(this.highWindSpeed);
          return e && r && e !== r ? t = "".concat(this.lowWindSpeed.scalar, "-").concat(this.highWindSpeed.scalar, " ").concat(this.highWindSpeed.units) : e ? t = e : r && (t = r), t ? this.windDirection && "0 mph" !== t ? "".concat(this.windDirection, " ").concat(t) : t : "";
        }
      }, {
        key: "totalGallonsApplied",
        get: function () {
          var t;
          return this.gallonsAppliedOverride ? parseFloat(this.gallonsAppliedOverride) : (null === (t = this.applicators.reduce(function (t, e) {
            return new ye(t).add("".concat(e.computedGallonsApplied, " gal")).to("gal");
          }, "0 gal")) || void 0 === t ? void 0 : t.scalar) || 0;
        }
      }, {
        key: "totalAcresCompleted",
        get: function () {
          return this.fieldCompletions.length < 1 ? 0 : this.fieldCompletions.reduce(function (t, e) {
            return t + parseFloat((null == e ? void 0 : e.acres) || 0);
          }, 0);
        }
      }, {
        key: "totalTreatedAcres",
        get: function () {
          return (0, X.compose)(X.sum, (0, X.map)((0, X.prop)("treatedAcres")))(this.fieldCompletions);
        }
      }, {
        key: "sprayRateOutliers",
        get: function () {
          var t;
          if (null === (t = this.applicators) || void 0 === t || !t.length) return [];
          var e = {};
          this.applicators.forEach(function (t) {
            var r = new ye(t.sprayRate),
                n = r.isBlank ? "empty" : r.displayValue;
            e[n] ? e[n] += 1 : e[n] = 1;
          });
          var r = Object.entries(e).reduce(function (t, e) {
            var r = $n(e, 2),
                n = r[0],
                o = r[1];
            return o > t.count && (t.rate = n, t.count = o), t;
          }, {
            rate: "",
            count: 0
          });
          return this.applicators.reduce(function (t, e) {
            var n = new ye(e.sprayRate);
            return n.isBlank ? (t.push("empty"), t) : (n.eq(new ye(r.rate)) || t.push(e.sprayRate.displayValue), t);
          }, []);
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return ji(ji({}, t), {}, {
            date: {
              name: "Date",
              key: "date",
              type: "string"
            },
            type: ji(ji({}, t.type), {}, {
              defaultValue: this.type
            }),
            sprayRecordId: {
              name: "Spray Record ID",
              key: "sprayRecordId",
              type: "number"
            },
            startTime: {
              name: "Start Time",
              key: "startTime",
              type: "string"
            },
            stopTime: {
              name: "Stop Time",
              key: "stopTime",
              type: "string"
            },
            windDirection: {
              name: "Wind Direction",
              key: "windDirection",
              type: "string"
            },
            temperatureUnits: {
              name: "Temperature Units",
              key: "temperatureUnits",
              type: "string",
              defaultValue: "F"
            },
            temperatureLow: {
              name: "Temperature Low",
              key: "temperatureLow",
              type: "string"
            },
            temperatureHigh: {
              name: "Temperature High",
              key: "temperatureHigh",
              type: "string"
            },
            lowWindSpeed: {
              name: "Low Wind Speed",
              key: "lowWindSpeed",
              type: "model",
              modelClass: ye
            },
            highWindSpeed: {
              name: "High Wind Speed",
              key: "highWindSpeed",
              type: "model",
              modelClass: ye
            },
            applicators: {
              name: "Applicator",
              key: "applicators",
              type: "modelCollection",
              modelClass: Oi
            },
            fieldCompletions: {
              name: "Field Completion",
              key: "fieldCompletions",
              type: "modelCollection",
              modelClass: hn
            },
            gallonsAppliedOverride: {
              name: "Gallons Applied Override",
              key: "gallonsAppliedOverride",
              type: "string"
            }
          });
        }
      }, {
        key: "from",
        value: function (t) {
          return new this(t);
        }
      }, {
        key: "parseTime",
        value: function (t) {
          return En()(t, ["h:mm a", "H:mm", "k:mm"]).format("HH:mm");
        }
      }, {
        key: "commonGallonsPerAcre",
        value: function (t) {
          var e, r, n;
          if (null === (e = t.applicators) || void 0 === e || !e.length) return null;
          var o = Oi.gallonsPerAcreScalar(null === (r = t.applicators[0]) || void 0 === r ? void 0 : r.sprayRate);
          return 1 === (null === (n = t.applicators) || void 0 === n ? void 0 : n.length) ? o : t.applicators.reduce(function (t, e) {
            var r = Oi.gallonsPerAcreScalar(null == e ? void 0 : e.sprayRate);
            return t && t === r && r || null;
          }, o);
        }
      }, {
        key: "predictedAcresRate",
        value: function (t, e) {
          return this.commonGallonsPerAcre(t) || e || 0;
        }
      }, {
        key: "predictedAcresTreated",
        value: function (t, e) {
          if (t.gallonsAppliedOverride) {
            var r = this.predictedAcresRate(t, e);
            return r ? t.totalGallonsApplied / r : 0;
          }

          return (0, X.compose)(X.sum, (0, X.map)(function (t) {
            return Oi.predictedAcresTreated(t, e);
          }))(t.applicators || []);
        }
      }, {
        key: "percentVarianceAcresTreated",
        value: function (t, e) {
          var r = this.predictedAcresTreated(t, e);
          return (t.totalTreatedAcres - r) / r * 100;
        }
      }]), u;
    }(wt(ge, x, M, I)), w(vi, "type", "IF2::SprayRecord::Application"), $((gi = bi).prototype, "isOvernight", [V.computed], Object.getOwnPropertyDescriptor(gi.prototype, "isOvernight"), gi.prototype), $(gi.prototype, "windDirectionAndSpeed", [V.computed], Object.getOwnPropertyDescriptor(gi.prototype, "windDirectionAndSpeed"), gi.prototype), $(gi.prototype, "totalGallonsApplied", [V.computed], Object.getOwnPropertyDescriptor(gi.prototype, "totalGallonsApplied"), gi.prototype), $(gi.prototype, "totalAcresCompleted", [V.computed], Object.getOwnPropertyDescriptor(gi.prototype, "totalAcresCompleted"), gi.prototype), $(gi.prototype, "totalTreatedAcres", [V.computed], Object.getOwnPropertyDescriptor(gi.prototype, "totalTreatedAcres"), gi.prototype), $(gi.prototype, "sprayRateOutliers", [V.computed], Object.getOwnPropertyDescriptor(gi.prototype, "sprayRateOutliers"), gi.prototype), gi);

    function ki(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ri(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ki(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ki(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Ai = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return Ri(Ri({}, t), {}, {
            type: Ri(Ri({}, t.type), {}, {
              defaultValue: this.type
            }),
            sprayRecordId: {
              name: "Spray Record ID",
              key: "sprayRecordId",
              type: "number"
            },
            phi: {
              name: "PHI",
              key: "phi",
              type: "model",
              modelClass: ye
            },
            rei: {
              name: "REI",
              key: "rei",
              type: "model",
              modelClass: ye
            },
            phiOverride: {
              name: "PHI Override",
              key: "phiOverride",
              type: "model",
              modelClass: ye
            },
            phiOverrideBy: {
              name: "PHI Overridden By",
              key: "phiOverrideBy",
              type: "string"
            },
            phiOverrideReason: {
              name: "PHI Override Reason",
              key: "phiOverrideReason",
              type: "string"
            },
            reiOverride: {
              name: "REI Override",
              key: "reiOverride",
              type: "model",
              modelClass: ye
            },
            reiOverrideBy: {
              name: "REI Overridden By",
              key: "reiOverrideBy",
              type: "string"
            },
            reiOverrideReason: {
              name: "REI Override Reason",
              key: "reiOverrideReason",
              type: "string"
            },
            total: {
              name: "Total",
              key: "total",
              type: "model",
              modelClass: ye
            }
          });
        }
      }]), u;
    }(po);

    function Di(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function _i(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Di(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Di(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Ai, "type", "IF2::SprayRecord::ProductApplication");

    var xi,
        Si,
        Ci,
        Ei = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          return _i(_i({}, A(c(u), "getAttributeDefinition", this).call(this)), {}, {
            documentNumber: {
              name: "Document Number",
              key: "documentNumber",
              type: "string"
            },
            date: {
              name: "Date",
              key: "date",
              type: "string"
            },
            writtenBy: {
              name: "Written By",
              key: "writtenBy",
              type: "model",
              modelClass: Do,
              defaultValue: new Do()
            }
          });
        }
      }]), u;
    }(wt(ge, x, E));

    function Ni(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Bi(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ni(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ni(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Mi = (Ci = Si = function (e) {
      r(s, e);
      var n,
          a,
          u = (n = s, a = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (a) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function s() {
        var e;
        t(this, s);

        for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];

        return w(o(e = u.call.apply(u, [this].concat(n))), "parseTime", function (t) {
          return En()(t, ["h:mm a", "H:mm", "k:mm"]).format("HH:mm");
        }), e;
      }

      return R(s, [{
        key: "abbreviatedDateTitle",
        get: function () {
          var t = En()().format("YYYY");

          if (this.dates.length <= 0) {
            if (!this.dateTitle) return "";
            var e = En()(this.dateTitle, "M/D/YYYY");
            return e.format("YYYY") === t ? e.format("M/D") : e.format("M/D/YYYY");
          }

          var r = this.dates[0],
              n = r.format("YYYY"),
              o = n === t ? r.format("M/D") : r.format("M/D/YYYY"),
              i = this.dates[this.dates.length - 1],
              c = i.format("YYYY") === t ? i.format("M/D") : i.format("M/D/YYYY");
          return 1 === this.dates.length || o === c ? o : n === i.format("YYYY") ? "".concat(r.format("M/D"), " - ").concat(i.format("M/D")).concat(n !== t ? ", ".concat(n) : "") : "".concat(r.format("M/D/YYYY"), " - ").concat(i.format("M/D/YYYY"));
        }
      }, {
        key: "dates",
        get: function () {
          return this.sortedApplications.filter(function (t) {
            return t.date;
          }).map(function (t) {
            return En()(t.date);
          });
        }
      }, {
        key: "dateTitle",
        get: function () {
          if (this.dates.length <= 0) return this.recommendation && this.recommendation.date && En()(this.recommendation.date).format("M/D/YYYY") || "";
          var t = this.dates[0].format("M/D/YYYY"),
              e = this.dates[this.dates.length - 1].format("M/D/YYYY");
          return 1 === this.dates.length || t === e ? t : "".concat(t, " - ").concat(e);
        }
      }, {
        key: "fieldCompletionPercents",
        get: function () {
          var t = {};
          return this.fields.forEach(function (e) {
            t[e.id] = 0;
          }), this.applications.forEach(function (e) {
            e.fieldCompletions.forEach(function (e) {
              t[e.field.id] += Number(e.percentage);
            });
          }), t;
        }
      }, {
        key: "sortedApplications",
        get: function () {
          var t = this;
          return (this.applications || []).slice().sort(function (e, r) {
            var n = At(En()(e.date).format("YYYYMMDD"), En()(r.date).format("YYYYMMDD"));
            return 0 === n ? t.sortByStartTime(e, r) : n;
          });
        }
      }, {
        key: "title",
        get: function () {
          return this.name || this.abbreviatedDateTitle || (this.applicationMethod ? "".concat(this.applicationMethod, " Application") : "");
        }
      }, {
        key: "updatedAtDate",
        get: function () {
          return En()(this.updatedAt, ["M/D/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD") || "";
        }
      }, {
        key: "updatedAtTitle",
        get: function () {
          return En()(this.updatedAt, ["M/D/YYYY", "YYYY-MM-DD"]).format("M/D/YYYY") || "";
        }
      }, {
        key: "updatedTime",
        get: function () {
          return this.updatedAt && En()(this.updatedAt).format("YYYY/MM/DD HH:mm:ss");
        }
      }, {
        key: "sortByStartTime",
        value: function (t, e) {
          var r = At(this.parseTime(t.startTime), this.parseTime(e.startTime));
          return 0 === r ? At(this.parseTime(t.stopTime), this.parseTime(e.stopTime)) : r;
        }
      }, {
        key: "findApplication",
        value: function (t) {
          return this.applications.find(function (e) {
            return e.serial === t;
          });
        }
      }, {
        key: "findProductApplication",
        value: function (t) {
          return this.productApplications.find(function (e) {
            return e.serial === t;
          });
        }
      }, {
        key: "moveProductApplication",
        value: function (t, e, r) {
          var n = this.findProductApplication(t);

          if (n) {
            var o = this.productApplications.findIndex(function (t) {
              return t.position === e;
            }),
                i = this.productApplications.findIndex(function (t) {
              return t.position === r;
            });
            this.productApplications.splice(o, 1), this.productApplications.splice(i, 0, n), this.updateProductApplicationPositions();
          }
        }
      }, {
        key: "removeApplication",
        value: function (t) {
          var e = this.applications.findIndex(function (e) {
            return e.serial === t;
          });
          e < 0 || this.applications.splice(e, 1);
        }
      }, {
        key: "removeProductApplication",
        value: function (t) {
          var e = this.productApplications.findIndex(function (e) {
            return e.serial === t;
          });
          e < 0 || (this.productApplications.splice(e, 1), this.updateProductApplicationPositions());
        }
      }, {
        key: "pushApplication",
        value: function (t) {
          return Pt(this.applications, wi.from.bind(wi), t, {
            searchKey: "serial"
          });
        }
      }, {
        key: "updateProductApplicationPositions",
        value: function () {
          this.productApplications.forEach(function (t, e) {
            t.position !== e && t.update({
              position: e
            });
          });
        }
      }, {
        key: "updateProductApplication",
        value: function (t) {
          return Pt(this.productApplications, Ai.from.bind(Ai), t, {
            searchKey: "serial"
          }), this.updateProductApplicationPositions(), this.productApplications;
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(s), "getAttributeDefinition", this).call(this);
          return Bi(Bi({}, t), {}, {
            type: Bi(Bi({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Re
            },
            cropNames: {
              name: "Crop Names",
              key: "cropNames",
              type: "array"
            },
            organic: {
              name: "Organic",
              key: "organic",
              type: "boolean"
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            },
            targetGallonsPerAcre: {
              name: "Target GPA",
              key: "targetGallonsPerAcre",
              type: "number"
            },
            licensedApplicator: {
              name: "Licensed Applicator",
              key: "licensedApplicator",
              type: "model",
              modelClass: ur
            },
            fields: {
              name: "Field",
              key: "fields",
              type: "modelCollection",
              modelClass: fn
            },
            recommendation: {
              name: "Recommendation",
              key: "recommendation",
              type: "model",
              modelClass: Ei
            },
            complete: {
              name: "Complete",
              key: "complete",
              type: "boolean"
            },
            showFieldMap: {
              name: "Show Field Map",
              key: "showFieldMap",
              type: "boolean"
            },
            applications: {
              name: "Application",
              key: "applications",
              type: "modelCollection",
              modelClass: wi
            },
            maxPhi: {
              name: "Max PHI",
              key: "maxPhi",
              type: "model",
              modelClass: ye
            },
            maxRei: {
              name: "Max REI",
              key: "maxRei",
              type: "model",
              modelClass: ye
            },
            productApplications: {
              name: "Product Application",
              key: "productApplications",
              type: "modelCollection",
              modelClass: Ai
            },
            targetCoveragePercentage: {
              name: "Target Coverage (%)",
              key: "targetCoveragePercentage",
              type: "number"
            },
            date: {
              name: "Date",
              key: "date",
              type: "string"
            }
          });
        }
      }, {
        key: "isSprayRecord",
        value: function (t) {
          return t instanceof s;
        }
      }]), s;
    }(wt(ge, x, M, E, I, ft, zt, Y)), w(Si, "type", "IF2::SprayRecord"), $((xi = Ci).prototype, "abbreviatedDateTitle", [V.computed], Object.getOwnPropertyDescriptor(xi.prototype, "abbreviatedDateTitle"), xi.prototype), $(xi.prototype, "dates", [V.computed], Object.getOwnPropertyDescriptor(xi.prototype, "dates"), xi.prototype), $(xi.prototype, "dateTitle", [V.computed], Object.getOwnPropertyDescriptor(xi.prototype, "dateTitle"), xi.prototype), $(xi.prototype, "fieldCompletionPercents", [V.computed], Object.getOwnPropertyDescriptor(xi.prototype, "fieldCompletionPercents"), xi.prototype), $(xi.prototype, "sortedApplications", [V.computed], Object.getOwnPropertyDescriptor(xi.prototype, "sortedApplications"), xi.prototype), $(xi.prototype, "title", [V.computed], Object.getOwnPropertyDescriptor(xi.prototype, "title"), xi.prototype), $(xi.prototype, "updatedAtDate", [V.computed], Object.getOwnPropertyDescriptor(xi.prototype, "updatedAtDate"), xi.prototype), $(xi.prototype, "updatedAtTitle", [V.computed], Object.getOwnPropertyDescriptor(xi.prototype, "updatedAtTitle"), xi.prototype), $(xi.prototype, "updatedTime", [V.computed], Object.getOwnPropertyDescriptor(xi.prototype, "updatedTime"), xi.prototype), $(xi.prototype, "moveProductApplication", [V.action], Object.getOwnPropertyDescriptor(xi.prototype, "moveProductApplication"), xi.prototype), $(xi.prototype, "removeApplication", [V.action], Object.getOwnPropertyDescriptor(xi.prototype, "removeApplication"), xi.prototype), $(xi.prototype, "removeProductApplication", [V.action], Object.getOwnPropertyDescriptor(xi.prototype, "removeProductApplication"), xi.prototype), $(xi.prototype, "pushApplication", [V.action], Object.getOwnPropertyDescriptor(xi.prototype, "pushApplication"), xi.prototype), $(xi.prototype, "updateProductApplicationPositions", [V.action], Object.getOwnPropertyDescriptor(xi.prototype, "updateProductApplicationPositions"), xi.prototype), $(xi.prototype, "updateProductApplication", [V.action], Object.getOwnPropertyDescriptor(xi.prototype, "updateProductApplication"), xi.prototype), xi);

    function Fi(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ti(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Fi(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Fi(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Ii = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return Ti(Ti({}, t), {}, {
            type: Ti(Ti({}, t.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }]), u;
    }(lr);

    function Li(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function $i(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Li(Object(r), !0).forEach(function (e) {
          w(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Li(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    w(Ii, "type", "IF2::TeamApplicator");

    var Vi = function (e) {
      r(u, e);
      var n,
          o,
          a = (n = u, o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
            e = c(n);

        if (o) {
          var r = c(this).constructor;
          t = Reflect.construct(e, arguments, r);
        } else t = e.apply(this, arguments);

        return i(this, t);
      });

      function u() {
        return t(this, u), a.apply(this, arguments);
      }

      return R(u, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var t = A(c(u), "getAttributeDefinition", this).call(this);
          return $i($i({}, t), {}, {
            type: $i($i({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Re,
              defaultValue: new Re()
            },
            applicators: {
              name: "Applicator",
              key: "applicators",
              type: "modelCollection",
              modelClass: Ii
            }
          });
        }
      }]), u;
    }(wt(ge, x, M, E, I));

    w(Vi, "type", "IF2::Team");
  })(), p;
})());